export const LoginSVG = ({ width, height }: any) => (
  <svg
    id="SvgjsSvg1233"
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs id="SvgjsDefs1234"></defs>
    <g id="SvgjsG1235">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enable-background="new 0 0 1364 960"
        viewBox="0 0 1364 960"
        width={width}
        height={height}
      >
        <path
          fill="#e0e0ff"
          d="M601.83,211.71l-3.47-1.24c0.62-4.86,0.49-9.71-0.34-14.39l3.91-1.85c5.84-2.77,8.33-9.74,5.56-15.58
              c-2.77-5.84-9.74-8.33-15.58-5.56l-3.34,1.58c-2.92-3.78-6.41-7.14-10.4-9.94c0,0,0,0,0,0l1.45-4.07c2.17-6.09-1-12.78-7.09-14.95
              c-6.09-2.17-12.78,1-14.95,7.09l-1.24,3.47c-4.86-0.62-9.71-0.49-14.39,0.33l-1.85-3.91c-2.77-5.84-9.74-8.33-15.58-5.56
              c-5.84,2.77-8.33,9.74-5.56,15.58l1.58,3.34c-3.78,2.92-7.14,6.41-9.94,10.4c0,0,0,0,0,0l-4.07-1.45
              c-6.09-2.17-12.78,1-14.95,7.09c-2.17,6.09,1,12.78,7.09,14.95l3.47,1.24c-0.62,4.86-0.49,9.71,0.33,14.39l-3.9,1.85
              c-5.84,2.77-8.33,9.74-5.56,15.58c2.77,5.84,9.74,8.33,15.58,5.56l3.32-1.58c0,0,0,0,0,0c2.92,3.77,6.42,7.13,10.41,9.94
              l-1.45,4.06c-2.17,6.09,1,12.78,7.09,14.95c6.09,2.17,12.78-1,14.95-7.09l1.24-3.47c4.86,0.62,9.71,0.49,14.39-0.34l1.85,3.9
              c2.77,5.84,9.74,8.33,15.58,5.56c5.84-2.77,8.33-9.74,5.56-15.58l-1.58-3.33c0,0,0,0,0,0c3.77-2.92,7.13-6.42,9.94-10.41
              l4.06,1.45c6.08,2.17,12.78-1,14.95-7.09C611.09,220.57,607.91,213.88,601.83,211.71z M583.05,216.08
              c-6.46,18.11-26.4,27.56-44.51,21.1c-18.11-6.46-27.56-26.4-21.1-44.51c6.47-18.12,26.4-27.56,44.51-21.1
              C580.06,178.03,589.52,197.96,583.05,216.08z"
          className="colore0e0ff svgShape"
        ></path>
        <path
          fill="#e0e0ff"
          d="M557.65 183.63c-11.45-4.08-24.05 1.9-28.13 13.35-4.09 11.45 1.89 24.05 13.34 28.13 11.45 4.09 24.06-1.88 28.14-13.33C575.08 200.33 569.1 187.72 557.65 183.63zM459.69 232.44l-1.96-.7c.35-2.74.27-5.47-.19-8.11l2.2-1.04c3.29-1.56 4.69-5.49 3.13-8.78-1.56-3.29-5.49-4.69-8.78-3.13l-1.88.89c-1.65-2.13-3.61-4.02-5.86-5.6 0 0 0 0 0 0l.82-2.29c1.22-3.43-.56-7.2-3.99-8.42-3.43-1.22-7.2.56-8.42 3.99l-.7 1.96c-2.74-.35-5.47-.27-8.1.19l-1.04-2.2c-1.56-3.29-5.49-4.69-8.78-3.13-3.29 1.56-4.69 5.49-3.13 8.78l.89 1.88c-2.13 1.65-4.02 3.61-5.6 5.86 0 0 0 0 0 0l-2.29-.82c-3.43-1.22-7.2.56-8.42 3.99-1.22 3.43.56 7.2 3.99 8.42l1.96.7c-.35 2.74-.27 5.47.19 8.11l-2.2 1.04c-3.29 1.56-4.69 5.49-3.13 8.78 1.56 3.29 5.49 4.69 8.78 3.13l1.87-.89c0 0 0 0 0 0 1.65 2.12 3.62 4.02 5.87 5.6l-.82 2.29c-1.22 3.43.56 7.2 3.99 8.42 3.43 1.22 7.2-.56 8.42-3.99l.7-1.96c2.74.35 5.47.27 8.11-.19l1.04 2.2c1.56 3.29 5.49 4.69 8.78 3.13 3.29-1.56 4.69-5.49 3.13-8.78l-.89-1.87c0 0 0 0 0 0 2.12-1.65 4.02-3.62 5.6-5.87l2.29.82c3.43 1.22 7.2-.56 8.42-3.99C464.91 237.43 463.12 233.66 459.69 232.44zM449.11 234.9c-3.64 10.2-14.87 15.53-25.07 11.89-10.2-3.64-15.53-14.87-11.89-25.07 3.64-10.21 14.87-15.53 25.07-11.89C447.43 213.47 452.76 224.69 449.11 234.9z"
          className="colore0e0ff svgShape"
        ></path>
        <path
          fill="#e0e0ff"
          d="M434.8,216.62c-6.45-2.3-13.55,1.07-15.85,7.52c-2.3,6.45,1.06,13.55,7.51,15.85
              c6.45,2.3,13.55-1.06,15.85-7.51C444.62,226.03,441.25,218.92,434.8,216.62z"
          className="colore0e0ff svgShape"
        ></path>
        <path
          fill="#d1d1ff"
          d="M282.24 766.63c-2.59-1.47-3.96-4.62-3.76-7.59.21-2.97 1.81-5.71 3.95-7.78 2.14-2.07 4.79-3.53 7.5-4.77 4.48-2.05 9.36-3.59 14.25-3.51-5.13-5.1-10.65-9.8-16.51-14.06-.53-.39-1.07-.76-1.61-1.14-2.73 4.38-5.46 8.75-8.2 13.13-1.82 2.92-3.71 5.91-6.5 7.94-2.78 2.03-6.71 2.89-9.7 1.19-2.59-1.47-3.96-4.62-3.75-7.59.21-2.97 1.81-5.71 3.95-7.78s4.79-3.53 7.5-4.77c4.62-2.12 9.67-3.69 14.71-3.5-6.64-4.53-13.66-8.49-20.96-11.85-2.94 4.33-5.88 8.65-8.82 12.98-1.93 2.85-3.94 5.77-6.8 7.69-2.86 1.92-6.81 2.63-9.74.82-2.53-1.57-3.78-4.77-3.46-7.73.32-2.96 2.03-5.64 4.24-7.63 2.22-1.98 4.92-3.34 7.68-4.48 4.41-1.82 9.17-3.14 13.9-2.99-5.34-2.3-10.81-4.29-16.39-5.92-1.65-.48-3.32-.92-4.98-1.34-3.17 4.35-6.34 8.7-9.51 13.05-2.03 2.78-4.13 5.63-7.05 7.46-2.92 1.83-6.89 2.4-9.76.5-2.48-1.65-3.62-4.89-3.2-7.84.42-2.95 2.21-5.57 4.49-7.48 2.28-1.91 5.03-3.18 7.82-4.22 3.98-1.5 8.24-2.58 12.46-2.58-5.71-1.22-11.49-2.08-17.32-2.55-4.74 2.26-9.47 4.52-14.21 6.78-3.11 1.48-6.31 2.99-9.75 3.21-3.44.22-7.21-1.16-8.83-4.21-1.4-2.63-.86-6.02.91-8.41 1.77-2.39 4.6-3.85 7.52-4.44 2.92-.6 5.94-.4 8.89 0 5.44.75 10.96 2.3 15.27 5.66.02 0 .04 0 .06 0 6.2.5 12.35 1.42 18.42 2.75-3.74-2.36-6.84-5.79-9.44-9.42-1.73-2.42-3.32-5-4.15-7.86-.83-2.86-.86-6.04.43-8.72 1.29-2.68 4.04-4.74 7.02-4.73 3.45.01 6.43 2.7 7.84 5.85 1.41 3.14 1.57 6.68 1.7 10.12.21 5.24.41 10.48.62 15.71 7.38 1.85 14.6 4.3 21.59 7.31-3.3-3.29-5.6-7.59-7.31-11.97-1.08-2.77-1.97-5.67-2.07-8.64-.1-2.97.67-6.06 2.58-8.33 1.92-2.28 5.1-3.59 7.98-2.84 3.34.87 5.55 4.21 6.14 7.6.59 3.39-.14 6.86-.86 10.22-1.1 5.12-2.2 10.24-3.3 15.37.22.1.44.2.65.3 7.11 3.32 13.95 7.21 20.44 11.63-3.2-4.13-4.83-9.36-5.7-14.55-.49-2.93-.78-5.95-.27-8.88.51-2.93 1.88-5.8 4.22-7.64 2.34-1.84 5.72-2.48 8.39-1.16 3.09 1.52 4.59 5.25 4.47 8.69-.11 3.44-1.53 6.69-2.92 9.83-2.18 4.95-4.37 9.89-6.55 14.84.09.06.18.13.27.19l.14-.06c-.02.04-.05.07-.07.11 6.24 4.4 12.13 9.29 17.59 14.63-1.19-4.54-1.01-9.44-.29-14.12.47-3 1.16-6 2.59-8.67 1.43-2.67 3.68-5 6.53-6.03 2.85-1.03 6.32-.57 8.48 1.56 2.5 2.46 2.74 6.54 1.53 9.83-1.22 3.29-3.63 5.98-5.98 8.57-3.35 3.69-6.69 7.38-10.04 11.07-.08.13-.16.26-.24.38 5.86 6.04 11.16 12.6 15.81 19.61.49.74-.57 1.65-1.07.9-4.57-6.89-9.77-13.35-15.51-19.29-2.59 4.15-5.18 8.3-7.78 12.45-1.82 2.92-3.71 5.91-6.5 7.94C289.16 767.47 285.24 768.33 282.24 766.63zM1111.59 492.14c1.97-3.48 1.37-8.05-.91-11.32-2.28-3.27-6.02-5.33-9.9-6.24-3.89-.9-7.95-.75-11.91-.32-6.57.72-13.25 2.32-18.81 5.78 2.39-9.4 5.5-18.62 9.3-27.55.35-.81.71-1.62 1.06-2.43 6.16 3.15 12.32 6.3 18.48 9.45 4.11 2.1 8.35 4.24 12.95 4.66 4.6.42 9.71-1.3 11.98-5.32 1.97-3.48 1.37-8.05-.91-11.32-2.28-3.27-6.02-5.33-9.9-6.23-3.89-.9-7.95-.75-11.91-.32-6.78.74-13.67 2.42-19.34 6.11 4.52-9.78 9.86-19.19 15.95-28.08 6.36 2.95 12.73 5.91 19.09 8.86 4.19 1.94 8.5 3.92 13.12 4.16 4.61.24 9.65-1.67 11.77-5.78 1.83-3.55 1.07-8.09-1.34-11.28s-6.22-5.09-10.14-5.85c-3.92-.76-7.97-.45-11.92.14-6.32.94-12.72 2.7-18.05 6.14 4.55-6.33 9.48-12.39 14.78-18.11 1.57-1.69 3.18-3.35 4.81-4.98 6.64 2.82 13.29 5.64 19.93 8.47 4.25 1.8 8.63 3.64 13.25 3.73 4.62.09 9.59-1.99 11.58-6.16 1.72-3.61.8-8.12-1.71-11.22-2.51-3.1-6.38-4.89-10.32-5.51-3.94-.63-7.98-.19-11.91.53-5.61 1.02-11.26 2.71-16.12 5.63 5.73-5.34 11.79-10.31 18.16-14.87 7.01-.67 14.01-1.33 21.02-2 4.6-.44 9.33-.91 13.43-3.03 4.11-2.12 7.5-6.31 7.26-10.92-.21-3.99-3.16-7.52-6.85-9.05-3.69-1.53-7.94-1.26-11.71.07-3.77 1.33-7.11 3.63-10.23 6.13-5.74 4.61-11.02 10.2-13.67 17.03-.02.01-.04.02-.06.04-6.79 4.84-13.24 10.15-19.3 15.86 2.68-5.3 3.89-11.38 4.38-17.35.33-3.98.37-8.04-.65-11.9-1.01-3.86-3.17-7.54-6.5-9.73-3.33-2.19-7.92-2.66-11.34-.6-3.96 2.39-5.53 7.54-4.99 12.13.54 4.59 2.8 8.77 5.01 12.82 3.37 6.17 6.74 12.34 10.12 18.51-7.21 7.21-13.84 15.01-19.8 23.29 1.54-6.06 1.22-12.59.16-18.81-.67-3.94-1.64-7.88-3.58-11.37-1.94-3.49-4.94-6.51-8.72-7.81-3.77-1.3-8.33-.61-11.14 2.23-3.24 3.29-3.49 8.68-1.82 12.98 1.66 4.31 4.89 7.79 8.04 11.17 4.8 5.13 9.59 10.27 14.39 15.4-.18.26-.37.53-.55.79-5.9 8.72-11.08 17.91-15.5 27.46.84-6.95-.9-14.1-3.47-20.67-1.45-3.72-3.2-7.38-5.81-10.4-2.61-3.02-6.16-5.37-10.12-5.88-3.96-.51-8.29 1.09-10.46 4.44-2.51 3.88-1.66 9.2.84 13.08 2.5 3.88 6.36 6.64 10.13 9.3 5.92 4.19 11.84 8.37 17.77 12.56-.06.13-.12.27-.18.4l-.2.03c.05.03.1.05.15.08-4.14 9.36-7.55 19.04-10.16 28.95-1.76-6.04-5.34-11.56-9.4-16.44-2.6-3.13-5.47-6.11-8.96-8.19-3.49-2.09-7.69-3.22-11.68-2.44-3.99.78-7.66 3.7-8.68 7.64-1.18 4.55 1.35 9.42 5.02 12.37 3.67 2.95 8.29 4.38 12.79 5.74 6.39 1.94 12.79 3.88 19.18 5.82.18.09.36.19.54.28-2.58 10.99-4.16 22.19-4.68 33.46-.06 1.19 1.79 1.5 1.85.3.51-11.08 2.05-22.09 4.55-32.88 5.84 2.99 11.69 5.98 17.53 8.97 4.11 2.1 8.35 4.24 12.95 4.66C1104.21 497.88 1109.31 496.16 1111.59 492.14z"
          className="colord1d1ff svgShape"
        ></path>
        <path
          fill="#e0e0ff"
          d="M386.42,590.93l14.03,54.54c-5.96-2.63-12.23-4.68-18.33-6.84c-6-2.12-12-4.41-17.56-7.55
                      c-5.66-3.2-10.36-7.38-14.71-12.18c-4.2-4.64-8.21-9.55-13.32-13.26c-4.01-2.93-8.62-4.91-13.37-6.3
                      c-9.85-2.91-20.19-3.46-30.1-6.09c-4.99-1.31-9.83-3.18-14.13-6.07c-5.19-3.47-9.43-8.15-13.46-12.86
                      c-4.03-4.71-7.91-9.57-12.53-13.73c-3.93-3.54-8.37-6.49-13.14-8.77c-9.56-4.6-20.21-6.61-30.77-6.67
                      c-25.84-0.16-49.61,11.69-71.55,24.18c-1.29,0.74-2.59,1.48-3.89,2.24c-4.99-13.88,13.3-29.62,25.81-34.89
                      c8.56-3.6,18.35-2.52,27.35-4.77c45.62-11.36,72.11-33.51,105.1,14.6c3.69,5.39,7.13,11.25,12.59,14.83
                      C328.53,574.76,376.9,551.53,386.42,590.93z"
          className="colore0e0ff svgShape"
        ></path>
        <path
          fill="#d6d6ff"
          d="M375.14,710.73c-34.31,21.62-79.15-2.52-64.06-49.49c12.13-25.15-12.46-33.85-32.93-34.51
                      c-10.16-0.34-22.04,1.72-29.01-5.69c-13.1-17.46,6.84-47.82-36.93-48.72c-24.7-0.52-63.92,29.62-78,0.75
                      c-0.06-0.14-0.13-0.28-0.19-0.42c20.8-12.01,42.73-23.96,67.03-26.02c10.67-0.9,21.61,0.06,31.76,3.58
                      c4.96,1.71,9.71,4.06,14.04,7.05c4.81,3.33,8.87,7.5,12.7,11.91c4.04,4.67,7.87,9.55,12.36,13.82c3.95,3.76,8.4,6.83,13.45,8.93
                      c9.12,3.79,19.07,4.67,28.7,6.48c4.89,0.93,9.8,2.09,14.41,4.04c5.27,2.25,9.72,5.63,13.7,9.72c4.35,4.48,8.16,9.47,12.85,13.61
                      c4.53,4.01,9.81,7.03,15.31,9.49c9.92,4.45,20.57,7.13,30.47,11.64C400.8,646.88,413.74,686.41,375.14,710.73z"
          className="colord6d6ff svgShape"
        ></path>
        <path
          fill="#ffffff"
          d="M400.45,645.47l0.36,1.41c-9.9-4.51-20.55-7.18-30.47-11.64c-5.5-2.46-10.79-5.48-15.31-9.49
                      c-4.69-4.14-8.51-9.12-12.85-13.61c-3.98-4.1-8.43-7.47-13.7-9.72c-4.61-1.95-9.51-3.11-14.41-4.04
                      c-9.63-1.81-19.58-2.69-28.7-6.48c-5.05-2.1-9.5-5.17-13.45-8.93c-4.49-4.27-8.31-9.15-12.36-13.82
                      c-3.83-4.41-7.89-8.58-12.7-11.91c-4.32-2.99-9.08-5.33-14.04-7.05c-10.15-3.52-21.09-4.48-31.76-3.58
                      c-24.3,2.06-46.23,14.01-67.03,26.02c-0.16-0.36-0.31-0.71-0.44-1.07c1.3-0.76,2.6-1.5,3.89-2.24
                      c21.94-12.49,45.71-24.34,71.55-24.18c10.56,0.06,21.21,2.07,30.77,6.67c4.77,2.28,9.22,5.23,13.14,8.77
                      c4.61,4.16,8.5,9.02,12.53,13.73c4.03,4.72,8.26,9.39,13.46,12.86c4.3,2.88,9.14,4.75,14.13,6.07
                      c9.91,2.63,20.26,3.17,30.1,6.09c4.75,1.4,9.36,3.38,13.37,6.3c5.11,3.71,9.12,8.62,13.32,13.26c4.34,4.8,9.04,8.98,14.71,12.18
                      c5.57,3.15,11.57,5.43,17.56,7.55C388.22,640.79,394.49,642.84,400.45,645.47z"
          className="colorfff svgShape"
        ></path>
        <path
          fill="#390f73"
          d="M1076.44,282.37v439.46c0,6.67-5.39,12.07-12.05,12.07h-726.8c-6.66,0-12.07-5.4-12.07-12.07V282.37
                          c0-6.66,5.4-12.07,12.07-12.07h726.8C1071.05,270.3,1076.44,275.71,1076.44,282.37z"
          className="color390f73 svgShape"
          style={{ fill: "white" }}
        ></path>
        <path
          fill="#cac7ff"
          d="M1119.54,776.26H286.49c-5.2,0-9.41-8.1-9.41-18.09l0,0c0-9.99,4.21-18.09,9.41-18.09h833.05
                          c5.2,0,9.41,8.1,9.41,18.09l0,0C1128.95,768.16,1124.74,776.26,1119.54,776.26z"
          className="colorcac7ff svgShape"
        ></path>
        <path
          fill="#c0bdff"
          d="M1069.75,229.67H332.21c-6.06,0-10.98,4.96-10.98,11.07v488.27c0,6.11,4.92,11.07,10.98,11.07h737.54
                          c6.06,0,10.98-4.96,10.98-11.07V240.74C1080.74,234.63,1075.82,229.67,1069.75,229.67z M1073.44,718.66
                          c0,6.62-5.33,11.98-11.92,11.98H342.73c-6.59,0-11.93-5.36-11.93-11.98V282.29c0-6.62,5.34-11.98,11.93-11.98h718.79
                          c6.59,0,11.92,5.36,11.92,11.98V718.66z"
          className="colorc0bdff svgShape"
        ></path>
        <path
          fill="#ffb300"
          d="M971.96,662.49V762.9c0,4.67-2.4,8.79-6.04,11.17c-1.1,0.72-2.31,1.28-3.6,1.66
                  c-1.18,0.34-2.43,0.53-3.73,0.53H811.7c-1.81,0-3.53-0.36-5.1-1.01c-1.19-0.49-2.3-1.15-3.28-1.95c-3.03-2.45-4.97-6.2-4.97-10.4
                  V662.49c0-2.39,0.63-4.63,1.73-6.58c0.3-0.52,0.63-1.02,0.99-1.5c2.44-3.21,6.3-5.29,10.64-5.29H958.6
                  c4.34,0,8.21,2.08,10.64,5.29c0.71,0.93,1.3,1.96,1.74,3.06C971.61,659.03,971.96,660.72,971.96,662.49z"
          className="colorffb300 svgShape"
        ></path>
        <path
          fill="#f0d8ad"
          d="M885.16,705.94l-81.85,67.36c0.99,0.8,2.09,1.46,3.28,1.95l78.54-64.64l77.19,65.12
                      c1.29-0.37,2.5-0.94,3.6-1.66L885.16,705.94z"
          className="colorf0d8ad svgShape"
        ></path>
        <path
          fill="#f0d8ad"
          d="M971.96,662.49l-4,10.83l-60.16,42.81c-6.42,4.57-13.99,6.99-21.87,6.99c-7.88,0-15.45-2.42-21.87-6.99
                  l-60.16-42.81l-5.56-10.83c0-3.03,1.01-5.83,2.72-8.07c2.44-3.21,6.3-5.29,10.64-5.29H958.6c4.34,0,8.21,2.08,10.64,5.29
                  C970.95,656.66,971.96,659.46,971.96,662.49z"
          className="colorf0d8ad svgShape"
        ></path>
        <path
          fill="#ffdc52"
          d="M970.98,657.48l-7.24,14.25l-57.85,41.63c-11.95,8.6-27.98,8.6-39.94,0l-57.85-41.63l-8.04-15.82
                  c0.3-0.52,0.63-1.02,0.99-1.5c2.44-3.21,6.3-5.29,10.64-5.29H958.6c4.34,0,8.21,2.08,10.64,5.29
                  C969.95,655.35,970.54,656.38,970.98,657.48z"
          className="colorffdc52 svgShape"
        ></path>
        <path
          fill="#a389e0"
          d="M476.34 437.76c-.39 0-.71-.32-.71-.71s.32-.71.71-.71h29.28c.39 0 .71.32.71.71s-.32.71-.71.71H476.34zM359.94 532.61c-2.12 0-3.84-1.72-3.84-3.84 0-2.12 1.72-3.84 3.84-3.84 1.89 0 3.52 1.41 3.79 3.28l.04.24h83.11l26.12-26.12h70.53c.4 0 .73.33.73.73s-.33.73-.73.73H473.6l-26.12 26.12H363.6l-.07.19C362.96 531.61 361.52 532.61 359.94 532.61zM359.94 526.36c-1.33 0-2.41 1.08-2.41 2.41s1.08 2.41 2.41 2.41c1.33 0 2.41-1.08 2.41-2.41S361.27 526.36 359.94 526.36zM466.65 462.22c-2.12 0-3.84-1.72-3.84-3.84 0-2.12 1.72-3.84 3.84-3.84 1.88 0 3.47 1.35 3.78 3.21l.04.24h41.6l19.59-19.59h36.78c.4 0 .73.33.73.73s-.33.73-.73.73h-36.17l-19.59 19.59h-42.35l-.07.19C469.72 461.19 468.27 462.22 466.65 462.22zM466.65 455.97c-1.33 0-2.41 1.08-2.41 2.41 0 1.33 1.08 2.41 2.41 2.41s2.41-1.08 2.41-2.41C469.06 457.06 467.98 455.97 466.65 455.97zM456.72 496.68c-2.12 0-3.84-1.72-3.84-3.84 0-.86.28-1.68.82-2.36l.16-.2-12.68-12.68h-84.54l-.05.23c-.38 1.75-1.96 3.02-3.75 3.02-2.12 0-3.84-1.72-3.84-3.84s1.72-3.84 3.84-3.84c1.69 0 3.2 1.13 3.68 2.76l.06.21h85.21l12.99 12.99c.03.03.05.06.08.1l.13.19.21-.09c.48-.21.99-.31 1.52-.31 2.12 0 3.84 1.72 3.84 3.84S458.84 496.68 456.72 496.68zM456.72 490.43c-1.33 0-2.41 1.08-2.41 2.41s1.08 2.41 2.41 2.41 2.41-1.08 2.41-2.41S458.05 490.43 456.72 490.43zM352.83 474.59c-1.33 0-2.41 1.08-2.41 2.41s1.08 2.41 2.41 2.41c1.2 0 2.22-.9 2.38-2.09l.01-.08-.03-.08c-.04-.1-.07-.2-.07-.3 0-.08.02-.16.05-.24l.03-.08-.02-.08C354.92 475.36 353.96 474.59 352.83 474.59zM394.4 554.7c-.41 0-.73-.33-.73-.73s.33-.73.73-.73h64.95l27.6-27.6h59.37c.41 0 .73.33.73.73s-.33.73-.73.73h-58.76l-27.6 27.6H394.4zM496.03 549.44c-.41 0-.73-.33-.73-.73 0-.4.33-.73.73-.73h43.91c.4 0 .73.33.73.73 0 .41-.33.73-.73.73H496.03zM471.41 575.13c-2.12 0-3.84-1.72-3.84-3.84 0-2.12 1.72-3.84 3.84-3.84 1.73 0 3.25 1.17 3.7 2.84l.06.21.22 0c2.55.05 10.1.07 22.45.07 19.5 0 47.2-.06 66.62-.12.41 0 .74.33.74.73 0 .41-.33.74-.73.74 0 0-22.44.06-44.93.1-10.05.01-17.88.02-23.98.02-12.18 0-17.82-.03-20.12-.1l-.23-.01-.05.23C474.73 573.91 473.2 575.13 471.41 575.13zM471.41 568.88c-1.33 0-2.41 1.08-2.41 2.41 0 1.33 1.08 2.41 2.41 2.41 1.12 0 2.08-.76 2.34-1.85l.03-.13-.07-.11c-.17-.24-.18-.55-.03-.8l.06-.11-.04-.12C473.39 569.57 472.47 568.88 471.41 568.88zM358.37 444.76c-2.12 0-3.84-1.72-3.84-3.84 0-2.12 1.72-3.84 3.84-3.84 1.37 0 2.64.74 3.33 1.94l.08.14h83.07l26.12-26.12h70.53c.4 0 .73.33.73.73 0 .41-.33.73-.73.73h-69.92l-26.12 26.12h-83.25v.29C362.21 443.03 360.49 444.76 358.37 444.76zM358.37 438.51c-1.33 0-2.41 1.08-2.41 2.41 0 1.33 1.08 2.41 2.41 2.41 1.33 0 2.41-1.08 2.41-2.41C360.79 439.59 359.7 438.51 358.37 438.51zM467.5 481.89l-20.85-20.85h-68.22c-.41 0-.73-.33-.73-.73 0-.41.33-.73.73-.73h68.83l20.85 20.85h78.04c.4 0 .73.33.73.73 0 .41-.33.73-.73.73H467.5zM375.92 498.93c-.4 0-.73-.33-.73-.73s.33-.73.73-.73h61.39c.4 0 .73.33.73.73s-.33.73-.73.73H375.92z"
          className="colora389e0 svgShape"
        ></path>
        <circle
          cx="507.25"
          cy="437.05"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <circle
          cx="474.29"
          cy="437.05"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <circle
          cx="376.64"
          cy="460.26"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <circle
          cx="374.61"
          cy="498.2"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <circle
          cx="439.03"
          cy="498.2"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <circle
          cx="393.67"
          cy="553.95"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <circle
          cx="494.85"
          cy="548.71"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <rect
          width="35.19"
          height="10.87"
          x="536.99"
          y="410.57"
          fill="#8cc3ff"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="536.99"
          y="432.98"
          fill="#8cc3ff"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="536.99"
          y="455.39"
          fill="#8cc3ff"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="536.99"
          y="477.8"
          fill="#8cc3ff"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="536.99"
          y="500.22"
          fill="#8cc3ff"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="536.99"
          y="522.63"
          fill="#8cc3ff"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="536.99"
          y="545.04"
          fill="#8cc3ff"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="536.99"
          y="567.46"
          fill="#8cc3ff"
          className="color8cc3ff svgShape"
        ></rect>
        <path
          fill="#a389e0"
          d="M926.79 437.76c.39 0 .71-.32.71-.71s-.32-.71-.71-.71h-29.28c-.39 0-.71.32-.71.71s.32.71.71.71H926.79zM1039.61 530.12l-.07-.19h-83.89l-26.12-26.12h-69.92c-.4 0-.73-.33-.73-.73s.33-.73.73-.73h70.53l26.12 26.12h83.11l.04-.24c.27-1.87 1.9-3.28 3.79-3.28 2.12 0 3.84 1.72 3.84 3.84 0 2.12-1.72 3.84-3.84 3.84C1041.61 532.61 1040.17 531.61 1039.61 530.12zM1040.78 528.77c0 1.33 1.08 2.41 2.41 2.41 1.33 0 2.41-1.08 2.41-2.41s-1.08-2.41-2.41-2.41C1041.86 526.36 1040.78 527.44 1040.78 528.77zM932.87 459.66l-.07-.19h-42.35l-19.59-19.59h-36.17c-.4 0-.73-.33-.73-.73s.33-.73.73-.73h36.78L891.06 458h41.6l.04-.24c.31-1.86 1.9-3.21 3.78-3.21 2.12 0 3.84 1.72 3.84 3.84 0 2.12-1.72 3.84-3.84 3.84C934.86 462.22 933.41 461.19 932.87 459.66zM934.07 458.39c0 1.33 1.08 2.41 2.41 2.41 1.33 0 2.41-1.08 2.41-2.41 0-1.33-1.08-2.41-2.41-2.41C935.15 455.97 934.07 457.06 934.07 458.39zM942.57 492.84c0-2.12 1.72-3.84 3.84-3.84.52 0 1.03.11 1.52.31l.21.09.13-.19c.02-.03.05-.07.08-.1l12.99-12.99h85.21l.06-.21c.48-1.62 1.99-2.76 3.68-2.76 2.12 0 3.84 1.72 3.84 3.84s-1.72 3.84-3.84 3.84c-1.79 0-3.37-1.27-3.75-3.02l-.05-.23h-84.54l-12.68 12.68.16.2c.53.68.82 1.5.82 2.36 0 2.12-1.72 3.84-3.84 3.84C944.3 496.68 942.57 494.96 942.57 492.84zM944 492.84c0 1.33 1.08 2.41 2.41 2.41 1.33 0 2.41-1.08 2.41-2.41s-1.08-2.41-2.41-2.41C945.08 490.43 944 491.51 944 492.84zM1047.95 476.46l-.02.08.03.08c.03.09.05.17.05.24 0 .1-.02.21-.07.3l-.03.08.01.08c.16 1.19 1.18 2.09 2.38 2.09 1.33 0 2.41-1.08 2.41-2.41s-1.08-2.41-2.41-2.41C1049.17 474.59 1048.21 475.36 1047.95 476.46zM1008.73 554.7c.41 0 .73-.33.73-.73s-.33-.73-.73-.73h-64.95l-27.6-27.6h-59.37c-.41 0-.73.33-.73.73s.33.73.73.73h58.76l27.6 27.6H1008.73zM907.1 549.44c.41 0 .73-.33.73-.73 0-.4-.33-.73-.73-.73h-43.91c-.4 0-.73.33-.73.73 0 .41.33.73.73.73H907.1zM927.99 572.17l-.05-.23-.23.01c-2.3.07-7.94.1-20.12.1-6.1 0-13.93-.01-23.98-.02-22.49-.03-44.93-.1-44.93-.1-.41 0-.73-.33-.73-.74 0-.4.33-.73.74-.73 19.42.06 47.12.12 66.62.12 12.35 0 19.9-.02 22.45-.07l.22 0 .06-.21c.45-1.67 1.97-2.84 3.7-2.84 2.12 0 3.84 1.72 3.84 3.84 0 2.12-1.72 3.84-3.84 3.84C929.93 575.13 928.4 573.91 927.99 572.17zM929.42 570.59l-.04.12.06.11c.15.25.14.56-.03.8l-.07.11.03.13c.26 1.09 1.22 1.85 2.34 1.85 1.33 0 2.41-1.08 2.41-2.41 0-1.33-1.08-2.41-2.41-2.41C930.66 568.88 929.74 569.57 929.42 570.59zM1040.92 440.92v-.29h-83.25l-26.12-26.12h-69.92c-.4 0-.73-.33-.73-.73 0-.41.33-.73.73-.73h70.53l26.12 26.12h83.07l.08-.14c.69-1.2 1.96-1.94 3.33-1.94 2.12 0 3.84 1.72 3.84 3.84 0 2.12-1.72 3.84-3.84 3.84C1042.64 444.76 1040.92 443.03 1040.92 440.92zM1042.35 440.92c0 1.33 1.08 2.41 2.41 2.41s2.41-1.08 2.41-2.41c0-1.33-1.08-2.41-2.41-2.41S1042.35 439.59 1042.35 440.92zM935.63 481.89l20.85-20.85h68.22c.41 0 .73-.33.73-.73 0-.41-.33-.73-.73-.73h-68.83l-20.85 20.85h-78.04c-.4 0-.73.33-.73.73 0 .41.33.73.73.73H935.63zM1027.21 498.93c.4 0 .73-.33.73-.73s-.33-.73-.73-.73h-61.39c-.4 0-.73.33-.73.73s.33.73.73.73H1027.21z"
          className="colora389e0 svgShape"
        ></path>
        <circle
          cx="895.88"
          cy="437.05"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <circle
          cx="928.84"
          cy="437.05"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <circle
          cx="1026.5"
          cy="460.26"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <circle
          cx="1028.52"
          cy="498.2"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <circle
          cx="964.1"
          cy="498.2"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <circle
          cx="1009.47"
          cy="553.95"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <circle
          cx="908.28"
          cy="548.71"
          r="3.09"
          fill="#a389e0"
          className="colora389e0 svgShape"
        ></circle>
        <rect
          width="35.19"
          height="10.87"
          x="830.95"
          y="410.57"
          fill="#8cc3ff"
          transform="rotate(-180 848.547 416.002)"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="830.95"
          y="432.98"
          fill="#8cc3ff"
          transform="rotate(-180 848.547 438.414)"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="830.95"
          y="455.39"
          fill="#8cc3ff"
          transform="rotate(-180 848.547 460.827)"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="830.95"
          y="477.8"
          fill="#8cc3ff"
          transform="rotate(-180 848.547 483.24)"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="830.95"
          y="500.22"
          fill="#8cc3ff"
          transform="rotate(-180 848.547 505.653)"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="830.95"
          y="522.63"
          fill="#8cc3ff"
          transform="rotate(-180 848.547 528.065)"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="830.95"
          y="545.04"
          fill="#8cc3ff"
          transform="rotate(-180 848.547 550.478)"
          className="color8cc3ff svgShape"
        ></rect>
        <rect
          width="35.19"
          height="10.87"
          x="830.95"
          y="567.46"
          fill="#8cc3ff"
          transform="rotate(-180 848.547 572.891)"
          className="color8cc3ff svgShape"
        ></rect>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ffffff"
            d="M597.87 426.02h57.28v19.09h-36.28v35.32h28.83v19.09h-28.83v41.05h36.28v19.09h-57.28V426.02zM667.18 426.02h31.12c10.82 0 18.71 2.52 23.68 7.54 4.96 5.03 7.45 12.76 7.45 23.2v8.21c0 13.87-4.58 22.66-13.75 26.35v.38c5.09 1.53 8.69 4.65 10.79 9.36 2.1 4.71 3.15 11.01 3.15 18.9v23.48c0 3.82.13 6.91.38 9.26.25 2.36.89 4.68 1.91 6.97h-21.38c-.76-2.16-1.27-4.2-1.53-6.11-.26-1.91-.38-5.35-.38-10.31v-24.44c0-6.11-.99-10.37-2.96-12.79-1.97-2.42-5.38-3.63-10.21-3.63h-7.26v57.28h-21V426.02zM695.82 483.29c4.2 0 7.35-1.08 9.45-3.25 2.1-2.16 3.15-5.79 3.15-10.88v-10.31c0-4.84-.86-8.33-2.58-10.5-1.72-2.16-4.42-3.25-8.11-3.25h-9.55v38.19H695.82zM744.12 426.02h30.93c10.44 0 18.26 2.8 23.48 8.4 5.22 5.6 7.83 13.81 7.83 24.63v13.17c0 10.82-2.61 19.03-7.83 24.63-5.22 5.6-13.05 8.4-23.48 8.4h-9.93v54.41h-21V426.02zM775.05 486.16c3.44 0 6.01-.95 7.73-2.86 1.72-1.91 2.58-5.16 2.58-9.74v-15.85c0-4.58-.86-7.83-2.58-9.74-1.72-1.91-4.3-2.86-7.73-2.86h-9.93v41.05H775.05z"
            className="colorfff svgShape"
            style={{
              fill: "red",
            }}
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ffb300"
            d="M717.09,727.51v39.88c-1.84,2.89-6.42,5.45-12.84,7.41c-7.96,2.44-18.75,3.93-30.62,3.93
                  c-14.97,0-28.22-2.38-36.25-6.02c-3.47-1.57-5.97-3.37-7.21-5.32v-39.88H717.09z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#e6cabc"
            d="M717.09,737.67v3.12c-6.89,5.72-23.53,9.66-43.46,9.66c-19.93,0-36.57-3.94-43.46-9.66v-3.12
                  c4.11,6.46,22.03,11.34,43.46,11.34C695.06,749.02,712.98,744.14,717.09,737.67z"
            className="colore6cabc svgShape"
          ></path>
          <path
            fill="#e6cabc"
            d="M717.09,747.58v3.12c-6.89,5.72-23.53,9.66-43.46,9.66c-19.93,0-36.57-3.94-43.46-9.66v-3.12
                  c4.11,6.46,22.03,11.34,43.46,11.34C695.06,758.92,712.98,754.04,717.09,747.58z"
            className="colore6cabc svgShape"
          ></path>
          <path
            fill="#e6cabc"
            d="M717.09,757.48v3.12c-6.89,5.72-23.53,9.66-43.46,9.66c-19.93,0-36.57-3.94-43.46-9.66v-3.12
                  c4.11,6.46,22.03,11.34,43.46,11.34C695.06,768.82,712.98,763.94,717.09,757.48z"
            className="colore6cabc svgShape"
          ></path>
          <path
            fill="#999999"
            d="M637.38,727.51v45.2c-3.47-1.57-5.97-3.37-7.21-5.32v-39.88H637.38z"
            className="color999 svgShape"
          ></path>
          <path
            fill="#e2cdbe"
            d="M717.09,727.51v39.88c-1.84,2.89-6.42,5.45-12.84,7.41v-47.29H717.09z"
            className="colore2cdbe svgShape"
          ></path>
          <ellipse
            cx="673.63"
            cy="727.32"
            fill="#ffb300"
            rx="43.42"
            ry="13.87"
            className="colorffb300 svgShape"
          ></ellipse>
          <path
            fill="#ffb300"
            d="M673.62,715.26c-20.65,0-37.4,5.4-37.4,12.05c0,6.65,16.75,12.05,37.4,12.05c20.65,0,37.4-5.4,37.4-12.05
                  C711.03,720.66,694.28,715.26,673.62,715.26z M673.62,738.53c-19.22,0-34.8-5.02-34.8-11.21c0-6.19,15.58-11.21,34.8-11.21
                  s34.8,5.02,34.8,11.21C708.42,733.51,692.84,738.53,673.62,738.53z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#ffb300"
            d="M705.05,717.66c-4.27-1.44-9.49-2.59-15.34-3.35c-4.97-0.64-10.4-0.99-16.09-0.99c-0.9,0-1.8,0.01-2.71,0.03
                  c-20.07,0.39-36.45,5.19-40,11.43c-0.47,0.82-0.71,1.66-0.71,2.53c0,1.24,0.5,2.45,1.45,3.59c1.62,1.98,4.55,3.78,8.48,5.31
                  c7.95,3.11,20,5.09,33.48,5.09h0.13c22.13-0.02,40.35-5.37,42.95-12.28c0.22-0.56,0.33-1.13,0.33-1.71
                  C717.04,723.58,712.48,720.17,705.05,717.66z M709,731.23c-4.22,3.96-14.65,6.99-27.54,7.87c-2.52,0.18-5.15,0.27-7.84,0.27
                  c-11.69,0-22.13-1.73-28.99-4.44c-3.94-1.55-6.69-3.43-7.83-5.49c-0.39-0.69-0.58-1.4-0.58-2.12c0-1.79,1.21-3.48,3.36-5.01
                  l0.01,0c4.36-3.07,12.58-5.44,22.67-6.47c3.59-0.37,7.4-0.57,11.37-0.57c3.8,0,7.48,0.18,10.94,0.52
                  c6.16,0.61,11.63,1.71,15.98,3.17c6.49,2.16,10.48,5.12,10.48,8.36C711.03,728.68,710.32,730,709,731.23z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#e6cabc"
            d="M673.62,715.26c-20.65,0-37.4,5.4-37.4,12.05c0,6.65,16.75,12.05,37.4,12.05c20.65,0,37.4-5.4,37.4-12.05
                  C711.03,720.66,694.28,715.26,673.62,715.26z M673.62,738.53c-19.22,0-34.8-5.02-34.8-11.21c0-6.19,15.58-11.21,34.8-11.21
                  s34.8,5.02,34.8,11.21C708.42,733.51,692.84,738.53,673.62,738.53z"
            className="colore6cabc svgShape"
          ></path>
          <path
            fill="#ffb300"
            d="M708.42,727.31c0,6.19-15.58,11.21-34.8,11.21s-34.8-5.02-34.8-11.21c0-6.19,15.58-11.21,34.8-11.21
                  S708.42,721.12,708.42,727.31z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#e6cabc"
            d="M687.73,731.65c0-2.08-3.74-3.24-11.08-4.17v-4.92c3.66,0.04,6.36,0.43,7.73,0.67l1.58-1.51
                  c-1.9-0.35-5.02-0.67-9.31-0.7v-2h-4.68v2.14c-6.24,0.45-10.16,1.89-10.16,3.74c0,1.87,3.84,3.04,10.16,3.86v5.46
                  c-3.72-0.04-7.21-0.45-9.64-0.93l-1.45,1.55c2.33,0.5,6.87,0.9,11.08,0.91v1.99h4.68v-2.12
                  C684.1,735.17,687.73,733.52,687.73,731.65z M667.59,724.7c0-0.72,1.27-1.55,4.37-1.93v4.03
                  C668.97,726.26,667.59,725.65,667.59,724.7z M676.64,734.05v-4.64c3.7,0.62,5.23,1.32,5.23,2.39
                  C681.87,732.87,679.99,733.69,676.64,734.05z"
            className="colore6cabc svgShape"
          ></path>
          <path
            fill="#ffeb97"
            d="M687.05,730.77c0-2.08-3.74-3.24-11.08-4.17v-4.92c3.66,0.04,6.36,0.43,7.73,0.67l1.58-1.51
                  c-1.9-0.35-5.02-0.67-9.31-0.7v-2h-4.68v2.14c-6.24,0.45-10.16,1.89-10.16,3.74c0,1.87,3.84,3.04,10.16,3.86v5.46
                  c-3.72-0.04-7.21-0.45-9.64-0.93l-1.45,1.55c2.33,0.5,6.87,0.9,11.08,0.91v1.99h4.68v-2.12
                  C683.42,734.29,687.05,732.64,687.05,730.77z M666.91,723.82c0-0.72,1.27-1.55,4.37-1.93v4.03
                  C668.29,725.38,666.91,724.77,666.91,723.82z M675.96,733.17v-4.64c3.7,0.62,5.23,1.32,5.23,2.39
                  C681.19,731.99,679.31,732.81,675.96,733.17z"
            className="colorffeb97 svgShape"
          ></path>
          <path
            fill="#1a1a1a"
            d="M689.71 714.32l-5.14 1.47-47.76 13.65-5.14 1.47c-.95-1.14-1.45-2.35-1.45-3.59 0-.87.24-1.71.71-2.53l8.66-2.48.01 0 22.67-6.47 8.66-2.47c.9-.02 1.8-.03 2.71-.03C679.31 713.33 684.74 713.68 689.71 714.32zM717.04 727.32c0 .58-.11 1.15-.33 1.71l-7.7 2.2-27.54 7.87-7.71 2.2h-.13c-13.48 0-25.53-1.98-33.48-5.09l4.49-1.28 55.92-15.98 4.5-1.29C712.48 720.17 717.04 723.58 717.04 727.32z"
            className="color1a1a1a svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ffb300"
            d="M717.08,696.74v39.88c-1.84,2.89-6.42,5.45-12.84,7.41c-7.96,2.44-18.75,3.93-30.62,3.93
                  c-14.97,0-28.22-2.38-36.25-6.02c-3.47-1.57-5.97-3.37-7.21-5.32v-39.88H717.08z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#e6cabc"
            d="M717.08,706.91v3.12c-6.89,5.72-23.53,9.66-43.46,9.66c-19.93,0-36.57-3.94-43.46-9.66v-3.12
                  c4.11,6.46,22.03,11.34,43.46,11.34C695.05,718.25,712.97,713.37,717.08,706.91z"
            className="colore6cabc svgShape"
          ></path>
          <path
            fill="#e6cabc"
            d="M717.08,716.82v3.12c-6.89,5.72-23.53,9.66-43.46,9.66c-19.93,0-36.57-3.94-43.46-9.66v-3.12
                  c4.11,6.46,22.03,11.34,43.46,11.34C695.05,728.16,712.97,723.28,717.08,716.82z"
            className="colore6cabc svgShape"
          ></path>
          <path
            fill="#e6cabc"
            d="M717.08,726.72v3.12c-6.89,5.72-23.53,9.66-43.46,9.66c-19.93,0-36.57-3.94-43.46-9.66v-3.12
                  c4.11,6.46,22.03,11.34,43.46,11.34C695.05,738.06,712.97,733.18,717.08,726.72z"
            className="colore6cabc svgShape"
          ></path>
          <path
            fill="#999999"
            d="M637.37,696.74v45.2c-3.47-1.57-5.97-3.37-7.21-5.32v-39.88H637.37z"
            className="color999 svgShape"
          ></path>
          <path
            fill="#e2cdbe"
            d="M717.08,696.74v39.88c-1.84,2.89-6.42,5.45-12.84,7.41v-47.29H717.08z"
            className="colore2cdbe svgShape"
          ></path>
          <ellipse
            cx="673.62"
            cy="696.55"
            fill="#ffb300"
            rx="43.42"
            ry="13.87"
            className="colorffb300 svgShape"
          ></ellipse>
          <path
            fill="#ffb300"
            d="M673.62,684.5c-20.65,0-37.4,5.4-37.4,12.05c0,6.65,16.75,12.05,37.4,12.05c20.65,0,37.4-5.4,37.4-12.05
                  C711.02,689.9,694.27,684.5,673.62,684.5z M673.62,707.76c-19.22,0-34.8-5.02-34.8-11.21c0-6.19,15.58-11.21,34.8-11.21
                  s34.8,5.02,34.8,11.21C708.41,702.74,692.83,707.76,673.62,707.76z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#ffb300"
            d="M705.04,686.9c-4.27-1.44-9.49-2.59-15.34-3.35c-4.97-0.64-10.4-0.99-16.09-0.99c-0.9,0-1.81,0.01-2.71,0.03
                  c-20.07,0.39-36.45,5.19-40,11.43c-0.47,0.82-0.71,1.66-0.71,2.53c0,1.24,0.5,2.45,1.45,3.59c1.62,1.98,4.55,3.78,8.48,5.31
                  c7.95,3.11,20,5.09,33.48,5.09h0.13c22.13-0.02,40.35-5.37,42.95-12.28c0.22-0.56,0.33-1.13,0.33-1.71
                  C717.03,692.81,712.47,689.41,705.04,686.9z M709,700.46c-4.22,3.96-14.65,6.99-27.54,7.87c-2.52,0.18-5.15,0.27-7.84,0.27
                  c-11.69,0-22.13-1.73-28.99-4.44c-3.94-1.55-6.69-3.43-7.83-5.49c-0.39-0.69-0.58-1.4-0.58-2.12c0-1.79,1.21-3.48,3.36-5.01
                  l0.01,0c4.36-3.07,12.58-5.44,22.67-6.47c3.59-0.37,7.4-0.57,11.37-0.57c3.8,0,7.48,0.18,10.94,0.52
                  c6.16,0.61,11.63,1.71,15.98,3.17c6.49,2.16,10.48,5.12,10.48,8.36C711.02,697.92,710.31,699.24,709,700.46z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#e6cabc"
            d="M673.62,684.5c-20.65,0-37.4,5.4-37.4,12.05c0,6.65,16.75,12.05,37.4,12.05c20.65,0,37.4-5.4,37.4-12.05
                  C711.02,689.9,694.27,684.5,673.62,684.5z M673.62,707.76c-19.22,0-34.8-5.02-34.8-11.21c0-6.19,15.58-11.21,34.8-11.21
                  s34.8,5.02,34.8,11.21C708.41,702.74,692.83,707.76,673.62,707.76z"
            className="colore6cabc svgShape"
          ></path>
          <path
            fill="#ffb300"
            d="M708.41,696.55c0,6.19-15.58,11.21-34.8,11.21s-34.8-5.02-34.8-11.21c0-6.19,15.58-11.21,34.8-11.21
                  S708.41,690.36,708.41,696.55z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#e6cabc"
            d="M687.72,700.89c0-2.08-3.74-3.24-11.08-4.17v-4.92c3.66,0.04,6.36,0.43,7.73,0.67l1.58-1.51
                  c-1.9-0.35-5.02-0.67-9.31-0.7v-2h-4.68v2.14c-6.24,0.45-10.16,1.89-10.16,3.74c0,1.87,3.84,3.04,10.16,3.86v5.46
                  c-3.72-0.04-7.21-0.45-9.64-0.93l-1.45,1.55c2.33,0.5,6.87,0.9,11.08,0.91V707h4.68v-2.12
                  C684.09,704.41,687.72,702.76,687.72,700.89z M667.59,693.94c0-0.72,1.27-1.55,4.37-1.93v4.03
                  C668.96,695.49,667.59,694.89,667.59,693.94z M676.64,703.28v-4.64c3.7,0.62,5.23,1.32,5.23,2.39
                  C681.86,702.11,679.98,702.93,676.64,703.28z"
            className="colore6cabc svgShape"
          ></path>
          <path
            fill="#ffeb97"
            d="M687.04,700.01c0-2.08-3.74-3.24-11.08-4.17v-4.92c3.66,0.04,6.36,0.43,7.73,0.67l1.58-1.51
                  c-1.9-0.35-5.02-0.67-9.31-0.7v-2h-4.68v2.14c-6.24,0.45-10.16,1.89-10.16,3.74c0,1.87,3.84,3.04,10.16,3.86v5.46
                  c-3.72-0.04-7.21-0.45-9.64-0.93l-1.45,1.55c2.33,0.5,6.87,0.9,11.08,0.91v1.99h4.68v-2.12
                  C683.41,703.53,687.04,701.88,687.04,700.01z M666.91,693.06c0-0.72,1.27-1.55,4.37-1.93v4.03
                  C668.28,694.61,666.91,694.01,666.91,693.06z M675.96,702.4v-4.64c3.7,0.62,5.23,1.32,5.23,2.39
                  C681.18,701.22,679.3,702.05,675.96,702.4z"
            className="colorffeb97 svgShape"
          ></path>
          <path
            fill="#1a1a1a"
            d="M689.7 683.55l-5.14 1.47-47.76 13.65-5.14 1.47c-.95-1.14-1.45-2.35-1.45-3.59 0-.87.24-1.71.71-2.53l8.66-2.48.01 0 22.67-6.47 8.66-2.47c.9-.02 1.8-.03 2.71-.03C679.31 682.56 684.73 682.91 689.7 683.55zM717.03 696.55c0 .58-.11 1.15-.33 1.71l-7.7 2.2-27.54 7.87-7.71 2.2h-.13c-13.48 0-25.53-1.98-33.48-5.09l4.49-1.28 55.92-15.98 4.5-1.29C712.47 689.41 717.03 692.81 717.03 696.55z"
            className="color1a1a1a svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ffb300"
            d="M733.49,710.33c-16.9,1.33-29.11,18.3-24.55,37.68c4.57,19.38,23.07,29.11,38.79,22.76
              c13.48-5.45,20.28-21.21,16.83-35.86C761.1,720.25,747.98,709.18,733.49,710.33z M747.23,768.66
              c-14.58,5.71-31.56-3.42-35.76-21.25c-4.2-17.83,6.91-33.58,22.51-34.98c13.52-1.21,25.86,9.07,29.1,22.82
              C766.32,749,759.87,763.71,747.23,768.66z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#ffb300"
            d="M756.02,714.04c-3.38-3-7.32-5.37-11.59-6.85c-3.78-1.31-7.85-1.94-12.09-1.71
              c-0.69,0.04-1.38,0.09-2.06,0.19c-16.57,2.01-29.15,17.02-28.45,36.07c0.09,2.55,0.43,5.12,1.04,7.71
              c0.88,3.72,2.24,7.18,4.01,10.32c3,5.37,7.1,9.71,11.85,12.85c9.15,6.05,20.23,7.3,30.14,3.02l0.09-0.04
              c14.26-6.22,21.73-22.3,19.6-37.72c-0.17-1.24-0.4-2.49-0.69-3.74C765.97,726.05,761.68,719.07,756.02,714.04z M765.46,743.85
              c-0.31,9.6-4.83,18.77-12.53,24.1c-1.59,1.11-3.33,2.06-5.2,2.82c-8.58,3.47-18.06,2.12-25.77-3.24c-4.63-3.22-8.5-7.83-11-13.49
              c-0.85-1.91-1.53-3.92-2.03-6.03c-1.23-5.21-1.19-10.37-0.13-15.14l0.01-0.01c2.12-9.34,8.08-16.78,16.05-20.34
              c2.68-1.2,5.58-1.95,8.62-2.19c2.83-0.22,5.61,0.01,8.24,0.63c4.53,1.07,8.71,3.29,12.23,6.32c5.06,4.34,8.91,10.48,10.59,17.63
              C765.27,737.92,765.55,740.93,765.46,743.85z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#e6cabc"
            d="M733.49,710.33c-16.9,1.33-29.11,18.3-24.55,37.68c4.57,19.38,23.07,29.11,38.79,22.76
              c13.48-5.45,20.28-21.21,16.83-35.86C761.1,720.25,747.98,709.18,733.49,710.33z M747.23,768.66
              c-14.58,5.71-31.56-3.42-35.76-21.25c-4.2-17.83,6.91-33.58,22.51-34.98c13.52-1.21,25.86,9.07,29.1,22.82
              C766.32,749,759.87,763.71,747.23,768.66z"
            className="colore6cabc svgShape"
          ></path>
          <path
            fill="#ffb300"
            d="M763.08,735.25c3.24,13.75-3.21,28.46-15.84,33.41c-14.58,5.71-31.56-3.42-35.76-21.25
              c-4.2-17.83,6.91-33.58,22.51-34.98C747.5,711.22,759.84,721.5,763.08,735.25z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#e6cabc"
            d="M752.82,748.58c-1.17-4.95-4.31-7.1-9.93-8.12l-2.88-12.21c2.64-0.34,4.75,0.27,5.82,0.69l0.22-3.8
              c-1.49-0.63-3.86-1.09-6.93-0.68l-1.17-4.95l-3.48,0.44l1.27,5.39c-4.53,1.89-6.77,6.2-5.63,11.03c1.15,4.89,4.89,7.24,10.15,8.14
              l3.25,13.79c-2.75,0.79-5.63,0.61-7.8-0.04l-0.17,4.44c2.12,0.69,5.79,0.51,8.88-0.54l1.19,5.03l3.29-1.25l-1.24-5.26
              C752.43,757.78,753.86,753.03,752.82,748.58z M734.53,734.9c-0.44-1.85,0.04-4.14,2.16-5.52l2.4,10.17
              C736.52,738.67,735.1,737.34,734.53,734.9z M746.72,756.73l-2.71-11.5c2.94,0.83,4.39,2.26,5.01,4.86
              C749.63,752.69,748.83,755.1,746.72,756.73z"
            className="colore6cabc svgShape"
          ></path>
          <path
            fill="#ffeb97"
            d="M751.88,746.61c-1.17-4.96-4.33-7.14-9.99-8.22L739,726.15c2.66-0.31,4.78,0.32,5.86,0.75l0.23-3.8
              c-1.5-0.64-3.88-1.13-6.98-0.75l-1.17-4.96l-3.51,0.41l1.27,5.4c-4.57,1.85-6.83,6.13-5.69,10.97c1.16,4.91,4.92,7.29,10.22,8.25
              l3.26,13.82c-2.77,0.77-5.67,0.56-7.86-0.12l-0.18,4.44c2.13,0.71,5.84,0.57,8.95-0.45l1.19,5.04l3.31-1.22l-1.24-5.28
              C751.48,755.81,752.93,751.07,751.88,746.61z M733.47,732.74c-0.44-1.86,0.04-4.14,2.18-5.5l2.4,10.19
              C735.47,736.53,734.05,735.19,733.47,732.74z M745.73,754.7l-2.72-11.53c2.96,0.86,4.42,2.3,5.04,4.92
              C748.66,750.68,747.85,753.09,745.73,754.7z"
            className="colorffeb97 svgShape"
          ></path>
          <path
            fill="#1a1a1a"
            d="M744.43 707.19l-2.7 3.78-30.76 43.08-4.08 5.71c-1.77-3.14-3.13-6.6-4.01-10.32-.61-2.59-.95-5.16-1.04-7.71l6.98-8.86.01-.01 16.05-20.34 5.41-6.86c.68-.09 1.37-.15 2.06-.19C736.58 705.24 740.65 705.87 744.43 707.19zM767.87 734.13c.29 1.25.52 2.5.69 3.74l-3.11 5.98-12.53 24.1-3.97 7.63-.09.04c-9.91 4.29-20.99 3.03-30.14-3.02l3.23-5.07 32-50.25 2.06-3.24C761.68 719.07 765.97 726.05 767.87 734.13z"
            className="color1a1a1a svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#6633b0"
            d="M1227.75,779.76H178.28c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5h1049.48c1.93,0,3.5,1.57,3.5,3.5
              S1229.69,779.76,1227.75,779.76z"
            className="color6633b0 svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ff69b4"
            d="M1148.05,270.49c-23.36,46.59-79.31,66.06-126.34,44.62c-1.11-0.5-2.21-1.02-3.31-1.58
              c-47.69-23.92-66.96-81.96-43.05-129.65c23.91-47.69,81.96-66.96,129.65-43.05c1.1,0.55,2.19,1.12,3.26,1.72
              C1153.55,167.43,1171.41,223.9,1148.05,270.49z"
            className="colorff69b4 svgShape"
            style={{ fill: "#d2112b" }}
          ></path>
          <circle
            cx="1061.7"
            cy="227.19"
            r="83.66"
            fill="#ffffff"
            className="colorfff svgShape"
          ></circle>
          <path
            fill="#ffffff"
            d="M1011.06,201.79c14-27.92,48.11-39.25,76.03-25.24c27.92,14,39.25,48.11,25.24,76.03
              c-14,27.92-48.11,39.25-76.03,25.24C1008.38,263.82,997.06,229.72,1011.06,201.79z"
            className="colorfff svgShape"
          ></path>
          <circle
            cx="1061.7"
            cy="227.19"
            r="72.58"
            fill="#552996"
            transform="rotate(-84.341 1061.738 227.189)"
            className="color552996 svgShape"
          ></circle>
          <circle
            cx="1061.7"
            cy="227.19"
            r="60.72"
            fill="#ffffff"
            transform="rotate(-84.341 1061.738 227.189)"
            className="colorfff svgShape"
          ></circle>
          <circle
            cx="1061.7"
            cy="227.19"
            r="54.55"
            fill="#ffb300"
            transform="rotate(-84.341 1061.738 227.189)"
            className="colorffb300 svgShape"
          ></circle>
          <circle
            cx="1061.7"
            cy="227.19"
            r="31.22"
            fill="#ffffff"
            transform="rotate(-71.831 1061.737 227.203)"
            className="colorfff svgShape"
          ></circle>
          <path
            fill="#ff69b4"
            d="M1046.45,219.54c4.22-8.41,14.49-11.82,22.9-7.6c8.41,4.22,11.82,14.49,7.6,22.9
              c-4.22,8.41-14.49,11.82-22.9,7.6C1045.65,238.22,1042.23,227.95,1046.45,219.54z"
            className="colorff69b4 svgShape"
          ></path>
          <rect
            width="114.53"
            height="1.92"
            x="1063.35"
            y="192.39"
            fill="#603ba6"
            transform="rotate(151.558 1120.602 193.33)"
            className="color603ba6 svgShape"
          ></rect>
          <polygon
            fill="#603ba6"
            points="1072.28 214.25 1076.71 222.43 1058.27 227.13"
            className="color603ba6 svgShape"
          ></polygon>
          <polygon
            fill="#603ba6"
            points="1077.64 211.34 1082.07 219.52 1063.63 224.22"
            className="color603ba6 svgShape"
          ></polygon>
          <polygon
            fill="#ff69b4"
            points="1159.86 179.93 1158.84 178.04 1150.37 177.23 1154.32 169.7 1153.29 167.8 1147.55 178.76"
            className="colorff69b4 svgShape"
          ></polygon>
          <polygon
            fill="#ff69b4"
            points="1162.09 178.73 1161.08 176.83 1152.62 175.98 1156.59 168.47 1155.57 166.57 1149.79 177.5"
            className="colorff69b4 svgShape"
          ></polygon>
          <polygon
            fill="#ff69b4"
            points="1169.17 174.89 1168.15 173 1159.68 172.19 1163.63 164.66 1162.6 162.76 1156.86 173.72"
            className="colorff69b4 svgShape"
          ></polygon>
          <polygon
            fill="#ff69b4"
            points="1171.4 173.68 1170.39 171.78 1161.92 170.94 1165.9 163.43 1164.88 161.53 1159.1 172.46"
            className="colorff69b4 svgShape"
          ></polygon>
          <path
            fill="#603ba6"
            d="M1168.66,165.86l2.54-1.38c0.62-0.34,1.4-0.11,1.74,0.52l0,0c0.34,0.62,0.11,1.4-0.52,1.74l-2.54,1.38
                  c-0.62,0.34-1.4,0.11-1.74-0.52l0,0C1167.81,166.98,1168.04,166.2,1168.66,165.86z"
            className="color603ba6 svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#78b8ff"
            d="M1100.84,578.9h-75.11c-5.6,0-10.15,4.54-10.15,10.15v75.11c0,5.6,4.54,10.15,10.15,10.15h75.11
              c5.6,0,10.15-4.54,10.15-10.15v-75.11C1110.99,583.44,1106.44,578.9,1100.84,578.9z"
            className="color78b8ff svgShape"
            style={{ fill: "#d2112b" }}
          ></path>
          <polygon
            fill="#ffffff"
            points="1044.75 640.41 1040.05 640.41 1026.45 626.81 1038.93 614.33 1043.64 614.33 1031.16 626.81"
            className="colorfff svgShape"
          ></polygon>
          <polygon
            fill="#ffffff"
            points="1100.12 626.81 1086.53 640.41 1081.82 640.41 1095.42 626.81 1082.93 614.33 1087.64 614.33"
            className="colorfff svgShape"
          ></polygon>
          <polygon
            fill="#ffffff"
            points="1073.67 614.33 1056.86 640.41 1052.9 640.41 1069.71 614.33"
            className="colorfff svgShape"
          ></polygon>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ffb300"
            d="M375.79,294.27h-89.98c-6.4,0-11.58,5.19-11.58,11.58v89.98c0,6.4,5.19,11.58,11.58,11.58h89.98
                      c6.4,0,11.58-5.19,11.58-11.58v-89.98C387.37,299.46,382.19,294.27,375.79,294.27z"
            className="colorffb300 svgShape"
          ></path>
          <circle
            cx="329.95"
            cy="338.95"
            r="22.22"
            fill="#ffffff"
            transform="rotate(-31.714 329.977 338.963)"
            className="colorfff svgShape"
          ></circle>
          <path
            fill="#ffffff"
            d="M350.32,361.35c-1.79-1.4-4.29-1.35-6.05,0.09c-3.82,3.12-8.71,5-14.05,5c-5.16,0-9.9-1.76-13.67-4.71
                  c-1.79-1.41-4.33-1.38-6.06,0.11c-4.48,3.84-7.21,9.39-7.21,16.59v0.65c0,3.73,3.02,6.75,6.75,6.75h41.52
                  c3.73,0,6.75-3.02,6.75-6.75v-0.65C358.31,370.91,355.26,365.2,350.32,361.35z"
            className="colorfff svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ffb300"
            d="M1188.47,473.76h-55.55c-3.95,0-7.15,3.2-7.15,7.15v55.55c0,3.95,3.2,7.15,7.15,7.15h55.55
                      c3.95,0,7.15-3.2,7.15-7.15v-55.55C1195.62,476.96,1192.42,473.76,1188.47,473.76z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#ffffff"
            d="M1160.7,501.83c-4.52,0-8.19,3.66-8.19,8.19c0,4.52,3.67,8.19,8.19,8.19c4.52,0,8.19-3.67,8.19-8.19
                  C1168.88,505.5,1165.22,501.83,1160.7,501.83z M1160.7,512.13c-1.17,0-2.12-0.95-2.12-2.12s0.95-2.12,2.12-2.12
                  c1.17,0,2.12,0.95,2.12,2.12S1161.86,512.13,1160.7,512.13z"
            className="colorfff svgShape"
          ></path>
          <path
            fill="#ffffff"
            d="M1183.64,506.36l-4.93-1.58c0,0,0,0,0,0c-0.39-1.34-0.92-2.62-1.58-3.81l2.34-4.65
                  c0.4-0.79,0.24-1.74-0.38-2.36l-2.38-2.38c-0.63-0.63-1.59-0.78-2.38-0.37l-4.6,2.37h0c-1.2-0.66-2.47-1.19-3.81-1.58
                  c0,0,0,0,0,0l-1.63-4.94c-0.28-0.84-1.06-1.4-1.94-1.4h-3.37c-0.89,0-1.67,0.57-1.94,1.42l-1.58,4.93c0,0,0,0,0,0
                  c-1.34,0.38-2.61,0.91-3.81,1.58c0,0,0,0,0,0l-4.65-2.34c-0.79-0.4-1.74-0.24-2.36,0.38l-2.38,2.38
                  c-0.63,0.63-0.78,1.59-0.37,2.38l2.37,4.6c-0.66,1.2-1.19,2.48-1.58,3.82l-4.94,1.63c-0.84,0.28-1.4,1.06-1.4,1.94v3.37
                  c0,0.89,0.57,1.67,1.42,1.94l4.93,1.58c0,0,0,0,0,0c0.39,1.34,0.92,2.62,1.58,3.81l-2.34,4.65c-0.4,0.79-0.24,1.74,0.38,2.36
                  l2.38,2.38c0.63,0.63,1.59,0.78,2.38,0.37l4.6-2.37c1.2,0.66,2.47,1.19,3.81,1.58h0l1.63,4.95c0.28,0.84,1.06,1.4,1.94,1.4h3.37
                  c0.89,0,1.67-0.57,1.94-1.42l1.58-4.93c0,0,0,0,0,0c1.34-0.39,2.61-0.92,3.81-1.58c0,0,0,0,0,0l4.65,2.34
                  c0.79,0.4,1.74,0.24,2.36-0.38l2.38-2.38c0.63-0.63,0.78-1.59,0.37-2.38l-2.37-4.6c0.66-1.2,1.19-2.48,1.58-3.82l4.94-1.63
                  c0.84-0.28,1.4-1.06,1.4-1.94v-3.37C1185.06,507.41,1184.48,506.63,1183.64,506.36z M1160.7,523.43
                  c-7.41,0-13.42-6.01-13.42-13.42c0-7.41,6.01-13.42,13.42-13.42c7.41,0,13.41,6.01,13.41,13.42S1168.11,523.43,1160.7,523.43z"
            className="colorfff svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#78b8ff"
            d="M729.9,156.69h-75.85c-5.39,0-9.76,4.37-9.76,9.76v75.85c0,5.39,4.37,9.76,9.76,9.76h75.85
                      c5.39,0,9.76-4.37,9.76-9.76v-75.85C739.66,161.06,735.29,156.69,729.9,156.69z"
            className="color78b8ff svgShape"
            style={{ fill: "#d2112b" }}
          ></path>
          <path
            fill="#ffffff"
            d="M728.55,204l0-0.01v-0.01c0-0.28-0.01-0.56-0.02-0.83c-0.02-0.5-0.05-1-0.09-1.49l0-0.02
              c-0.01-0.12-0.01-0.23-0.02-0.35c-0.09-1.04-0.21-1.97-0.36-2.83c-0.34-2.05-0.85-4.07-1.54-6.03c-0.2-0.58-0.42-1.15-0.63-1.68
              l-0.27-0.65c-0.31-0.72-0.66-1.46-1.02-2.18l-0.34-0.65c-1.22-2.28-2.69-4.43-4.38-6.4c-0.18-0.22-0.37-0.43-0.58-0.67
              c-0.47-0.54-0.99-1.08-1.59-1.67c-0.38-0.39-0.78-0.77-1.23-1.16c-3.55-3.2-7.65-5.64-12.06-7.23c-8.3-2.46-16.6-2.46-24.91,0
              c-4.41,1.59-8.51,4.03-12.06,7.23c-0.42,0.38-0.83,0.76-1.24,1.16c-0.51,0.5-1.03,1.04-1.58,1.66c-0.18,0.21-0.39,0.44-0.58,0.67
              c-1.68,1.97-3.15,4.12-4.37,6.39l-0.35,0.65c-0.41,0.79-0.74,1.51-1.02,2.18l-0.28,0.65c-0.23,0.56-0.44,1.11-0.64,1.68
              c-0.68,1.95-1.2,3.98-1.54,6.03c-0.16,0.94-0.27,1.89-0.35,2.84c-0.01,0.11-0.02,0.22-0.02,0.35l0,0.02
              c-0.04,0.49-0.07,0.99-0.09,1.49c-0.01,0.27-0.02,0.54-0.02,0.82v0.01l0,0.01c-0.01,0.12-0.01,0.25-0.01,0.39
              c0,0.53,0.01,1.06,0.03,1.59c0.04,0.96,0.12,1.95,0.26,3.02c0.12,0.93,0.28,1.89,0.47,2.83c0.08,0.41,0.19,0.85,0.32,1.39
              c0.18,0.72,0.39,1.48,0.66,2.33c0.39,1.19,0.84,2.36,1.34,3.49c0.07,0.17,0.16,0.35,0.23,0.51c0.35,0.77,0.74,1.53,1.18,2.33
              c0.09,0.17,0.18,0.33,0.27,0.48l0.01,0.02c0.48,0.84,0.98,1.65,1.5,2.41c0.57,0.84,1.13,1.6,1.72,2.33
              c0.84,1.04,1.73,2.04,2.67,2.97c1.02,1.02,2.09,1.97,3.18,2.83c3.11,2.46,6.56,4.39,10.27,5.73c8.31,2.44,16.62,2.44,24.92,0
              c3.71-1.34,7.16-3.27,10.27-5.73c1.09-0.86,2.16-1.81,3.18-2.83c0.93-0.93,1.83-1.93,2.67-2.98c0.59-0.73,1.15-1.49,1.72-2.33
              c0.52-0.75,1.02-1.56,1.5-2.4l0.01-0.02c0.09-0.14,0.18-0.31,0.28-0.49c0.44-0.79,0.82-1.55,1.17-2.31
              c0.04-0.09,0.08-0.18,0.12-0.27c0.04-0.08,0.07-0.16,0.11-0.25c0.5-1.12,0.95-2.29,1.33-3.48c0.27-0.85,0.49-1.61,0.67-2.33
              c0.13-0.53,0.23-0.97,0.32-1.39c0.2-0.94,0.36-1.9,0.47-2.83c0.14-1.07,0.22-2.06,0.26-3.02v-0.01c0.03-0.48,0.04-1.01,0.04-1.58
              C728.56,204.25,728.56,204.12,728.55,204z M723.95,191.99c0.8,2.03,1.4,4.13,1.78,6.25c0.18,0.96,0.31,1.95,0.41,2.94
              c0.01,0.13,0.02,0.26,0.03,0.41l0.03,0.65h-11.36l-0.03-0.6c-0.16-3.2-0.58-6.32-1.24-9.28l-0.17-0.76h10.4L723.95,191.99z
               M715.99,180.01c2.02,1.97,3.8,4.2,5.29,6.63c0.14,0.23,0.28,0.46,0.39,0.67c0.41,0.7,0.81,1.44,1.21,2.26l0.44,0.9H713.1
              l-0.13-0.46c-0.93-3.36-2.17-6.47-3.7-9.25l-0.51-0.93h7.05L715.99,180.01z M703.23,190.47l-0.08-0.53
              c-0.51-3.4-1.19-6.53-2.02-9.3l-0.24-0.81h5.36l0.18,0.29c1.75,2.77,3.18,5.98,4.24,9.54l0.24,0.81H703.23z M711.2,191.59
              l0.12,0.48c0.73,3.04,1.2,6.23,1.37,9.5l0.03,0.66h-8.57l-0.02-0.61c-0.08-3.21-0.31-6.35-0.67-9.33l-0.08-0.7H711.2z
               M703.58,215.66l0.06-0.56h8.11l-0.16,0.76c-0.74,3.43-1.81,6.63-3.18,9.52l-0.17,0.36h-6.41l0.18-0.77
              C702.69,222.1,703.22,218.97,703.58,215.66z M703.76,213.98l0.06-0.68c0.24-2.88,0.37-5.85,0.37-8.83c0-0.09,0-0.19,0-0.28
              c0-0.07,0-0.15,0-0.22l0-0.63h8.58l0.01,0.62c0,0.08,0,0.16,0,0.24c0,0.12,0,0.24,0,0.36c0,3-0.24,5.99-0.73,8.9l-0.09,0.53
              H703.76z M704.69,172.66c2.59,0.98,4.78,2.23,6.92,3.73c0.6,0.42,1.13,0.82,1.62,1.21l1.39,1.12h-6.57l-0.19-0.28
              c-1.18-1.8-2.48-3.21-3.93-4.62c-0.63-0.61-2.71-2.22-2.71-2.22S703.84,172.34,704.69,172.66z M698.98,172.55
              c2.07,1.21,4,2.94,5.74,5.15l0.8,1.02h-5.02l-0.15-0.41c-0.68-1.87-1.42-3.52-2.23-4.89l-1.21-2.06L698.98,172.55z M692.79,171.82
              l0.91,0.45c1.6,0.79,3.07,2.66,4.38,5.56l0.4,0.89h-5.69V171.82z M692.79,179.83h6.1l0.15,0.42c0.96,2.71,1.75,5.9,2.34,9.49
              l0.12,0.73h-8.71V179.83z M692.79,191.59h8.87l0.07,0.54c0.4,3.02,0.65,6.2,0.75,9.45l0.02,0.65h-9.71V191.59z M692.79,203.34
              h9.73l0,0.62l0,0.21c0,0.1,0,0.2,0,0.29c0,3-0.14,6.01-0.41,8.94l-0.05,0.57h-9.27V203.34z M692.79,215.1h9.16l-0.08,0.7
              c-0.41,3.44-1.01,6.62-1.77,9.47l-0.12,0.47h-7.18V215.1z M687.02,171.34l-1.21,2.06c-0.8,1.37-1.55,3.02-2.23,4.89l-0.15,0.41
              h-5.02l0.8-1.02c1.74-2.21,3.67-3.94,5.74-5.15L687.02,171.34z M679.76,203.34l0,0.63c0,0.08,0,0.15,0,0.23c0,0.09,0,0.18,0,0.27
              c0,2.98,0.12,5.95,0.37,8.83l0.06,0.68h-8.21l-0.09-0.53c-0.48-2.91-0.73-5.9-0.73-8.9c0-0.12,0-0.24,0.01-0.36
              c0-0.08,0-0.16,0-0.24l0.01-0.62H679.76z M671.21,202.23l0.04-0.66c0.17-3.26,0.64-6.46,1.37-9.5l0.12-0.48h7.82l-0.09,0.7
              c-0.36,2.98-0.59,6.12-0.67,9.33l-0.02,0.61H671.21z M680.3,215.1l0.06,0.56c0.37,3.32,0.89,6.45,1.57,9.31l0.18,0.77h-6.41
              l-0.17-0.36c-1.37-2.89-2.44-6.1-3.18-9.52l-0.16-0.76H680.3z M680.71,190.47h-7.69l0.24-0.81c1.06-3.56,2.49-6.77,4.24-9.54
              l0.18-0.29h5.36l-0.24,0.81c-0.83,2.77-1.51,5.9-2.02,9.3L680.71,190.47z M670.7,177.6c0.49-0.4,1.02-0.79,1.62-1.21
              c2.14-1.49,4.47-2.74,6.93-3.73c0.94-0.37,3.4-1.07,3.4-1.07s-2.12,1.53-2.73,2.1c-1.41,1.3-2.66,2.94-3.84,4.74l-0.19,0.28h-6.58
              L670.7,177.6z M661.04,189.57c0.4-0.82,0.8-1.56,1.21-2.26c0.13-0.22,0.26-0.44,0.4-0.67c1.48-2.41,3.26-4.64,5.3-6.63l0.18-0.18
              h7.05l-0.51,0.93c-1.53,2.78-2.77,5.89-3.7,9.25l-0.13,0.46H660.6L661.04,189.57z M657.77,201.57c0.01-0.13,0.02-0.26,0.03-0.38
              l0-0.03c0.1-1.01,0.24-1.99,0.41-2.93c0.38-2.12,0.98-4.22,1.78-6.25l0.16-0.4h10.4l-0.17,0.76c-0.66,2.96-1.08,6.08-1.24,9.28
              l-0.03,0.6h-11.37L657.77,201.57z M658.9,213.53c-0.12-0.42-0.24-0.88-0.37-1.43c-0.22-0.9-0.4-1.86-0.55-2.94
              c-0.14-1-0.24-2.02-0.3-3.13c-0.02-0.45-0.04-1.03-0.04-1.64c0-0.14,0-0.29,0.01-0.44l0.02-0.6h11.39l-0.01,0.63
              c0,0.09,0,0.17,0,0.26c0,0.11,0,0.22,0,0.33c0,2.94,0.22,5.87,0.66,8.7l0.11,0.72h-10.79L658.9,213.53z M665.21,225.74l-0.19-0.24
              c-0.63-0.79-1.22-1.61-1.8-2.49c-0.12-0.17-0.23-0.35-0.34-0.52l-0.01-0.01c-0.53-0.85-0.99-1.64-1.38-2.4
              c-0.09-0.18-0.18-0.35-0.27-0.53c-0.59-1.17-1.11-2.39-1.55-3.61l-0.31-0.84h10.67l0.1,0.5c0.66,3.29,1.61,6.41,2.84,9.26
              l0.37,0.87H665.21z M678.66,235.86c-1.33-0.62-2.66-1.22-3.89-1.93c-1.5-0.87-2.95-1.86-4.29-2.93c-1.19-0.96-2.32-1.99-3.36-3.08
              l-1.01-1.06h7.77l0.17,0.34c0.5,1,1.03,1.94,1.58,2.81c1.12,1.8,2.38,3.43,3.72,4.83c0.81,0.85,2.87,2.4,2.93,2.45
              C682.21,237.27,679.87,236.43,678.66,235.86z M685.12,236.66c-3.15-1.79-6.03-4.86-8.33-8.86l-0.54-0.94h6.15l0.13,0.46
              c0.24,0.85,0.47,1.6,0.7,2.31c0.8,2.41,1.72,4.49,2.73,6.16l1.25,2.06L685.12,236.66z M691.15,237.13l-0.91-0.45
              c-2.73-1.35-4.6-5.64-5.69-9l-0.27-0.82h6.86V237.13z M691.15,225.74h-7.18l-0.12-0.47c-0.76-2.85-1.35-6.04-1.77-9.47l-0.08-0.7
              h9.16V225.74z M691.15,213.98h-9.27l-0.05-0.57c-0.27-2.93-0.41-5.94-0.41-8.94c0-0.1,0-0.2,0-0.31c0-0.07,0-0.13,0-0.2l0-0.62
              h9.73V213.98z M691.15,202.23h-9.71l0.02-0.65c0.09-3.25,0.35-6.43,0.75-9.45l0.07-0.54h8.87V202.23z M691.15,190.47h-8.71
              l0.12-0.73c0.59-3.59,1.38-6.79,2.34-9.49l0.15-0.42h6.1V190.47z M691.15,178.71h-5.69l0.4-0.89c1.31-2.9,2.78-4.77,4.38-5.56
              l0.91-0.45V178.71z M693.69,236.68l-0.91,0.45v-10.27h6.86l-0.27,0.82C698.3,231.04,696.42,235.33,693.69,236.68z M696.73,237.85
              l1.24-2.06c1.01-1.68,1.93-3.75,2.73-6.16c0.23-0.7,0.46-1.46,0.7-2.31l0.13-0.46h6.15l-0.54,0.94c-2.29,4-5.17,7.06-8.33,8.86
              L696.73,237.85z M716.81,227.92c-1.04,1.09-2.16,2.13-3.36,3.08c-1.34,1.08-2.79,2.07-4.29,2.93c-1.22,0.71-2.59,1.36-3.9,2.03
              c-0.79,0.4-3.54,1.34-3.54,1.34s2.16-1.73,2.86-2.44c1.37-1.38,2.6-3.03,3.72-4.84c0.54-0.87,1.07-1.82,1.58-2.81l0.17-0.34h7.77
              L716.81,227.92z M724.27,215.94c-0.44,1.22-0.97,2.44-1.55,3.61l-0.02,0.05c-0.08,0.16-0.16,0.32-0.25,0.48
              c-0.4,0.77-0.85,1.56-1.38,2.41c-0.1,0.15-0.22,0.35-0.35,0.53c-0.58,0.88-1.16,1.69-1.8,2.49l-0.19,0.24h-8.13l0.37-0.87
              c1.22-2.86,2.18-5.97,2.84-9.26l0.1-0.5h10.67L724.27,215.94z M726.25,206.02c-0.05,1.03-0.15,2.09-0.29,3.13
              c-0.13,0.98-0.32,1.97-0.54,2.94c-0.11,0.48-0.24,0.96-0.37,1.44l-0.13,0.46h-10.79l0.11-0.72c0.44-2.84,0.66-5.76,0.66-8.7
              c0-0.11,0-0.22,0-0.33c0-0.08,0-0.17-0.01-0.25l-0.01-0.63h11.38l0.03,0.6c0.01,0.15,0.01,0.3,0.01,0.44
              C726.28,204.92,726.27,205.47,726.25,206.02z"
            className="colorfff svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ff69b4"
            d="M274.35,422.07H218.8c-3.95,0-7.15,3.2-7.15,7.15v55.55c0,3.95,3.2,7.15,7.15,7.15h55.55
                      c3.95,0,7.15-3.2,7.15-7.15v-55.55C281.5,425.27,278.3,422.07,274.35,422.07z"
            className="colorff69b4 svgShape"
            style={{ fill: "#0078ac" }}
          ></path>
          <polygon
            fill="#ffffff"
            points="239.27 447.05 239.27 447.06 239.27 447.05"
            className="colorfff svgShape"
          ></polygon>
          <path
            fill="#ffffff"
            d="M234.67,455.61c0.57,0.86,1.22,1.65,1.94,2.37C235.98,457.19,235.33,456.4,234.67,455.61z M258.29,457.57
                          c0.68-0.72,1.28-1.52,1.8-2.37C259.48,456,258.88,456.79,258.29,457.57z"
            className="colorfff svgShape"
          ></path>
          <path
            fill="#ffffff"
            d="M247.4,432.21c-8.24-0.08-15.08,6.57-15.23,14.8c-0.06,3.18,0.87,6.14,2.49,8.6h0v0l0,0
                          c4.49,5.34,8.69,11.47,11.8,17.3c0.32,0.6,1.19,0.59,1.49-0.02c2.82-5.68,8.18-12.07,12.14-17.69c1.42-2.3,2.24-5.01,2.24-7.91
                          C262.34,439.01,255.66,432.29,247.4,432.21z M247.25,456.84c-1.8,0-3.48-0.5-4.91-1.36c-2.78-1.67-4.64-4.71-4.64-8.19
                          c0-5.27,4.28-9.55,9.55-9.55c5.27,0,9.55,4.28,9.55,9.55c0,3.37-1.74,6.33-4.38,8.03
                          C250.93,456.28,249.16,456.84,247.25,456.84z"
            className="colorfff svgShape"
          ></path>
          <circle
            cx="247.44"
            cy="479.4"
            r="3.52"
            fill="#ffffff"
            className="colorfff svgShape"
          ></circle>
          <path
            fill="#ffffff"
            d="M234.67,455.61c0.57,0.86,1.22,1.65,1.94,2.37C235.98,457.19,235.33,456.4,234.67,455.61z M258.29,457.57
                      c0.68-0.72,1.28-1.52,1.8-2.37C259.48,456,258.88,456.79,258.29,457.57z"
            className="colorfff svgShape"
          ></path>
        </g>
        <path
          fill="#ff69b4"
          d="M876.73,191.54h-77.57c-10.57,0-19.15,8.57-19.15,19.15v77.57c0,10.58,8.57,19.15,19.15,19.15h77.57
          c10.57,0,19.15-8.57,19.15-19.15v-77.57C895.88,200.11,887.31,191.54,876.73,191.54z"
          className="colorff69b4 svgShape"
          style={{ fill: "#0078ac" }}
        ></path>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ffffff"
            d="M885.8,214.29h-10.19c-0.55,0-1.04,0.28-1.34,0.7h-2.35c-4.99,0-9.06,4.06-9.06,9.06v0.42l-67.54,5.87
                  l2.72,33.07h65.26c1.45,2.22,1.6,4.93,0.38,7.32c-1.28,2.49-3.71,3.98-6.51,3.98h-50.48l-3.6,7.54
                  c-0.18-0.03-0.37-0.05-0.56-0.05c-1.7,0-3.09,1.38-3.09,3.09c0,1.7,1.38,3.09,3.09,3.09c1.7,0,3.09-1.38,3.09-3.09
                  c0-0.84-0.34-1.61-0.89-2.17l1.36-2.84h54.55l1.93,3.06c-0.57,0.56-0.93,1.34-0.93,2.21c0,1.7,1.38,3.09,3.09,3.09
                  c1.7,0,3.09-1.38,3.09-3.09c0-1.7-1.38-3.09-3.09-3.09c-0.17,0-0.33,0.02-0.5,0.04l-4.06-6.44c2.2-0.75,4.07-2.33,5.17-4.49
                  c1.55-3.02,1.31-6.6-0.62-9.38v-35.9h0.01v-2.24c0-3.98,3.23-7.21,7.21-7.21h2.33c0.29,0.44,0.79,0.72,1.36,0.72h10.19
                  c0.9,0,1.63-0.73,1.63-1.63C887.44,215.02,886.7,214.29,885.8,214.29z M806.86,278.63l1-2.08h49.32c0.36,0,0.71-0.03,1.06-0.07
                  l1.36,2.15H806.86z M849.62,261.55l-0.21-6.03l6.54-0.23l0.21,6.26H849.62z M842.1,261.55l-0.2-5.76l6.54-0.23l0.2,5.99H842.1z
                   M834.58,261.55l-0.19-5.5l6.54-0.23l0.2,5.73H834.58z M827.07,261.55l-0.18-5.24l6.54-0.23l0.19,5.47H827.07z M819.55,261.55
                  l-0.17-4.97l6.54-0.23l0.18,5.2H819.55z M812.04,261.55l-0.16-4.71h0l6.54-0.23l0.17,4.94H812.04z M804.52,261.55l-0.15-4.45
                  l6.54-0.23h0l0.16,4.68H804.52z M798.21,242.81l-0.49-6.01l4.99-0.18l0.21,6.03L798.21,242.81z M802.94,243.46L802.94,243.46
                  l0.21,6.02h0l-4.37,0.15l-0.49-6.01L802.94,243.46z M798.84,250.45l4.33-0.15l0.21,6.02h0l-4.04,0.14L798.84,250.45z
                   M810.03,230.91l0.16,4.63l-6.54,0.23l-0.15-4.29L810.03,230.91z M817.52,230.26l0.17,5.02l0,0l-6.54,0.23h0l-0.16-4.68
                  L817.52,230.26z M825.01,229.61l0.18,5.41l-6.54,0.23l0,0l-0.17-5.07L825.01,229.61z M832.51,228.96l0.2,5.79l-6.54,0.23
                  l-0.19-5.46L832.51,228.96z M840,228.31l0.21,6.18l-6.54,0.23l-0.2-5.84L840,228.31z M847.5,227.66l0.22,6.57l-6.54,0.23
                  l-0.21-6.23L847.5,227.66z M854.99,227l0.24,6.96l-6.54,0.23l-0.23-6.62L854.99,227z M855.49,241.62l0.21,6.02l-6.54,0.23
                  l-0.21-6.02L855.49,241.62z M848.92,241.03l-0.21-6.02l6.54-0.23l0.21,6.02L848.92,241.03z M855.72,248.46l0.21,6.02l-6.54,0.23
                  l-0.21-6.02L855.72,248.46z M847.98,241.88l0.21,6.02l-6.54,0.23l-0.21-6.02L847.98,241.88z M841.41,241.29l-0.21-6.02l6.54-0.23
                  l0.21,6.02L841.41,241.29z M848.22,248.72l0.21,6.02l-6.54,0.23l-0.21-6.02L848.22,248.72z M840.47,242.15l0.21,6.02l-6.54,0.23
                  l-0.2-6.02L840.47,242.15z M833.9,241.56l-0.21-6.02l6.54-0.23l0.21,6.02L833.9,241.56z M840.71,248.99l0.21,6.02l-6.54,0.23
                  l-0.21-6.02L840.71,248.99z M832.97,242.41l0.21,6.02l-6.54,0.23l-0.21-6.02L832.97,242.41z M826.4,241.82l-0.21-6.02l6.54-0.23
                  l0.21,6.02L826.4,241.82z M833.2,249.25l0.21,6.02l-6.54,0.23l-0.21-6.02L833.2,249.25z M825.46,242.67l0.21,6.02l-6.54,0.23
                  l-0.21-6.02L825.46,242.67z M818.89,242.08L818.89,242.08l-0.21-6.02h0l6.54-0.23l0.21,6.02L818.89,242.08z M819.15,249.74
                  l6.54-0.23l0.21,6.02l-6.54,0.23l0,0L819.15,249.74L819.15,249.74z M811.41,243.16l6.54-0.23h0l0.21,6.02l-6.54,0.23h0
                  L811.41,243.16L811.41,243.16z M811.38,242.35l-0.21-6.03l6.54-0.23l0.21,6.02L811.38,242.35z M818.18,249.78l0.2,6.02h0
                  l-6.54,0.23l-0.21-6.02L818.18,249.78z M810.44,243.2l0.2,6.02h0l-6.54,0.23l-0.21-6.02L810.44,243.2z M803.87,242.61
                  L803.87,242.61l-0.21-6.02h0l6.54-0.23h0l0.2,6.02L803.87,242.61z M804.13,250.27l6.54-0.23l0.21,6.02l-6.54,0.23h0
                  L804.13,250.27L804.13,250.27z M862.86,247.39l-6.2,0.22l-0.21-6.02l6.41-0.22V247.39z M862.86,240.54l-6.44,0.23l-0.21-6.02
                  l6.64-0.23V240.54z M856.69,248.43l6.17-0.22v6.03l-5.97,0.21L856.69,248.43z M862.86,233.7l-6.67,0.23l-0.24-7.01l6.91-0.6
                  V233.7z M802.53,231.57l0.14,4.24h0l-5.03,0.18l-0.33-3.96L802.53,231.57z M799.4,257.28l4-0.14l0.15,4.41h-3.8L799.4,257.28z
                   M857.14,261.55l-0.21-6.29l5.94-0.21v6.5H857.14z"
            className="colorfff svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <rect
            width="166.04"
            height="127.42"
            x="361.48"
            y="645.36"
            fill="#ff69b4"
            className="colorff69b4 svgShape"
            style={{ fill: "#0078ac" }}
          ></rect>
          <rect
            width="166.04"
            height="27.47"
            x="361.49"
            y="619.16"
            fill="#ffb921"
            className="colorffb921 svgShape"
          ></rect>
          <path
            fill="#ffffff"
            d="M390.42 619.16h-2.59c-.08-2.79-1.59-5.1-3.41-5.1-1.8 0-3.31 2.31-3.38 5.1-.03.1-.03.18-.03.28 0 2.92 1.56 5.38 3.41 5.38.72 0 1.28.59 1.28 1.28 0 .72-.56 1.28-1.28 1.28-3.36 0-5.97-3.49-5.97-7.95v-.28c.1-4.33 2.69-7.66 5.97-7.66C387.7 611.49 390.32 614.82 390.42 619.16zM414.36 619.16h-2.59c-.08-2.79-1.59-5.1-3.41-5.1-1.79 0-3.31 2.31-3.38 5.1-.03.1-.03.18-.03.28 0 2.92 1.56 5.38 3.41 5.38.72 0 1.28.59 1.28 1.28 0 .72-.56 1.28-1.28 1.28-3.36 0-5.97-3.49-5.97-7.95v-.28c.1-4.33 2.69-7.66 5.97-7.66C411.65 611.49 414.26 614.82 414.36 619.16zM438.31 619.16h-2.59c-.08-2.79-1.59-5.1-3.41-5.1-1.79 0-3.31 2.31-3.38 5.1-.03.1-.03.18-.03.28 0 2.92 1.56 5.38 3.41 5.38.72 0 1.28.59 1.28 1.28 0 .72-.56 1.28-1.28 1.28-3.36 0-5.97-3.49-5.97-7.95v-.28c.1-4.33 2.69-7.66 5.97-7.66C435.59 611.49 438.21 614.82 438.31 619.16zM462.25 619.16h-2.59c-.08-2.79-1.59-5.1-3.41-5.1-1.79 0-3.31 2.31-3.38 5.1-.03.1-.03.18-.03.28 0 2.92 1.56 5.38 3.41 5.38.72 0 1.28.59 1.28 1.28 0 .72-.56 1.28-1.28 1.28-3.36 0-5.97-3.49-5.97-7.95v-.28c.1-4.33 2.69-7.66 5.97-7.66C459.53 611.49 462.15 614.82 462.25 619.16zM486.2 619.16h-2.59c-.08-2.79-1.59-5.1-3.41-5.1-1.79 0-3.31 2.31-3.38 5.1-.03.1-.03.18-.03.28 0 2.92 1.56 5.38 3.41 5.38.72 0 1.28.59 1.28 1.28 0 .72-.56 1.28-1.28 1.28-3.36 0-5.97-3.49-5.97-7.95v-.28c.1-4.33 2.69-7.66 5.97-7.66C483.48 611.49 486.09 614.82 486.2 619.16zM510.14 619.16h-2.59c-.08-2.79-1.59-5.1-3.41-5.1-1.79 0-3.31 2.31-3.38 5.1-.03.1-.03.18-.03.28 0 2.92 1.56 5.38 3.41 5.38.72 0 1.28.59 1.28 1.28 0 .72-.56 1.28-1.28 1.28-3.36 0-5.97-3.49-5.97-7.95v-.28c.1-4.33 2.69-7.66 5.97-7.66C507.42 611.49 510.04 614.82 510.14 619.16z"
            className="colorfff svgShape"
          ></path>
          <rect
            width="21.59"
            height="21.59"
            x="405.8"
            y="657.04"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="433.71"
            y="657.04"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="461.63"
            y="657.04"
            fill="#ffcce6"
            className="colorffcce6 svgShape"
            style={{ fill: "#d2112b" }}
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="489.54"
            y="657.04"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="377.89"
            y="684.53"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="405.8"
            y="684.53"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="433.71"
            y="684.53"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="461.63"
            y="684.53"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="489.54"
            y="684.53"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="377.89"
            y="712.02"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="405.8"
            y="712.02"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="433.71"
            y="712.02"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="461.63"
            y="712.02"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="489.54"
            y="712.02"
            fill="#ffcce6"
            className="colorffcce6 svgShape"
            style={{ fill: "#d2112b" }}
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="377.89"
            y="739.51"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="405.8"
            y="739.51"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="461.63"
            y="739.51"
            fill="#ffffff"
            className="colorfff svgShape"
          ></rect>
          <rect
            width="21.59"
            height="21.59"
            x="433.71"
            y="739.51"
            fill="#ffcce6"
            className="colorffcce6 svgShape"
            style={{ fill: "#d2112b" }}
          ></rect>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ffb300"
            d="M256.07,264.46c-10.32,0-20.17-3.58-28-10.13l28.46-29.93l35.53,21.16c-3.68,5.34-8.53,9.83-14.17,13.09
                  C271.29,262.45,263.74,264.46,256.07,264.46z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#ff69b4"
            d="M258.7,218.43v-40.69c21.94,1.31,39.57,18.84,40.88,40.69H258.7z"
            className="colorff69b4 svgShape"
          ></path>
          <path
            fill="#8747e6"
            d="M273.77,225.16h33.96c-0.37,6.07-2.01,11.99-4.81,17.36L273.77,225.16z"
            className="color8747e6 svgShape"
          ></path>
          <path
            fill="#78b8ff"
            d="M224.23,250.72c-7.61-8.06-11.77-18.5-11.77-29.66c0-23.05,18.15-41.96,40.97-43.32v42.27L224.23,250.72z"
            className="color78b8ff svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#baddde"
            d="M1164.84,735.75v11.37c-10.39-0.31-20.4-4.02-28.44-10.56l6.54-9.37
              C1149.07,732.44,1156.75,735.44,1164.84,735.75z"
            className="colorbaddde svgShape"
          ></path>
          <path
            fill="#ff69b4"
            d="M1164.84,735.75v11.37c-10.39-0.31-20.4-4.02-28.44-10.56l6.54-9.37
              C1149.07,732.44,1156.75,735.44,1164.84,735.75z"
            className="colorff69b4 svgShape"
          ></path>
          <path
            fill="#d1eced"
            d="M1140.82,725.24l-6.59,9.45c-9.72-8.89-15.25-21.42-15.25-34.62c0-0.4,0-0.77,0.01-1.1h11.42
              c-0.01,0.36-0.02,0.73-0.02,1.1C1130.39,709.49,1134.18,718.59,1140.82,725.24z"
            className="colord1eced svgShape"
          ></path>
          <path
            fill="#ffb300"
            d="M1140.82,725.24l-6.59,9.45c-9.72-8.89-15.25-21.42-15.25-34.62c0-0.4,0-0.77,0.01-1.1h11.42
              c-0.01,0.36-0.02,0.73-0.02,1.1C1130.39,709.49,1134.18,718.59,1140.82,725.24z"
            className="colorffb300 svgShape"
          ></path>
          <path
            fill="#baddde"
            d="M1154.64,666.28c-13.07,4.46-22.52,16.19-24.03,29.85h-11.46c0.76-9.23,4.19-17.91,9.98-25.21
              c5.72-7.21,13.29-12.53,21.97-15.44L1154.64,666.28z"
            className="colorbaddde svgShape"
          ></path>
          <path
            fill="#78b8ff"
            d="M1154.64,666.28c-13.07,4.46-22.52,16.19-24.03,29.85h-11.46c0.76-9.23,4.19-17.91,9.98-25.21
              c5.72-7.21,13.29-12.53,21.97-15.44L1154.64,666.28z"
            className="color78b8ff svgShape"
          ></path>
          <path
            fill="#baddde"
            d="M1213.54,700.08c0,4.58-0.66,9.09-1.95,13.43l-10.58-4.59c0.74-2.87,1.11-5.84,1.11-8.83
              c0-10.99-5.12-21.39-13.78-28.14l7.18-8.84c5.32,4.18,9.74,9.51,12.83,15.49C1211.79,685.27,1213.54,692.5,1213.54,700.08z"
            className="colorbaddde svgShape"
          ></path>
          <path
            fill="#ff69b4"
            d="M1213.54,700.08c0,4.58-0.66,9.09-1.95,13.43l-10.58-4.59c0.74-2.87,1.11-5.84,1.11-8.83
              c0-10.99-5.12-21.39-13.78-28.14l7.18-8.84c5.32,4.18,9.74,9.51,12.83,15.49C1211.79,685.27,1213.54,692.5,1213.54,700.08z"
            className="colorff69b4 svgShape"
          ></path>
          <path
            fill="#d1eced"
            d="M1210.69,716.21c-3.21,8.76-8.89,16.3-16.52,21.86c-7.76,5.66-16.89,8.77-26.49,9.05v-11.37
              c14.71-0.59,27.75-10.26,32.51-24.1L1210.69,716.21z"
            className="colord1eced svgShape"
          ></path>
          <path
            fill="#8747e6"
            d="M1210.69,716.21c-3.21,8.76-8.89,16.3-16.52,21.86c-7.76,5.66-16.89,8.77-26.49,9.05v-11.37
              c14.71-0.59,27.75-10.26,32.51-24.1L1210.69,716.21z"
            className="color8747e6 svgShape"
          ></path>
          <path
            fill="#d1eced"
            d="M1193.22,661.4l-7.2,8.87c-5.86-3.87-12.67-5.91-19.76-5.91c-0.81,0-1.62,0.03-2.41,0.08
              c-2.19,0.14-4.37,0.49-6.49,1.03l-3.54-10.82c3.8-1.03,7.73-1.58,11.72-1.64c0.24,0,0.48-0.01,0.72-0.01
              C1176,653.01,1185.29,655.9,1193.22,661.4z"
            className="colord1eced svgShape"
          ></path>
          <path
            fill="#ffb300"
            d="M1193.22,661.4l-7.2,8.87c-5.86-3.87-12.67-5.91-19.76-5.91c-0.81,0-1.62,0.03-2.41,0.08
              c-2.19,0.14-4.37,0.49-6.49,1.03l-3.54-10.82c3.8-1.03,7.73-1.58,11.72-1.64c0.24,0,0.48-0.01,0.72-0.01
              C1176,653.01,1185.29,655.9,1193.22,661.4z"
            className="colorffb300 svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ffb300"
            d="M221.31,634.08l4.86-4.89c1.1-1.11,1.1-2.9-0.01-4c-1.11-1.1-2.9-1.1-4,0.01l-4.86,4.89l-4.89-4.86
              c-1.11-1.1-2.9-1.1-4,0.01c-1.1,1.11-1.1,2.9,0.01,4l4.89,4.86l-4.85,4.88c-1.1,1.11-1.1,2.9,0.01,4
              c0.55,0.55,1.28,0.83,2.01,0.82c0.72,0,1.45-0.28,2-0.84l4.85-4.88l4.88,4.85c0.55,0.55,1.28,0.83,2.01,0.82
              c0.72,0,1.45-0.28,2-0.84c1.1-1.11,1.1-2.9-0.01-4L221.31,634.08z"
            className="colorffb300 svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ffb300"
            d="M864.91,153.12l4.86-4.89c1.1-1.11,1.1-2.9-0.01-4c-1.11-1.1-2.9-1.1-4,0.01l-4.86,4.89l-4.89-4.86
              c-1.11-1.1-2.9-1.1-4,0.01c-1.1,1.11-1.1,2.9,0.01,4l4.89,4.86l-4.85,4.88c-1.1,1.11-1.1,2.9,0.01,4
              c0.55,0.55,1.28,0.83,2.01,0.82c0.72,0,1.45-0.28,2-0.84l4.85-4.88l4.88,4.85c0.55,0.55,1.28,0.83,2.01,0.82
              c0.72,0,1.45-0.28,2-0.84c1.1-1.11,1.1-2.9-0.01-4L864.91,153.12z"
            className="colorffb300 svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#8153c2"
            d="M234.71,373.11c-6.14,0.02-11.15-4.95-11.17-11.09c-0.02-6.14,4.95-11.15,11.09-11.17
                  c6.14-0.02,11.15,4.95,11.17,11.09C245.82,368.07,240.85,373.08,234.71,373.11z M234.64,354.33c-4.22,0.01-7.63,3.46-7.62,7.67
                  c0.01,4.22,3.46,7.63,7.67,7.62c4.22-0.01,7.63-3.46,7.62-7.67C242.3,357.73,238.86,354.32,234.64,354.33z"
            className="color8153c2 svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ff69b4"
            d="M433.39,161.39c0.55,0.88,0.73,1.95,0.48,3c-0.33,1.39-1.35,2.46-2.72,2.87l-13.23,3.91
                                  c-1.37,0.4-2.81,0.06-3.84-0.93c-1.03-0.98-1.45-2.4-1.12-3.79l3.23-13.41c0.33-1.39,1.35-2.46,2.72-2.87
                                  c1.37-0.4,2.81-0.06,3.84,0.93l10,9.5C433,160.85,433.22,161.11,433.39,161.39z M416.08,167.82c0.05,0.08,0.1,0.14,0.14,0.17
                                  c0.11,0.1,0.4,0.32,0.81,0.2l13.23-3.91c0.42-0.12,0.54-0.47,0.58-0.61c0.03-0.14,0.08-0.5-0.24-0.8l-10-9.5
                                  c-0.32-0.3-0.67-0.24-0.81-0.2c-0.14,0.04-0.47,0.18-0.58,0.61l-3.23,13.41C415.92,167.46,415.99,167.68,416.08,167.82z"
            className="colorff69b4 svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#ff69b4"
            d="M1177.28,597.3c0.55,0.88,0.73,1.95,0.48,3c-0.33,1.39-1.35,2.46-2.72,2.87l-13.23,3.91
                                  c-1.37,0.41-2.81,0.06-3.84-0.93c-1.03-0.98-1.45-2.4-1.12-3.79l3.23-13.41c0.33-1.39,1.35-2.46,2.72-2.87
                                  c1.37-0.4,2.81-0.06,3.84,0.93l10,9.5C1176.88,596.76,1177.1,597.02,1177.28,597.3z M1159.96,603.73
                                  c0.05,0.08,0.1,0.14,0.14,0.17c0.11,0.1,0.4,0.32,0.81,0.2l13.23-3.91c0.42-0.12,0.54-0.47,0.58-0.61
                                  c0.03-0.14,0.08-0.5-0.24-0.8l-10-9.5c-0.32-0.3-0.67-0.24-0.81-0.2c-0.14,0.04-0.47,0.18-0.58,0.61l-3.23,13.41
                                  C1159.8,603.37,1159.87,603.59,1159.96,603.73z"
            className="colorff69b4 svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#6633b0"
            d="M911.08,829.43H708.02c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5h203.06c1.93,0,3.5,1.57,3.5,3.5
              S913.01,829.43,911.08,829.43z"
            className="color6633b0 svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#6633b0"
            d="M1039.97,829.43h-67.3c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5h67.3c1.93,0,3.5,1.57,3.5,3.5
              S1041.9,829.43,1039.97,829.43z"
            className="color6633b0 svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000 svgShape">
          <path
            fill="#6633b0"
            d="M418.09,829.43h-67.3c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5h67.3c1.93,0,3.5,1.57,3.5,3.5
              S420.02,829.43,418.09,829.43z"
            className="color6633b0 svgShape"
          ></path>
        </g>
      </svg>
    </g>
  </svg>
);

export const DashboardSVG = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Outline"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    style={{ marginRight: 5 }}
  >
    <path
      d="M7,0H4A4,4,0,0,0,0,4V7a4,4,0,0,0,4,4H7a4,4,0,0,0,4-4V4A4,4,0,0,0,7,0ZM9,7A2,2,0,0,1,7,9H4A2,2,0,0,1,2,7V4A2,2,0,0,1,4,2H7A2,2,0,0,1,9,4Z"
      fill="#ffffff"
    />
    <path
      d="M20,0H17a4,4,0,0,0-4,4V7a4,4,0,0,0,4,4h3a4,4,0,0,0,4-4V4A4,4,0,0,0,20,0Zm2,7a2,2,0,0,1-2,2H17a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
      fill="#ffffff"
    />
    <path
      d="M7,13H4a4,4,0,0,0-4,4v3a4,4,0,0,0,4,4H7a4,4,0,0,0,4-4V17A4,4,0,0,0,7,13Zm2,7a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V17a2,2,0,0,1,2-2H7a2,2,0,0,1,2,2Z"
      fill="#ffffff"
    />
    <path
      d="M20,13H17a4,4,0,0,0-4,4v3a4,4,0,0,0,4,4h3a4,4,0,0,0,4-4V17A4,4,0,0,0,20,13Zm2,7a2,2,0,0,1-2,2H17a2,2,0,0,1-2-2V17a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
      fill="#ffffff"
    />
  </svg>
);

export const SaleSVG = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Outline"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    style={{ marginRight: 15 }}
  >
    <path
      d="M19,10H7v-3h1.5c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5H3.5C1.57,0,0,1.57,0,3.5s1.57,3.5,3.5,3.5h1.5v3c-2.757,0-5,2.243-5,5v4c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5v-4c0-2.757-2.243-5-5-5ZM2,3.5c0-.827,.673-1.5,1.5-1.5h5c.827,0,1.5,.673,1.5,1.5s-.673,1.5-1.5,1.5H3.5c-.827,0-1.5-.673-1.5-1.5Zm3,8.5h14c1.654,0,3,1.346,3,3v3H2v-3c0-1.654,1.346-3,3-3Zm14,10H5c-1.304,0-2.415-.836-2.828-2H21.828c-.413,1.164-1.524,2-2.828,2Zm-10-7c0-.552,.448-1,1-1s1,.448,1,1-.448,1-1,1-1-.448-1-1Zm-4,0c0-.552,.448-1,1-1s1,.448,1,1-.448,1-1,1-1-.448-1-1Zm8,0c0-.552,.448-1,1-1s1,.448,1,1-.448,1-1,1-1-.448-1-1Zm4,0c0-.552,.448-1,1-1s1,.448,1,1-.448,1-1,1-1-.448-1-1Z"
      fill={"#ffffff"}
    />
  </svg>
);

export const SalesRegisterSVG = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Outline"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    style={{ marginRight: 5 }}
  >
    <path
      d="M9,17v2c0,.552-.448,1-1,1s-1-.448-1-1v-2c0-.552,.448-1,1-1s1,.448,1,1Zm7-3c-.553,0-1,.448-1,1v4c0,.552,.447,1,1,1s1-.448,1-1v-4c0-.552-.447-1-1-1Zm-4-3c-.552,0-1,.448-1,1v7c0,.552,.448,1,1,1s1-.448,1-1v-7c0-.552-.448-1-1-1Zm10-.515v8.515c0,2.757-2.243,5-5,5H7c-2.757,0-5-2.243-5-5V5C2,2.243,4.243,0,7,0h4.515c1.869,0,3.627,.728,4.95,2.05l3.484,3.486c1.322,1.321,2.051,3.079,2.051,4.95ZM15.051,3.464c-.318-.318-.671-.587-1.051-.805V7c0,.551,.448,1,1,1h4.341c-.218-.379-.488-.732-.805-1.05l-3.484-3.486Zm4.949,7.021c0-.163-.008-.325-.023-.485h-4.977c-1.654,0-3-1.346-3-3V2.023c-.16-.015-.322-.023-.485-.023H7c-1.654,0-3,1.346-3,3v14c0,1.654,1.346,3,3,3h10c1.654,0,3-1.346,3-3V10.485Z"
      fill={"#ffffff"}
    />
  </svg>
);

export const InventorySVG = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Outline"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    style={{ marginRight: 15 }}
  >
    <path
      d="m10,23c0,.553-.448,1-1,1h-4c-2.757,0-5-2.243-5-5V7C0,4.243,2.243,2,5,2h.171c.413-1.164,1.525-2,2.829-2h2c1.304,0,2.416.836,2.829,2h.171c2.757,0,5,2.243,5,5v3c0,.552-.447,1-1,1s-1-.448-1-1v-3c0-1.654-1.346-3-3-3h-1c-.552,0-1-.448-1-1s-.449-1-1-1h-2c-.551,0-1,.449-1,1s-.448,1-1,1h-1c-1.654,0-3,1.346-3,3v12c0,1.654,1.346,3,3,3h4c.552,0,1,.447,1,1Zm-1.207-16.287l-2.227,2.227c-.078.079-.204.082-.286.006l-1.105-1.013c-.407-.373-1.04-.344-1.413.062-.373.407-.346,1.04.062,1.413l1.105,1.013c.424.389.958.582,1.491.582.565,0,1.129-.217,1.56-.648l2.227-2.227c.391-.391.391-1.023,0-1.414s-1.023-.391-1.414,0Zm0,6.08l-2.227,2.227c-.078.079-.204.081-.286.006l-1.105-1.013c-.407-.373-1.04-.345-1.413.062-.373.407-.346,1.04.062,1.413l1.105,1.013c.424.389.958.582,1.491.582.565,0,1.129-.218,1.56-.648l2.227-2.227c.391-.391.391-1.023,0-1.414s-1.023-.391-1.414,0Zm15.207,3.707v4c0,1.93-1.57,3.5-3.5,3.5h-5c-1.93,0-3.5-1.57-3.5-3.5v-4c0-1.93,1.57-3.5,3.5-3.5h5c1.93,0,3.5,1.57,3.5,3.5Zm-2,0c0-.827-.673-1.5-1.5-1.5h-5c-.827,0-1.5.673-1.5,1.5v4c0,.827.673,1.5,1.5,1.5h5c.827,0,1.5-.673,1.5-1.5v-4Zm-3,.5h-2c-.553,0-1,.447-1,1s.447,1,1,1h2c.553,0,1-.447,1-1s-.447-1-1-1Zm-5-7c0-.552-.447-1-1-1h-1.5c-.552,0-1,.448-1,1s.448,1,1,1h1.5c.553,0,1-.448,1-1Z"
      fill={"#ffffff"}
    />
  </svg>
);

export const InventoryRegisterSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <path
        className="cls-1"
        d="m426.67,277.14h-64c-47.13,0-85.33,38.21-85.33,85.33v64c0,47.13,38.21,85.33,85.33,85.33h64c47.13,0,85.33-38.21,85.33-85.33v-64c0-47.13-38.21-85.33-85.33-85.33Zm42.67,149.33c0,23.56-19.1,42.67-42.67,42.67h-64c-23.56,0-42.67-19.1-42.67-42.67v-64c0-23.56,19.1-42.67,42.67-42.67h64c23.56,0,42.67,19.1,42.67,42.67v64Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m257.33,490.67c0,11.8-9.56,21.33-21.33,21.33H106.67c-58.82,0-106.67-47.85-106.67-106.67V149.33C0,90.52,47.85,42.67,106.67,42.67h3.65C119.13,17.83,142.85,0,170.67,0h42.67c27.82,0,51.54,17.83,60.35,42.67h3.65c58.82,0,106.67,47.85,106.67,106.67v72c0,11.78-9.54,21.33-21.33,21.33s-21.33-9.56-21.33-21.33v-72c0-35.29-28.71-64-64-64h-21.33c-11.78,0-21.33-9.56-21.33-21.33s-9.58-21.33-21.33-21.33h-42.67c-11.75,0-21.33,9.58-21.33,21.33s-9.56,21.33-21.33,21.33h-21.33c-35.29,0-64,28.71-64,64v256c0,35.29,28.71,64,64,64h129.33c11.78,0,21.33,9.54,21.33,21.33Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m187.58,137.21l-47.51,47.51c-1.66,1.69-4.35,1.75-6.1.13l-23.57-21.61c-8.68-7.96-22.19-7.34-30.14,1.32-7.96,8.68-7.38,22.19,1.32,30.14l23.57,21.61c9.05,8.3,20.44,12.42,31.81,12.42,12.05,0,24.09-4.63,33.28-13.82l47.51-47.51c8.34-8.34,8.34-21.82,0-30.17-8.34-8.34-21.82-8.34-30.17,0v-.02Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m187.58,291.92l-47.51,47.51c-1.66,1.69-4.35,1.73-6.1.13l-23.57-21.61c-8.68-7.96-22.19-7.36-30.14,1.32-7.96,8.68-7.38,22.19,1.32,30.14l23.57,21.61c9.05,8.3,20.44,12.42,31.81,12.42,12.05,0,24.09-4.65,33.28-13.82l47.51-47.51c8.34-8.34,8.34-21.82,0-30.17-8.34-8.34-21.82-8.34-30.17,0v-.02Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m298.67,207.33c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m425.22,366.16l-37.94,37.94c-1.33,1.35-3.48,1.38-4.87.1l-18.83-17.26c-6.93-6.35-17.72-5.88-24.07,1.06-6.35,6.93-5.89,17.72,1.06,24.07l18.83,17.26c7.22,6.63,16.32,9.92,25.4,9.92,9.63,0,19.24-3.71,26.58-11.04l37.94-37.94c6.66-6.66,6.66-17.43,0-24.09-6.66-6.66-17.43-6.66-24.09,0v-.02Z"
        fill={"#ffffff"}
      />
    </g>
  </svg>
);

export const ItemGroupSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <path
        className="cls-1"
        d="m256,0C114.62,0,0,114.62,0,256s114.62,256,256,256,256-114.62,256-256S397.38,0,256,0Zm0,468.48c-117.35,0-212.48-95.13-212.48-212.48S138.65,43.52,256,43.52s212.48,95.13,212.48,212.48-95.13,212.48-212.48,212.48Z"
        fill={"#ffffff"}
      />
      <circle
        className="cls-1"
        cx="256.15"
        cy="151.81"
        r="63.12"
        fill={"#ffffff"}
      />
      <circle
        className="cls-1"
        cx="355.48"
        cy="305.63"
        r="63.12"
        fill={"#ffffff"}
      />
      <circle
        className="cls-1"
        cx="158.28"
        cy="305.63"
        r="63.12"
        fill={"#ffffff"}
      />
    </g>
  </svg>
);

export const ItemsSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <path
        className="cls-1"
        d="m149.33,189h-64C38.21,189,0,227.21,0,274.33v64c0,47.13,38.21,85.33,85.33,85.33h64c47.13,0,85.33-38.21,85.33-85.33v-64c0-47.13-38.21-85.33-85.33-85.33Zm42.67,149.33c0,23.56-19.1,42.67-42.67,42.67h-64c-23.56,0-42.67-19.1-42.67-42.67v-64c0-23.56,19.1-42.67,42.67-42.67h64c23.56,0,42.67,19.1,42.67,42.67v64Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m342.33,189h-64c-47.13,0-85.33,38.21-85.33,85.33v64c0,47.13,38.21,85.33,85.33,85.33h64c47.13,0,85.33-38.21,85.33-85.33v-64c0-47.13-38.21-85.33-85.33-85.33Zm42.67,149.33c0,23.56-19.1,42.67-42.67,42.67h-64c-23.56,0-42.67-19.1-42.67-42.67v-64c0-23.56,19.1-42.67,42.67-42.67h64c23.56,0,42.67,19.1,42.67,42.67v64Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m242.33,0h-64c-47.13,0-85.33,38.21-85.33,85.33v64c0,47.13,38.21,85.33,85.33,85.33h64c47.13,0,85.33-38.21,85.33-85.33v-64C327.67,38.21,289.46,0,242.33,0Zm42.67,149.33c0,23.56-19.1,42.67-42.67,42.67h-64c-23.56,0-42.67-19.1-42.67-42.67v-64c0-23.56,19.1-42.67,42.67-42.67h64c23.56,0,42.67,19.1,42.67,42.67v64Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m232.11,78.74c0-7.74-6.27-14.03-14.03-14.03h-21.05c-7.74,0-14.03,6.29-14.03,14.03s6.29,14.03,14.03,14.03h21.05c7.76,0,14.03-6.29,14.03-14.03Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m142.11,263.74c0-7.74-6.27-14.03-14.03-14.03h-21.05c-7.74,0-14.03,6.29-14.03,14.03s6.29,14.03,14.03,14.03h21.05c7.76,0,14.03-6.29,14.03-14.03Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m338.11,263.74c0-7.74-6.27-14.03-14.03-14.03h-21.05c-7.74,0-14.03,6.29-14.03,14.03s6.29,14.03,14.03,14.03h21.05c7.76,0,14.03-6.29,14.03-14.03Z"
        fill={"#ffffff"}
      />
    </g>
  </svg>
);

export const UnitOfMeasurementSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m302.18,24.99L24.99,302.18c-33.32,33.32-33.32,87.35,0,120.68l45.25,45.25c33.32,33.32,87.35,33.32,120.68,0L468.11,190.93c33.32-33.32,33.32-87.35,0-120.68l-45.25-45.25c-33.32-33.32-87.35-33.32-120.68,0Zm135.76,75.42c16.66,16.66,16.66,43.68,0,60.34L160.76,437.94c-16.66,16.66-43.68,16.66-60.34,0l-45.25-45.25c-16.66-16.66-16.66-43.68,0-60.34L332.35,55.16c16.66-16.66,43.68-16.66,60.34,0l45.25,45.25Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m197.88,441.6c8.33-8.33,8.34-21.83,0-30.17l-22.23-22.23c-8.19-8.19-21.56-8.83-30.03-.92s-9.04,22.19-.54,30.69l22.63,22.63c8.34,8.34,21.84,8.33,30.17,0Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m245.97,393.52c8.33-8.33,8.34-21.83,0-30.17l-22.23-22.23c-8.19-8.19-21.56-8.83-30.03-.92-8.86,8.27-9.04,22.19-.54,30.69l22.63,22.63c8.34,8.34,21.84,8.33,30.17,0Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m298.29,341.19c8.33-8.33,8.34-21.83,0-30.17l-22.23-22.23c-8.19-8.19-21.56-8.83-30.03-.92-8.86,8.27-9.04,22.19-.54,30.69l22.63,22.63c8.34,8.34,21.84,8.33,30.17,0Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m346.38,293.11c8.33-8.33,8.34-21.83,0-30.17l-22.23-22.23c-8.19-8.19-21.56-8.83-30.03-.92-8.86,8.27-9.04,22.19-.54,30.69l22.63,22.63c8.34,8.34,21.84,8.33,30.17,0Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m394.46,245.02c8.33-8.33,8.34-21.83,0-30.17l-22.23-22.23c-8.19-8.19-21.56-8.83-30.03-.92-8.86,8.27-9.04,22.19-.54,30.69l22.63,22.63c8.34,8.34,21.84,8.33,30.17,0Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m441.84,197.65c8.33-8.33,8.34-21.83,0-30.17l-22.23-22.23c-8.19-8.19-21.56-8.83-30.03-.92-8.86,8.27-9.04,22.19-.54,30.69l22.63,22.63c8.34,8.34,21.84,8.33,30.17,0Z"
          fill={"#ffffff"}
        />
        <circle
          className="cls-1"
          cx="345.77"
          cy="101.71"
          r="22.21"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const UnitOfMeasurementCategorySVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <g>
          <path
            className="cls-1"
            d="m302.18,24.99L24.99,302.18c-33.32,33.32-33.32,87.35,0,120.68l45.25,45.25c33.32,33.32,87.35,33.32,120.68,0L468.11,190.93c33.32-33.32,33.32-87.35,0-120.68l-45.25-45.25c-33.32-33.32-87.35-33.32-120.68,0Zm135.76,75.42c16.66,16.66,16.66,43.68,0,60.34L160.76,437.94c-16.66,16.66-43.68,16.66-60.34,0l-45.25-45.25c-16.66-16.66-16.66-43.68,0-60.34L332.35,55.16c16.66-16.66,43.68-16.66,60.34,0l45.25,45.25Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m197.88,441.6c8.33-8.33,8.34-21.83,0-30.17l-22.23-22.23c-8.19-8.19-21.56-8.83-30.03-.92s-9.04,22.19-.54,30.69l22.63,22.63c8.34,8.34,21.84,8.33,30.17,0Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m245.97,393.52c8.33-8.33,8.34-21.83,0-30.17l-22.23-22.23c-8.19-8.19-21.56-8.83-30.03-.92-8.86,8.27-9.04,22.19-.54,30.69l22.63,22.63c8.34,8.34,21.84,8.33,30.17,0Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m298.29,341.19c8.33-8.33,8.34-21.83,0-30.17l-22.23-22.23c-8.19-8.19-21.56-8.83-30.03-.92-8.86,8.27-9.04,22.19-.54,30.69l22.63,22.63c8.34,8.34,21.84,8.33,30.17,0Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m346.38,293.11c8.33-8.33,8.34-21.83,0-30.17l-22.23-22.23c-8.19-8.19-21.56-8.83-30.03-.92-8.86,8.27-9.04,22.19-.54,30.69l22.63,22.63c8.34,8.34,21.84,8.33,30.17,0Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m394.46,245.02c8.33-8.33,8.34-21.83,0-30.17l-22.23-22.23c-8.19-8.19-21.56-8.83-30.03-.92-8.86,8.27-9.04,22.19-.54,30.69l22.63,22.63c8.34,8.34,21.84,8.33,30.17,0Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m441.84,197.65c8.33-8.33,8.34-21.83,0-30.17l-22.23-22.23c-8.19-8.19-21.56-8.83-30.03-.92-8.86,8.27-9.04,22.19-.54,30.69l22.63,22.63c8.34,8.34,21.84,8.33,30.17,0Z"
            fill={"#ffffff"}
          />
          <circle
            className="cls-1"
            cx="345.77"
            cy="101.71"
            r="22.21"
            fill={"#ffffff"}
          />
        </g>
        <path
          className="cls-1"
          d="m485.31,344.19c0-11.78-9.54-21.33-21.33-21.33h-92c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h92c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m485.31,404.19c0-11.78-9.54-21.33-21.33-21.33h-92c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h92c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m485.31,465.19c0-11.78-9.54-21.33-21.33-21.33h-92c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h92c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const PulseCategorySVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m149.33,266h-64c-47.13,0-85.33,38.21-85.33,85.33v64c0,47.13,38.21,85.33,85.33,85.33h64c47.13,0,85.33-38.21,85.33-85.33v-64c0-47.13-38.21-85.33-85.33-85.33Zm42.67,149.33c0,23.56-19.1,42.67-42.67,42.67h-64c-23.56,0-42.67-19.1-42.67-42.67v-64c0-23.56,19.1-42.67,42.67-42.67h64c23.56,0,42.67,19.1,42.67,42.67v64Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m142.11,340.74c0-7.74-6.27-14.03-14.03-14.03h-21.05c-7.74,0-14.03,6.29-14.03,14.03s6.29,14.03,14.03,14.03h21.05c7.76,0,14.03-6.29,14.03-14.03Z"
          fill={"#ffffff"}
        />
      </g>
      <g>
        <path
          className="cls-1"
          d="m149.33,0h-64C38.21,0,0,38.21,0,85.33v64c0,47.13,38.21,85.33,85.33,85.33h64c47.13,0,85.33-38.21,85.33-85.33v-64C234.67,38.21,196.46,0,149.33,0Zm42.67,149.33c0,23.56-19.1,42.67-42.67,42.67h-64c-23.56,0-42.67-19.1-42.67-42.67v-64c0-23.56,19.1-42.67,42.67-42.67h64c23.56,0,42.67,19.1,42.67,42.67v64Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m142.11,74.74c0-7.74-6.27-14.03-14.03-14.03h-21.05c-7.74,0-14.03,6.29-14.03,14.03s6.29,14.03,14.03,14.03h21.05c7.76,0,14.03-6.29,14.03-14.03Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m452.11,79.74c0-7.74-6.27-14.03-14.03-14.03h-141.05c-7.74,0-14.03,6.29-14.03,14.03s6.29,14.03,14.03,14.03h141.05c7.76,0,14.03-6.29,14.03-14.03Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m452.11,160.74c0-7.74-6.27-14.03-14.03-14.03h-141.05c-7.74,0-14.03,6.29-14.03,14.03s6.29,14.03,14.03,14.03h141.05c7.76,0,14.03-6.29,14.03-14.03Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m452.11,340.74c0-7.74-6.27-14.03-14.03-14.03h-141.05c-7.74,0-14.03,6.29-14.03,14.03s6.29,14.03,14.03,14.03h141.05c7.76,0,14.03-6.29,14.03-14.03Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m452.11,421.74c0-7.74-6.27-14.03-14.03-14.03h-141.05c-7.74,0-14.03,6.29-14.03,14.03s6.29,14.03,14.03,14.03h141.05c7.76,0,14.03-6.29,14.03-14.03Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const ItemApprovalLevelSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <path
        className="cls-1"
        d="m293.89,87.38c0-7.74-6.27-14.03-14.03-14.03h-71.05c-7.74,0-14.03,6.29-14.03,14.03s6.29,14.03,14.03,14.03h71.05c7.76,0,14.03-6.29,14.03-14.03Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m210.25,448h-124.91c-23.56,0-42.67-19.1-42.67-42.67V85.33c0-23.56,19.1-42.67,42.67-42.67h318c23.56,0,42.67,19.1,42.67,42.67v120.42c0,11.78,9.55,21.33,21.33,21.33h0c11.78,0,21.33-9.55,21.33-21.33v-120.42c0-47.13-38.21-85.33-85.33-85.33H85.33C38.21,0,0,38.21,0,85.33v320c0,47.13,38.21,85.33,85.33,85.33h124.91c11.78,0,21.33-9.55,21.33-21.33h0c0-11.78-9.55-21.33-21.33-21.33Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m403.33,254.06h-64c-47.13,0-85.33,38.21-85.33,85.33v64c0,47.13,38.21,85.33,85.33,85.33h64c47.13,0,85.33-38.21,85.33-85.33v-64c0-47.13-38.21-85.33-85.33-85.33Zm42.67,149.33c0,23.56-19.1,42.67-42.67,42.67h-64c-23.56,0-42.67-19.1-42.67-42.67v-64c0-23.56,19.1-42.67,42.67-42.67h64c23.56,0,42.67,19.1,42.67,42.67v64Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m401.89,343.08l-37.94,37.94c-1.33,1.35-3.48,1.38-4.87.1l-18.83-17.26c-6.93-6.35-17.72-5.88-24.07,1.06-6.35,6.93-5.89,17.72,1.06,24.07l18.83,17.26c7.22,6.63,16.32,9.92,25.4,9.92,9.63,0,19.24-3.71,26.58-11.04l37.94-37.94c6.66-6.66,6.66-17.43,0-24.09-6.66-6.66-17.43-6.66-24.09,0v-.02Z"
        fill={"#ffffff"}
      />
    </g>
  </svg>
);

export const FinanceSVG = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Outline"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    style={{ marginRight: 15 }}
  >
    <path
      d="M16,23c0,.552-.447,1-1,1H6c-2.757,0-5-2.243-5-5V5C1,2.243,3.243,0,6,0h4.515c1.869,0,3.627,.728,4.95,2.05l3.484,3.486c.271,.271,.523,.568,.748,.883,.321,.449,.217,1.074-.232,1.395-.449,.32-1.075,.217-1.395-.233-.161-.225-.341-.438-.534-.63l-3.485-3.486c-.318-.318-.671-.587-1.051-.805V7c0,.551,.448,1,1,1h3c.553,0,1,.448,1,1s-.447,1-1,1h-3c-1.654,0-3-1.346-3-3V2.023c-.16-.015-.322-.023-.485-.023H6c-1.654,0-3,1.346-3,3v14c0,1.654,1.346,3,3,3H15c.553,0,1,.448,1,1Zm5.685-6.733l-3.041-.507c-.373-.062-.644-.382-.644-.76,0-.551,.448-1,1-1h2.268c.356,0,.688,.192,.867,.5,.275,.478,.885,.641,1.366,.365,.478-.277,.642-.888,.364-1.366-.534-.925-1.53-1.5-2.598-1.5h-.268v-1c0-.552-.447-1-1-1s-1,.448-1,1v1c-1.654,0-3,1.346-3,3,0,1.36,.974,2.51,2.315,2.733l3.041,.507c.373,.062,.644,.382,.644,.76,0,.551-.448,1-1,1h-2.268c-.356,0-.688-.192-.867-.5-.275-.479-.886-.642-1.366-.365-.478,.277-.642,.888-.364,1.366,.534,.925,1.53,1.499,2.598,1.499h.268v1c0,.552,.447,1,1,1s1-.448,1-1v-1c1.654,0,3-1.346,3-3,0-1.36-.974-2.51-2.315-2.733Zm-14.185-1.267h5.5c.553,0,1-.448,1-1s-.447-1-1-1H7.5c-1.378,0-2.5,1.122-2.5,2.5v2c0,1.378,1.122,2.5,2.5,2.5h5.5c.553,0,1-.448,1-1s-.447-1-1-1H7.5c-.276,0-.5-.224-.5-.5v-2c0-.276,.224-.5,.5-.5Zm-1.5-4h2c.552,0,1-.448,1-1s-.448-1-1-1h-2c-.552,0-1,.448-1,1s.448,1,1,1Zm0-4h2c.552,0,1-.448,1-1s-.448-1-1-1h-2c-.552,0-1,.448-1,1s.448,1,1,1Z"
      fill={"#ffffff"}
    />
  </svg>
);

export const PaymentSummarySVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <path
        className="cls-1"
        d="m106.67,0h213.33c58.91,0,106.67,47.76,106.67,106.67v49.08c0,11.78-9.55,21.33-21.33,21.33h0c-11.78,0-21.33-9.55-21.33-21.33v-49.08c0-35.35-28.65-64-64-64H106.67c-35.35,0-64,28.65-64,64v298.67c0,35.35,28.65,64,64,64h191.53c11.78,0,21.33,9.55,21.33,21.33h0c0,11.78-9.55,21.33-21.33,21.33H106.67c-58.91,0-106.67-47.76-106.67-106.67V106.67C0,47.76,47.76,0,106.67,0Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m441.39,341.23l-64.87-10.82c-7.96-1.32-13.74-8.15-13.74-16.21,0-11.75,9.56-21.33,21.33-21.33h48.38c7.59,0,14.68,4.1,18.5,10.67,5.87,10.2,18.88,13.67,29.14,7.79,10.2-5.91,13.7-18.94,7.77-29.14-11.39-19.73-32.64-32-55.42-32h-5.72v-21.33c0-11.78-9.54-21.33-21.33-21.33s-21.33,9.56-21.33,21.33v21.33c-35.29,0-64,28.71-64,64,0,29.01,20.78,53.55,49.39,58.3l64.87,10.82c7.96,1.32,13.74,8.15,13.74,16.21,0,11.75-9.56,21.33-21.33,21.33h-48.38c-7.59,0-14.68-4.1-18.5-10.67-5.87-10.22-18.9-13.7-29.14-7.79-10.2,5.91-13.7,18.94-7.77,29.14,11.39,19.73,32.64,31.98,55.42,31.98h5.72v21.33c0,11.78,9.54,21.33,21.33,21.33s21.33-9.56,21.33-21.33v-21.33c35.29,0,64-28.71,64-64,0-29.01-20.78-53.55-49.39-58.3v.02Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m334.98,139.62c0-11.78-9.54-21.33-21.33-21.33H111.65c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h202c11.8,0,21.33-9.56,21.33-21.33Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m284.98,328.62c0-11.78-9.54-21.33-21.33-21.33H111.65c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h152c11.8,0,21.33-9.56,21.33-21.33Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m322.98,232.62c0-11.78-9.54-21.33-21.33-21.33H111.65c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h190c11.8,0,21.33-9.56,21.33-21.33Z"
        fill={"#ffffff"}
      />
    </g>
  </svg>
);

export const PaymentRequestSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <path
        className="cls-1"
        d="m259.76,208.18l-64.87-10.82c-7.96-1.32-13.74-8.15-13.74-16.21,0-11.75,9.56-21.33,21.33-21.33h48.38c7.59,0,14.68,4.1,18.5,10.67,5.87,10.2,18.88,13.67,29.14,7.79,10.2-5.91,13.7-18.94,7.77-29.14-11.39-19.73-32.64-32-55.42-32h-5.72v-21.33c0-11.78-9.54-21.33-21.33-21.33s-21.33,9.56-21.33,21.33v21.33c-35.29,0-64,28.71-64,64,0,29.01,20.78,53.55,49.39,58.3l64.87,10.82c7.96,1.32,13.74,8.15,13.74,16.21,0,11.75-9.56,21.33-21.33,21.33h-48.38c-7.59,0-14.68-4.1-18.5-10.67-5.87-10.22-18.9-13.7-29.14-7.79-10.2,5.91-13.7,18.94-7.77,29.14,11.39,19.73,32.64,31.98,55.42,31.98h5.72v21.33c0,11.78,9.54,21.33,21.33,21.33s21.33-9.56,21.33-21.33v-21.33c35.29,0,64-28.71,64-64,0-29.01-20.78-53.55-49.39-58.3v.02Z"
        fill={"#fff"}
      />
      <path
        className="cls-1"
        d="m223.8,0C100.2,0,0,100.2,0,223.8s100.2,223.8,223.8,223.8,223.8-100.2,223.8-223.8S347.4,0,223.8,0Zm0,409.56c-102.59,0-185.75-83.17-185.75-185.75S121.21,38.05,223.8,38.05s185.75,83.17,185.75,185.75-83.17,185.75-185.75,185.75Z"
        fill={"#fff"}
      />
      <path
        className="cls-1"
        d="m499.17,458.01c0-11.78-9.54-21.33-21.33-21.33h-132c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h132c11.8,0,21.33-9.56,21.33-21.33Z"
        fill={"#fff"}
      />
      <path
        className="cls-1"
        d="m494.88,470.71c7.24-9.29,5.6-22.69-3.7-29.94l-33.12-25.83c-9.29-7.24-22.7-5.58-29.94,3.7-7.24,9.29-5.58,22.7,3.7,29.94l33.12,25.83c9.3,7.25,22.7,5.58,29.94-3.7Z"
        fill={"#fff"}
      />
      <path
        className="cls-1"
        d="m458.06,500.41l33.12-25.83c9.29-7.24,10.95-20.66,3.7-29.94-7.24-9.29-20.66-10.95-29.94-3.7l-33.12,25.83c-9.3,7.25-10.95,20.66-3.7,29.94,7.24,9.29,20.64,10.96,29.94,3.7Z"
        fill={"#fff"}
      />
    </g>
  </svg>
);

export const MaterialRequestSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m262.18,24.99L24.99,272.18c-33.32,33.32-33.32,87.35,0,120.68l85.25,85.25c33.32,33.32,87.35,33.32,120.68,0l237.19-247.19c33.32-33.32,33.32-87.35,0-120.68l-85.25-85.25c-33.32-33.32-87.35-33.32-120.68,0Zm175.76,115.42c16.66,16.66,16.66,43.68,0,60.34l-237.19,247.19c-16.66,16.66-43.68,16.66-60.34,0l-85.25-85.25c-16.66-16.66-16.66-43.68,0-60.34L292.35,55.16c16.66-16.66,43.68-16.66,60.34,0l85.25,85.25Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m348.95,351.52c8.33-8.33,8.34-21.83,0-30.17l-162.23-162.23c-8.19-8.19-21.56-8.83-30.03-.92-8.86,8.27-9.04,22.19-.54,30.69l162.63,162.63c8.34,8.34,21.84,8.33,30.17,0Z"
          fill={"#ffffff"}
        />
        <circle
          className="cls-1"
          cx="331.59"
          cy="165.59"
          r="32.15"
          fill={"#ffffff"}
        />
        <circle
          className="cls-1"
          cx="121.79"
          cy="329.9"
          r="32.15"
          fill={"#ffffff"}
        />
        <circle
          className="cls-1"
          cx="220.2"
          cy="340.87"
          r="32.15"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m490.59,439.27c0-11.78-9.54-21.33-21.33-21.33h-132c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h132c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m486.3,451.97c7.24-9.29,5.6-22.69-3.7-29.94l-33.12-25.83c-9.29-7.24-22.7-5.58-29.94,3.7-7.24,9.29-5.58,22.7,3.7,29.94l33.12,25.83c9.3,7.25,22.7,5.58,29.94-3.7Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m449.48,481.67l33.12-25.83c9.29-7.24,10.95-20.66,3.7-29.94-7.24-9.29-20.66-10.95-29.94-3.7l-33.12,25.83c-9.3,7.25-10.95,20.66-3.7,29.94,7.24,9.29,20.64,10.96,29.94,3.7Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const HumanResourceSVG = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Outline"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    style={{ marginRight: 15 }}
  >
    <path
      d="M5.5,7c1.93,0,3.5-1.57,3.5-3.5S7.43,0,5.5,0,2,1.57,2,3.5s1.57,3.5,3.5,3.5Zm0-5c.827,0,1.5,.673,1.5,1.5s-.673,1.5-1.5,1.5-1.5-.673-1.5-1.5,.673-1.5,1.5-1.5Zm4.5,8c-.827,0-1.5,.673-1.5,1.5,0,.328,.104,.639,.299,.899,.332,.441,.243,1.068-.199,1.4-.18,.135-.391,.201-.6,.201-.304,0-.604-.138-.8-.399-.458-.61-.701-1.336-.701-2.101,0-1.93,1.57-3.5,3.5-3.5,1.095,0,2.142,.523,2.8,1.399,.332,.442,.242,1.069-.199,1.4-.443,.332-1.068,.242-1.4-.199-.286-.382-.724-.601-1.2-.601Zm4.5-3c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5-3.5,1.57-3.5,3.5,1.57,3.5,3.5,3.5Zm0-5c.827,0,1.5,.673,1.5,1.5s-.673,1.5-1.5,1.5-1.5-.673-1.5-1.5,.673-1.5,1.5-1.5Zm8.196,17.134l-.974-.562c.166-.497,.278-1.019,.278-1.572s-.111-1.075-.278-1.572l.974-.562c.478-.276,.642-.888,.366-1.366-.277-.479-.887-.644-1.366-.366l-.973,.562c-.705-.794-1.644-1.375-2.723-1.594v-1.101c0-.552-.448-1-1-1s-1,.448-1,1v1.101c-1.079,.22-2.018,.801-2.723,1.594l-.973-.562c-.48-.277-1.09-.113-1.366,.366-.276,.479-.112,1.09,.366,1.366l.974,.562c-.166,.497-.278,1.019-.278,1.572s.111,1.075,.278,1.572l-.974,.562c-.478,.276-.642,.888-.366,1.366,.186,.321,.521,.5,.867,.5,.169,0,.341-.043,.499-.134l.973-.562c.705,.794,1.644,1.375,2.723,1.594v1.101c0,.552,.448,1,1,1s1-.448,1-1v-1.101c1.079-.22,2.018-.801,2.723-1.594l.973,.562c.158,.091,.33,.134,.499,.134,.346,0,.682-.179,.867-.5,.276-.479,.112-1.09-.366-1.366Zm-5.696,.866c-1.654,0-3-1.346-3-3s1.346-3,3-3,3,1.346,3,3-1.346,3-3,3ZM5,10c-1.654,0-3,1.346-3,3,0,.552-.448,1-1,1s-1-.448-1-1c0-2.757,2.243-5,5-5,.552,0,1,.448,1,1s-.448,1-1,1Zm5,7c0,.552-.448,1-1,1-1.654,0-3,1.346-3,3,0,.552-.448,1-1,1s-1-.448-1-1c0-2.757,2.243-5,5-5,.552,0,1,.448,1,1Z"
      fill={"#ffffff"}
    />
  </svg>
);

export const DepartmentsSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m149.33,330.46h-64c-47.13,0-85.33,38.21-85.33,85.33v7c0,47.13,38.21,85.33,85.33,85.33h64c47.13,0,85.33-38.21,85.33-85.33v-7c0-47.13-38.21-85.33-85.33-85.33Zm42.67,92.33c0,23.56-19.1,42.67-42.67,42.67h-64c-23.56,0-42.67-19.1-42.67-42.67v-7c0-23.56,19.1-42.67,42.67-42.67h64c23.56,0,42.67,19.1,42.67,42.67v7Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m420.33,330.46h-64c-47.13,0-85.33,38.21-85.33,85.33v7c0,47.13,38.21,85.33,85.33,85.33h64c47.13,0,85.33-38.21,85.33-85.33v-7c0-47.13-38.21-85.33-85.33-85.33Zm42.67,92.33c0,23.56-19.1,42.67-42.67,42.67h-64c-23.56,0-42.67-19.1-42.67-42.67v-7c0-23.56,19.1-42.67,42.67-42.67h64c23.56,0,42.67,19.1,42.67,42.67v7Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m289.58,0h-64c-47.13,0-85.33,38.21-85.33,85.33v7c0,47.13,38.21,85.33,85.33,85.33h64c47.13,0,85.33-38.21,85.33-85.33v-7c0-47.13-38.21-85.33-85.33-85.33Zm42.67,92.33c0,23.56-19.1,42.67-42.67,42.67h-64c-23.56,0-42.67-19.1-42.67-42.67v-7c0-23.56,19.1-42.67,42.67-42.67h64c23.56,0,42.67,19.1,42.67,42.67v7Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m409.91,241.79c0-11.78-9.54-21.33-21.33-21.33H121.58c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h267c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m257.58,251c11.78,0,21.33-9.54,21.33-21.33v-72c0-11.78-9.56-21.33-21.33-21.33s-21.33,9.56-21.33,21.33v72c0,11.8,9.56,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m388.62,308.13c11.78,0,21.33-9.54,21.33-21.33v-42c0-11.78-9.56-21.33-21.33-21.33s-21.33,9.56-21.33,21.33v42c0,11.8,9.56,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m117.62,305.13c11.78,0,21.33-9.54,21.33-21.33v-42c0-11.78-9.56-21.33-21.33-21.33s-21.33,9.56-21.33,21.33v42c0,11.8,9.56,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const DesignationsSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m423.33,50.17h-66.88v42.67h66.88c23.56,0,42.67,19.1,42.67,42.67v204c0,23.56-19.1,42.67-42.67,42.67H85.33c-23.56,0-42.67-19.1-42.67-42.67v-204c0-23.56,19.1-42.67,42.67-42.67h35.44v-42.67h-35.44C38.21,50.17,0,88.37,0,135.5v204c0,47.13,38.21,85.33,85.33,85.33h338c47.13,0,85.33-38.21,85.33-85.33v-204c0-47.13-38.21-85.33-85.33-85.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m311.33,0h-114c-47.13,0-85.33,27.21-85.33,74.33v-5c0,47.13,38.21,74.33,85.33,74.33h114c47.13,0,85.33-27.21,85.33-74.33v5C396.67,27.21,358.46,0,311.33,0Zm42.67,69.33c0,23.56-19.1,31.67-42.67,31.67h-114c-23.56,0-42.67-8.1-42.67-31.67v5c0-23.56,19.1-31.67,42.67-31.67h114c23.56,0,42.67,8.1,42.67,31.67v-5Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m162.78,264.12c27.17,0,49.27-22.1,49.27-49.27s-22.1-49.27-49.27-49.27-49.27,22.1-49.27,49.27,22.1,49.27,49.27,49.27Zm0-70.39c11.64,0,21.12,9.47,21.12,21.12s-9.47,21.12-21.12,21.12-21.12-9.47-21.12-21.12,9.47-21.12,21.12-21.12Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m162.34,302.95c-23.29,0-42.23,18.95-42.23,42.23,0,7.77-6.31,14.08-14.08,14.08s-14.08-6.31-14.08-14.08c0-38.81,31.58-70.39,70.39-70.39,7.77,0,14.08,6.31,14.08,14.08s-6.31,14.08-14.08,14.08Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m148.92,288.98c0-7.77,6.31-14.08,14.08-14.08,38.81,0,70.39,31.58,70.39,70.39,0,7.77-6.31,14.08-14.08,14.08s-14.08-6.31-14.08-14.08c0-23.29-18.95-42.23-42.23-42.23-7.77,0-14.08-6.31-14.08-14.08Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m421.33,224.85c0-11.78-9.54-21.33-21.33-21.33h-92c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h92c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m421.33,308.85c0-11.78-9.54-21.33-21.33-21.33h-92c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h92c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const EmployeesSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m107.33,149.33c41.17,0,74.67-33.49,74.67-74.67S148.51,0,107.33,0,32.67,33.49,32.67,74.67s33.49,74.67,74.67,74.67Zm0-106.67c17.64,0,32,14.36,32,32s-14.36,32-32,32-32-14.36-32-32,14.36-32,32-32Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m106.67,208.17c-35.29,0-64,28.71-64,64,0,11.78-9.56,21.33-21.33,21.33S0,283.94,0,272.17c0-58.82,47.85-106.67,106.67-106.67,11.78,0,21.33,9.56,21.33,21.33s-9.56,21.33-21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m232.11,282.41c41.17,0,74.67-33.49,74.67-74.67s-33.49-74.67-74.67-74.67-74.67,33.49-74.67,74.67,33.49,74.67,74.67,74.67Zm0-106.67c17.64,0,32,14.36,32,32s-14.36,32-32,32-32-14.36-32-32,14.36-32,32-32Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m357.45,149.53c41.17,0,74.67-33.49,74.67-74.67S398.63.2,357.45.2s-74.67,33.49-74.67,74.67,33.49,74.67,74.67,74.67Zm0-106.67c17.64,0,32,14.36,32,32s-14.36,32-32,32-32-14.36-32-32,14.36-32,32-32Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m338.12,187.03c0-11.78,9.56-21.33,21.33-21.33,58.82,0,106.67,47.85,106.67,106.67,0,11.78-9.56,21.33-21.33,21.33-11.78,0-21.33-9.56-21.33-21.33,0-35.29-28.71-64-64-64-11.78,0-21.33-9.56-21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m231.05,345.33c-35.29,0-64,28.71-64,64,0,11.78-9.56,21.33-21.33,21.33s-21.33-9.56-21.33-21.33c0-58.82,47.85-106.67,106.67-106.67,11.78,0,21.33,9.56,21.33,21.33s-9.56,21.33-21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m210.71,324.17c0-11.78,9.56-21.33,21.33-21.33,58.82,0,106.67,47.85,106.67,106.67,0,11.78-9.56,21.33-21.33,21.33-11.78,0-21.33-9.56-21.33-21.33,0-35.29-28.71-64-64-64-11.78,0-21.33-9.56-21.33-21.33Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const ShiftsSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m256,0C114.62,0,0,114.62,0,256s114.62,256,256,256,256-114.62,256-256S397.38,0,256,0Zm0,468.48c-117.35,0-212.48-95.13-212.48-212.48S138.65,43.52,256,43.52s212.48,95.13,212.48,212.48-95.13,212.48-212.48,212.48Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m491.05,256c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m95.05,256c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m256,94.57c11.78,0,21.33-9.54,21.33-21.33v-32c0-11.78-9.56-21.33-21.33-21.33s-21.33,9.56-21.33,21.33v32c0,11.8,9.56,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m256,487.57c11.78,0,21.33-9.54,21.33-21.33v-32c0-11.78-9.56-21.33-21.33-21.33s-21.33,9.56-21.33,21.33v32c0,11.8,9.56,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m343.74,206.81c-7.17-9.34-20.55-11.12-29.91-3.94l-69.19,37.74c-9.34,7.17-11.11,20.57-3.94,29.91,7.17,9.34,20.57,11.11,29.91,3.94l69.19-37.74c9.36-7.18,11.11-20.57,3.94-29.91Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m257.62,278.87c11.78,0,21.33-9.54,21.33-21.33l-1-112c0-11.78-9.56-21.33-21.33-21.33s-21.33,9.56-21.33,21.33l1,112c0,11.8,9.56,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const HolidaysSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m69.81,438.08c31.86-18.56,66.8-28.44,102.98-33.62,22.22-3.18,44.73-4.31,67.13-6.18,2.81-.24,4.48-.69,5.58-3.69,18.76-51.42,37.65-102.79,56.51-154.18.17-.45.24-.94.5-1.99-8.81-3.2-17.59-6.38-26.8-9.73-1.03,4.56-1.83,8.51-2.82,12.4-2.28,8.96-9.97,14.13-18.1,12.26-8.89-2.04-13.56-9.92-11.48-19.41,1.12-5.09,2.26-10.18,3.5-15.77-28.83-10.47-57.48-20.87-86.44-31.38-2.07,4.84-3.92,9.34-5.91,13.78-3.94,8.79-12.2,12.43-20.27,9.03-7.82-3.29-11.26-11.7-7.92-20.37,17.6-45.6,47.51-80.6,90.35-104.35,31.8-17.63,66.01-25.86,102.26-24.52,43.57,1.61,82.66,16.07,116.78,43.34,34.41,27.5,57.16,62.79,68.46,105.29,2.76,10.4,3.78,21.26,5.63,31.91.28,1.62.68,3.22,1.03,4.83v25.39c-.32,1.46-.82,2.91-.94,4.39-1.32,16.6-4.82,32.73-10.25,48.45-3.27,9.45-11.11,13.86-19.66,11.11-8.41-2.71-12.16-10.97-9.31-20.57,1.33-4.46,2.7-8.91,4.12-13.62-29.42-10.67-58.25-21.13-87.31-31.67-2.68,5.18-5.08,10-7.65,14.74-4.54,8.38-13.25,11.36-20.98,7.29-7.5-3.95-10.11-12.67-6.18-20.96,1.78-3.77,3.77-7.44,5.88-11.58-9.23-3.34-18.03-6.53-27.13-9.83-18.39,50.1-36.61,99.73-54.69,148.98,20.05,2.54,39.24,4.35,58.22,7.51,34.01,5.67,66.87,15.25,96.93,32.71m-61.73-207.59c.47-.8.79-1.2.96-1.66,9.03-25.5,15.08-51.59,15.08-78.81,0-13.44-1.04-26.75-7.2-39.05-5.39-10.76-12.95-13.9-23.76-8.5-7.15,3.57-13.98,8.33-19.89,13.72-15.32,13.94-26.47,31.16-35.76,49.52-5.46,10.8-10.13,22.01-15.39,33.57,29.2,10.61,57.42,20.86,85.96,31.22Zm45.12-103.56c2.33,19.61,2.15,38.84-1.57,57.74-3.73,18.95-8.71,37.66-13.22,56.84,25.94,9.4,52.51,19.04,79.24,28.73,4.82-53.75-21.94-112.83-64.45-143.31Zm-239.4,33.03c27.25,9.9,53.53,19.44,80.12,29.09,13.95-36.8,32.15-70.48,60.39-98.1-58.06-.07-104.51,22.71-140.51,69.01Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m52.8,128.22c1.86-6.07-1.44-9.69-8.06-13.38-5.5-3.07-9.06-3.24-13.76.16-2.86,2.06-6.05,3.74-9.25,5.24-7.25,3.4-15.44.88-19.45-5.77-4.19-6.94-2.52-15.48,4.31-20.2,4.3-2.97,9.12-5.19,13.4-8.18,1.4-.98,2.23-3.24,2.63-5.07.38-1.75-.66-3.84-.17-5.51,1.98-6.68-1.49-9.82-6.98-12.21-2.92-1.27-5.66-3.05-8.31-4.84C0,53.64-2,45.17,2.18,38c4.1-7.03,12.63-9.49,20.28-5.62,4.07,2.06,7.94,4.49,11.9,6.76.73.42,1.43.92,2.2,1.25,2.89,1.26,16.16-7.21,16.21-10.37.07-4.74-.07-9.48.05-14.21C53.02,6.64,59.36.06,67.9,0c8.53-.06,15.06,6.53,15.3,15.6.13,4.73-.2,9.49.17,14.2.12,1.59,1.5,3.33,2.77,4.5,1.18,1.09,3.38,1.16,4.44,2.31,5.42,5.88,10.46,3.68,15.78-.14,2.59-1.86,5.47-3.41,8.39-4.69,7.24-3.17,15.43-.3,19.24,6.5,3.85,6.88,2.07,15.19-4.6,19.74-4.32,2.95-9.13,5.18-13.41,8.16-1.4.98-2.25,3.24-2.61,5.07-.38,1.92.7,4.19.16,6.02-1.8,6,.99,8.95,6.09,11.19,3.38,1.48,6.56,3.53,9.6,5.64,6.87,4.77,8.7,13.13,4.63,20.14-3.99,6.87-12.37,9.48-19.8,5.87-4.25-2.06-8.25-4.62-12.36-6.96-.73-.42-1.43-.92-2.2-1.26-2.93-1.28-16.18,7.14-16.23,10.35-.07,4.91.1,9.82-.06,14.72-.29,8.79-6.73,15.23-15.07,15.3-8.36.07-14.9-6.32-15.31-15.06-.12-2.53-.02-5.07-.02-8.99Zm30.4-51.95c.07-8.29-6.76-15.25-15.07-15.33-8.28-.08-15.25,6.77-15.32,15.07-.07,8.29,6.78,15.26,15.06,15.33,8.3.06,15.25-6.77,15.32-15.07Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const WeeklyScheduleSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m377.1,106c11.78,0,21.33-9.55,21.33-21.33V21.33c0-11.78-9.55-21.33-21.33-21.33s-21.33,9.55-21.33,21.33v63.33c0,11.78,9.55,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m296.1,106c11.78,0,21.33-9.55,21.33-21.33V21.33c0-11.78-9.55-21.33-21.33-21.33s-21.33,9.55-21.33,21.33v63.33c0,11.78,9.55,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m222.1,106c11.78,0,21.33-9.55,21.33-21.33V21.33c0-11.78-9.55-21.33-21.33-21.33s-21.33,9.55-21.33,21.33v63.33c0,11.78,9.55,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m144.1,106c11.78,0,21.33-9.55,21.33-21.33V21.33c0-11.78-9.55-21.33-21.33-21.33s-21.33,9.55-21.33,21.33v63.33c0,11.78,9.55,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m140.57,172.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m241.57,172.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m342.57,172.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m440.57,172.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m421.53,381.58c0-11.78-9.54-21.33-21.33-21.33h-35c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h35c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m140.57,253.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m241.57,253.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m140.57,334.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m220.57,334.08c0-11.78-9.54-21.33-21.33-21.33h-11c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h11c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m140.57,405.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m220.57,405.08c0-11.78-9.54-21.33-21.33-21.33h-11c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h11c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m220.23,464.29H85.33c-23.56,0-42.67-19.1-42.67-42.67V117.63c0-23.56,19.1-42.67,42.67-42.67h340c23.56,0,42.67,19.1,42.67,42.67v105.12c0,11.78,9.55,21.33,21.33,21.33h0c11.78,0,21.33-9.55,21.33-21.33v-105.12c0-47.13-38.21-85.33-85.33-85.33H85.33C38.21,32.29,0,70.5,0,117.63v304c0,47.13,38.21,85.33,85.33,85.33h134.89c11.78,0,21.33-9.55,21.33-21.33h0c0-11.78-9.55-21.33-21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m371.12,270.68c55.27,0,100.08,44.81,100.08,100.08s-44.81,100.08-100.08,100.08-100.08-44.81-100.08-100.08,44.81-100.08,100.08-100.08m0-38c-36.88,0-71.56,14.36-97.64,40.44-26.08,26.08-40.44,60.75-40.44,97.64s14.36,71.56,40.44,97.64c26.08,26.08,60.75,40.44,97.64,40.44s71.56-14.36,97.64-40.44c26.08-26.08,40.44-60.75,40.44-97.64s-14.36-71.56-40.44-97.64c-26.08-26.08-60.75-40.44-97.64-40.44h0Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m364.19,402.58c11.78,0,21.33-9.54,21.33-21.33v-52c0-11.78-9.56-21.33-21.33-21.33s-21.33,9.56-21.33,21.33v52c0,11.8,9.56,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const AttendenceSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m377.1,106c11.78,0,21.33-9.55,21.33-21.33V21.33c0-11.78-9.55-21.33-21.33-21.33s-21.33,9.55-21.33,21.33v63.33c0,11.78,9.55,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m296.1,106c11.78,0,21.33-9.55,21.33-21.33V21.33c0-11.78-9.55-21.33-21.33-21.33s-21.33,9.55-21.33,21.33v63.33c0,11.78,9.55,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m222.1,106c11.78,0,21.33-9.55,21.33-21.33V21.33c0-11.78-9.55-21.33-21.33-21.33s-21.33,9.55-21.33,21.33v63.33c0,11.78,9.55,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m144.1,106c11.78,0,21.33-9.55,21.33-21.33V21.33c0-11.78-9.55-21.33-21.33-21.33s-21.33,9.55-21.33,21.33v63.33c0,11.78,9.55,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m140.57,172.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m241.57,172.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m342.57,172.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m440.57,172.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m374.58,500.68c8.33-8.33,8.34-21.83,0-30.17l-44.75-44.75c-8.33-8.33-21.84-8.33-30.17,0s-8.33,21.84,0,30.17l44.75,44.75c8.34,8.34,21.84,8.33,30.17,0Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m140.57,253.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m241.57,253.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m140.57,334.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m140.57,405.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m241.57,334.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m342.57,253.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m342.57,334.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m443.57,253.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m443.57,334.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m241.57,405.08c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m240.23,464.29H85.33c-23.56,0-42.67-19.1-42.67-42.67V117.63c0-23.56,19.1-42.67,42.67-42.67h340c23.56,0,42.67,19.1,42.67,42.67v155.12c0,11.78,9.55,21.33,21.33,21.33h0c11.78,0,21.33-9.55,21.33-21.33V117.63c0-47.13-38.21-85.33-85.33-85.33H85.33C38.21,32.29,0,70.5,0,117.63v304c0,47.13,38.21,85.33,85.33,85.33h154.89c11.78,0,21.33-9.55,21.33-21.33h0c0-11.78-9.55-21.33-21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m348.37,498.9c8.33,8.33,21.83,8.34,30.17,0l126.27-116.27c8.33-8.33,8.33-21.84,0-30.17s-21.84-8.33-30.17,0l-126.27,116.27c-8.34,8.34-8.33,21.84,0,30.17Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const TimesheetSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m182.93,136l-47.51,47.51c-1.66,1.69-4.35,1.75-6.1.13l-23.57-21.61c-8.68-7.96-22.19-7.34-30.14,1.32-7.96,8.68-7.38,22.19,1.32,30.14l23.57,21.61c9.05,8.3,20.44,12.42,31.81,12.42,12.05,0,24.09-4.63,33.28-13.82l47.51-47.51c8.34-8.34,8.34-21.82,0-30.17-8.34-8.34-21.82-8.34-30.17,0v-.02Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m182.93,290.71l-47.51,47.51c-1.66,1.69-4.35,1.73-6.1.13l-23.57-21.61c-8.68-7.96-22.19-7.36-30.14,1.32-7.96,8.68-7.38,22.19,1.32,30.14l23.57,21.61c9.05,8.3,20.44,12.42,31.81,12.42,12.05,0,24.09-4.65,33.28-13.82l47.51-47.51c8.34-8.34,8.34-21.82,0-30.17-8.34-8.34-21.82-8.34-30.17,0v-.02Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m311.01,206.13c0-11.78-9.54-21.33-21.33-21.33h-32c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h32c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
      </g>
      <path
        className="cls-1"
        d="m237.33,490.67c0,11.8-9.56,21.33-21.33,21.33h-109.33c-58.82,0-106.67-47.85-106.67-106.67v-256C0,90.52,47.85,42.67,106.67,42.67h3.65C119.13,17.83,142.85,0,170.67,0h42.67c27.82,0,51.54,17.83,60.35,42.67h3.65c58.82,0,106.67,47.85,106.67,106.67v52c0,11.78-9.54,21.33-21.33,21.33s-21.33-9.56-21.33-21.33v-52c0-35.29-28.71-64-64-64h-21.33c-11.78,0-21.33-9.56-21.33-21.33s-9.58-21.33-21.33-21.33h-42.67c-11.75,0-21.33,9.58-21.33,21.33s-9.56,21.33-21.33,21.33h-21.33c-35.29,0-64,28.71-64,64v256c0,35.29,28.71,64,64,64h109.33c11.78,0,21.33,9.54,21.33,21.33Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m420.99,393.05c0-11.78-9.54-21.33-21.33-21.33h-35c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h35c11.8,0,21.33-9.56,21.33-21.33Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m370.58,282.15c55.27,0,100.08,44.81,100.08,100.08s-44.81,100.08-100.08,100.08-100.08-44.81-100.08-100.08,44.81-100.08,100.08-100.08m0-38c-36.88,0-71.56,14.36-97.64,40.44-26.08,26.08-40.44,60.75-40.44,97.64s14.36,71.56,40.44,97.64c26.08,26.08,60.75,40.44,97.64,40.44s71.56-14.36,97.64-40.44c26.08-26.08,40.44-60.75,40.44-97.64s-14.36-71.56-40.44-97.64c-26.08-26.08-60.75-40.44-97.64-40.44h0Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m363.65,414.05c11.78,0,21.33-9.54,21.33-21.33v-52c0-11.78-9.56-21.33-21.33-21.33s-21.33,9.56-21.33,21.33v52c0,11.8,9.56,21.33,21.33,21.33Z"
        fill={"#ffffff"}
      />
    </g>
  </svg>
);

export const ReportingAnalyticSVG = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Outline"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    style={{ marginRight: 15 }}
  >
    <path
      d="M23,22H5a3,3,0,0,1-3-3V1A1,1,0,0,0,0,1V19a5.006,5.006,0,0,0,5,5H23a1,1,0,0,0,0-2Z"
      fill={"#ffffff"}
    />
    <path
      d="M6,20a1,1,0,0,0,1-1V12a1,1,0,0,0-2,0v7A1,1,0,0,0,6,20Z"
      fill={"#ffffff"}
    />
    <path d="M10,10v9a1,1,0,0,0,2,0V10a1,1,0,0,0-2,0Z" fill={"#ffffff"} />
    <path d="M15,13v6a1,1,0,0,0,2,0V13a1,1,0,0,0-2,0Z" fill={"#ffffff"} />
    <path d="M20,9V19a1,1,0,0,0,2,0V9a1,1,0,0,0-2,0Z" fill={"#ffffff"} />
    <path
      d="M6,9a1,1,0,0,0,.707-.293l3.586-3.586a1.025,1.025,0,0,1,1.414,0l2.172,2.172a3,3,0,0,0,4.242,0l5.586-5.586A1,1,0,0,0,22.293.293L16.707,5.878a1,1,0,0,1-1.414,0L13.121,3.707a3,3,0,0,0-4.242,0L5.293,7.293A1,1,0,0,0,6,9Z"
      fill={"#ffffff"}
    />
  </svg>
);

export const ConsolidateSalesSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <path
        className="cls-1"
        d="m246.93,493.67c-32.6,0-65.18-6.54-96.1-19.62-60.72-25.68-107.81-73.46-132.59-134.56-24.78-61.09-24.29-128.18,1.39-188.9C44.36,92.1,90.03,45.9,148.24,20.5c10.63-4.64,23.01.22,27.65,10.85,4.64,10.63-.22,23.01-10.85,27.65-48.3,21.08-86.21,59.42-106.73,107.96-21.31,50.39-21.72,106.06-1.15,156.76,20.56,50.7,59.64,90.35,110.03,111.66,104.02,43.99,224.44-4.86,268.42-108.88,4.52-10.68,16.84-15.68,27.52-11.16,10.68,4.52,15.68,16.84,11.16,27.52-25.68,60.72-73.46,107.81-134.56,132.59-29.98,12.16-61.4,18.23-92.8,18.23Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m472.79,267.82h-225.82c-11.6,0-21-9.4-21-21V21c0-11.6,9.4-21,21-21,65.93,0,127.91,25.67,174.53,72.29,46.62,46.62,72.29,108.6,72.29,174.53,0,11.6-9.4,21-21,21Zm-204.82-42h182.75c-9.84-96.21-86.54-172.92-182.75-182.75v182.75Z"
        fill={"#ffffff"}
      />
    </g>
  </svg>
);

export const ChannelSalesSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <path
        className="cls-1"
        d="m399.92,140.91c-38.85,0-70.46-31.61-70.46-70.45S361.07,0,399.92,0s70.45,31.61,70.45,70.45-31.61,70.45-70.45,70.45Zm0-98.91c-15.69,0-28.46,12.76-28.46,28.45s12.76,28.45,28.46,28.45,28.45-12.76,28.45-28.45-12.76-28.45-28.45-28.45Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m399.92,509.7c-38.85,0-70.46-31.61-70.46-70.46s31.61-70.45,70.46-70.45,70.45,31.61,70.45,70.45-31.61,70.46-70.45,70.46Zm0-98.91c-15.69,0-28.46,12.76-28.46,28.45s12.76,28.46,28.46,28.46,28.45-12.76,28.45-28.46-12.76-28.45-28.45-28.45Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m357.37,435.35c-3.59,0-7.23-.92-10.55-2.86l-112.59-65.61c-10.02-5.84-13.41-18.7-7.57-28.72,5.84-10.02,18.7-13.41,28.72-7.57l112.59,65.61c10.02,5.84,13.41,18.7,7.57,28.72-3.9,6.69-10.94,10.43-18.16,10.43Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m244.82,181.96c-7.22,0-14.25-3.73-18.16-10.42-5.85-10.02-2.46-22.88,7.55-28.72l112.43-65.61c10.02-5.85,22.88-2.46,28.72,7.55,5.85,10.02,2.46,22.88-7.55,28.72l-112.43,65.61c-3.33,1.94-6.97,2.87-10.57,2.87Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m418.07,320.57c-11.98,0-23.81-3.08-34.53-9.13-16.39-9.25-28.19-24.33-33.24-42.46-5.05-18.13-2.73-37.14,6.52-53.53,9.25-16.39,24.33-28.19,42.46-33.24,18.13-5.04,37.14-2.73,53.53,6.52,16.39,9.25,28.19,24.33,33.24,42.46s2.73,37.14-6.52,53.53c-9.25,16.39-24.33,28.19-42.46,33.24-6.27,1.75-12.66,2.61-19,2.61Zm.15-98.95c-2.56,0-5.14.35-7.67,1.05-7.32,2.04-13.41,6.81-17.15,13.42-3.74,6.62-4.67,14.3-2.64,21.62,2.04,7.32,6.81,13.41,13.42,17.15,6.62,3.74,14.3,4.67,21.62,2.63,7.32-2.04,13.41-6.8,17.15-13.42,3.74-6.62,4.67-14.3,2.64-21.62-2.04-7.32-6.81-13.41-13.42-17.15h0c-4.33-2.44-9.11-3.69-13.94-3.69Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m238.6,273.63c-11.46,0-20.83-9.21-20.99-20.7-.17-11.6,9.1-21.13,20.7-21.3l130.16-1.86c11.59-.18,21.13,9.1,21.3,20.7.17,11.6-9.1,21.13-20.7,21.3l-130.16,1.86c-.1,0-.2,0-.31,0Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m139.78,236.17l-74.75-12.46c-9.17-1.52-15.83-9.39-15.83-18.68,0-13.54,11.01-24.58,24.58-24.58h55.75c8.75,0,16.91,4.72,21.31,12.29,6.76,11.75,21.75,15.76,33.58,8.97,11.75-6.81,15.78-21.83,8.95-33.58-13.13-22.74-37.61-36.87-63.86-36.87h-6.59v-24.58c0-13.57-10.99-24.58-24.58-24.58s-24.58,11.01-24.58,24.58v24.58C33.1,131.26.01,164.35.01,205c0,33.43,23.94,61.7,56.91,67.18l74.75,12.46c9.17,1.52,15.83,9.39,15.83,18.68,0,13.54-11.01,24.58-24.58,24.58h-55.75c-8.75,0-16.91-4.72-21.31-12.29-6.76-11.77-21.78-15.78-33.58-8.97-11.75,6.81-15.78,21.83-8.95,33.58,13.13,22.74,37.61,36.85,63.86,36.85h6.59v24.58c0,13.57,10.99,24.58,24.58,24.58s24.58-11.01,24.58-24.58v-24.58c40.66,0,73.75-33.09,73.75-73.75,0-33.43-23.94-61.7-56.91-67.18v.02Z"
        fill={"#ffffff"}
      />
    </g>
  </svg>
);

export const ConsolidatePulseInventorySVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m271.31,0h-44c-47.13,0-85.33,38.21-85.33,85.33v74c0,47.13,38.21,85.33,85.33,85.33h44c47.13,0,85.33-38.21,85.33-85.33v-74c0-47.13-38.21-85.33-85.33-85.33Zm42.67,159.33c0,23.56-19.1,42.67-42.67,42.67h-44c-23.56,0-42.67-19.1-42.67-42.67v-74c0-23.56,19.1-42.67,42.67-42.67h44c23.56,0,42.67,19.1,42.67,42.67v74Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m281.65,79.67c0-11.78-9.54-21.33-21.33-21.33h-22c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h22c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m281.65,134.67c0-11.78-9.54-21.33-21.33-21.33h-22c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h22c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m129.33,269.6h-44c-47.13,0-85.33,38.21-85.33,85.33v74c0,47.13,38.21,85.33,85.33,85.33h44c47.13,0,85.33-38.21,85.33-85.33v-74c0-47.13-38.21-85.33-85.33-85.33Zm42.67,159.33c0,23.56-19.1,42.67-42.67,42.67h-44c-23.56,0-42.67-19.1-42.67-42.67v-74c0-23.56,19.1-42.67,42.67-42.67h44c23.56,0,42.67,19.1,42.67,42.67v74Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m139.67,349.27c0-11.78-9.54-21.33-21.33-21.33h-22c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h22c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m139.67,404.27c0-11.78-9.54-21.33-21.33-21.33h-22c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h22c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m422.08,269.6h-44c-47.13,0-85.33,38.21-85.33,85.33v74c0,47.13,38.21,85.33,85.33,85.33h44c47.13,0,85.33-38.21,85.33-85.33v-74c0-47.13-38.21-85.33-85.33-85.33Zm42.67,159.33c0,23.56-19.1,42.67-42.67,42.67h-44c-23.56,0-42.67-19.1-42.67-42.67v-74c0-23.56,19.1-42.67,42.67-42.67h44c23.56,0,42.67,19.1,42.67,42.67v74Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m432.42,349.27c0-11.78-9.54-21.33-21.33-21.33h-22c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h22c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m432.42,404.27c0-11.78-9.54-21.33-21.33-21.33h-22c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h22c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m254.04,249.05c-11.78,0-21.33,9.54-21.33,21.33v122c0,11.78,9.56,11.33,21.33,11.33s21.33.44,21.33-11.33v-122c0-11.8-9.56-21.33-21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m266.74,253.33c-9.29-7.24-22.69-5.6-29.94,3.7l-25.83,33.12c-7.24,9.29-5.58,22.7,3.7,29.94,9.29,7.24,22.7,5.58,29.94-3.7l25.83-33.12c7.25-9.3,5.58-22.7-3.7-29.94Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m296.44,290.15l-25.83-33.12c-7.24-9.29-20.66-10.95-29.94-3.7-9.29,7.24-10.95,20.66-3.7,29.94l25.83,33.12c7.25,9.3,20.66,10.95,29.94,3.7,9.29-7.24,10.96-20.64,3.7-29.94Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m333.79,391.93c0-11.78-9.54-21.33-21.33-21.33h-117c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h117c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const ConsolidateCostOfGoodsSoldSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m361.17,222.53h-16.11c-11.78,0-21.33,9.55-21.33,21.33h0c0,11.78,9.55,21.33,21.33,21.33h16.11c23.56,0,42.67,19.1,42.67,42.67v114c0,23.56-19.1,42.67-42.67,42.67h-224c-23.56,0-42.67-19.1-42.67-42.67v-114c0-23.56,19.1-42.67,42.67-42.67h15.83c11.78,0,21.33-9.55,21.33-21.33h0c0-11.78-9.55-21.33-21.33-21.33h-15.83c-47.13,0-85.33,38.21-85.33,85.33v114c0,47.13,38.21,85.33,85.33,85.33h224c47.13,0,85.33-38.21,85.33-85.33v-114c0-47.13-38.21-85.33-85.33-85.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m279.15,230.7l-53.4-8.9c-6.55-1.09-11.31-6.71-11.31-13.34,0-9.67,7.87-17.56,17.56-17.56h39.82c6.25,0,12.08,3.37,15.22,8.78,4.83,8.39,15.54,11.26,23.99,6.41,8.39-4.86,11.27-15.59,6.39-23.99-9.38-16.24-26.86-26.34-45.62-26.34h-4.71v-17.56c0-9.69-7.85-17.56-17.56-17.56s-17.56,7.87-17.56,17.56v17.56c-29.04,0-52.68,23.63-52.68,52.68,0,23.88,17.1,44.07,40.65,47.99l53.4,8.9c6.55,1.09,11.31,6.71,11.31,13.34,0,9.67-7.87,17.56-17.56,17.56h-39.82c-6.25,0-12.08-3.37-15.22-8.78-4.83-8.41-15.56-11.27-23.99-6.41-8.39,4.86-11.27,15.59-6.39,23.99,9.38,16.24,26.86,26.32,45.62,26.32h4.71v17.56c0,9.69,7.85,17.56,17.56,17.56s17.56-7.87,17.56-17.56v-17.56c29.04,0,52.68-23.63,52.68-52.68,0-23.88-17.1-44.07-40.65-47.99v.02Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m447.98,115.31c-31.79,0-57.66-25.86-57.66-57.66S416.19,0,447.98,0s57.66,25.87,57.66,57.66-25.87,57.66-57.66,57.66Zm0-73.31c-8.63,0-15.66,7.02-15.66,15.66s7.02,15.66,15.66,15.66,15.66-7.02,15.66-15.66-7.02-15.66-15.66-15.66Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m333.02,145.74c-7.22,0-14.25-3.73-18.16-10.42-5.85-10.02-2.46-22.88,7.55-28.72l83.33-48.63c10.02-5.85,22.88-2.46,28.72,7.55,5.85,10.02,2.46,22.88-7.55,28.72l-83.33,48.63c-3.33,1.94-6.97,2.87-10.57,2.87Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m57.66,115.31C25.86,115.31,0,89.45,0,57.66S25.86,0,57.66,0s57.66,25.87,57.66,57.66-25.86,57.66-57.66,57.66Zm0-73.31c-8.63,0-15.66,7.02-15.66,15.66s7.02,15.66,15.66,15.66,15.66-7.02,15.66-15.66-7.02-15.66-15.66-15.66Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m172.62,145.74c-3.59,0-7.24-.92-10.56-2.87l-83.33-48.63c-10.02-5.85-13.4-18.7-7.55-28.72,5.85-10.02,18.71-13.4,28.72-7.55l83.33,48.63c10.02,5.85,13.4,18.7,7.55,28.72-3.9,6.69-10.93,10.42-18.16,10.42Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const SettingSVG = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Outline"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    style={{ marginRight: 15 }}
  >
    <path
      d="M12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z"
      fill={"#ffffff"}
    />
    <path
      d="M21.294,13.9l-.444-.256a9.1,9.1,0,0,0,0-3.29l.444-.256a3,3,0,1,0-3-5.2l-.445.257A8.977,8.977,0,0,0,15,3.513V3A3,3,0,0,0,9,3v.513A8.977,8.977,0,0,0,6.152,5.159L5.705,4.9a3,3,0,0,0-3,5.2l.444.256a9.1,9.1,0,0,0,0,3.29l-.444.256a3,3,0,1,0,3,5.2l.445-.257A8.977,8.977,0,0,0,9,20.487V21a3,3,0,0,0,6,0v-.513a8.977,8.977,0,0,0,2.848-1.646l.447.258a3,3,0,0,0,3-5.2Zm-2.548-3.776a7.048,7.048,0,0,1,0,3.75,1,1,0,0,0,.464,1.133l1.084.626a1,1,0,0,1-1,1.733l-1.086-.628a1,1,0,0,0-1.215.165,6.984,6.984,0,0,1-3.243,1.875,1,1,0,0,0-.751.969V21a1,1,0,0,1-2,0V19.748a1,1,0,0,0-.751-.969A6.984,6.984,0,0,1,7.006,16.9a1,1,0,0,0-1.215-.165l-1.084.627a1,1,0,1,1-1-1.732l1.084-.626a1,1,0,0,0,.464-1.133,7.048,7.048,0,0,1,0-3.75A1,1,0,0,0,4.79,8.992L3.706,8.366a1,1,0,0,1,1-1.733l1.086.628A1,1,0,0,0,7.006,7.1a6.984,6.984,0,0,1,3.243-1.875A1,1,0,0,0,11,4.252V3a1,1,0,0,1,2,0V4.252a1,1,0,0,0,.751.969A6.984,6.984,0,0,1,16.994,7.1a1,1,0,0,0,1.215.165l1.084-.627a1,1,0,1,1,1,1.732l-1.084.626A1,1,0,0,0,18.746,10.125Z"
      fill={"#ffffff"}
    />
  </svg>
);

export const UsersSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m107.33,149.33c41.17,0,74.67-33.49,74.67-74.67S148.51,0,107.33,0,32.67,33.49,32.67,74.67s33.49,74.67,74.67,74.67Zm0-106.67c17.64,0,32,14.36,32,32s-14.36,32-32,32-32-14.36-32-32,14.36-32,32-32Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m106.67,208.17c-35.29,0-64,28.71-64,64,0,11.78-9.56,21.33-21.33,21.33S0,283.94,0,272.17c0-58.82,47.85-106.67,106.67-106.67,11.78,0,21.33,9.56,21.33,21.33s-9.56,21.33-21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m232.11,282.41c41.17,0,74.67-33.49,74.67-74.67s-33.49-74.67-74.67-74.67-74.67,33.49-74.67,74.67,33.49,74.67,74.67,74.67Zm0-106.67c17.64,0,32,14.36,32,32s-14.36,32-32,32-32-14.36-32-32,14.36-32,32-32Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m357.45,149.53c41.17,0,74.67-33.49,74.67-74.67S398.63.2,357.45.2s-74.67,33.49-74.67,74.67,33.49,74.67,74.67,74.67Zm0-106.67c17.64,0,32,14.36,32,32s-14.36,32-32,32-32-14.36-32-32,14.36-32,32-32Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m338.12,187.03c0-11.78,9.56-21.33,21.33-21.33,58.82,0,106.67,47.85,106.67,106.67,0,11.78-9.56,21.33-21.33,21.33-11.78,0-21.33-9.56-21.33-21.33,0-35.29-28.71-64-64-64-11.78,0-21.33-9.56-21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m231.05,345.33c-35.29,0-64,28.71-64,64,0,11.78-9.56,21.33-21.33,21.33s-21.33-9.56-21.33-21.33c0-58.82,47.85-106.67,106.67-106.67,11.78,0,21.33,9.56,21.33,21.33s-9.56,21.33-21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m210.71,324.17c0-11.78,9.56-21.33,21.33-21.33,58.82,0,106.67,47.85,106.67,106.67,0,11.78-9.56,21.33-21.33,21.33-11.78,0-21.33-9.56-21.33-21.33,0-35.29-28.71-64-64-64-11.78,0-21.33-9.56-21.33-21.33Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const RolesSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <path
        className="cls-1"
        d="m364.24,320.21c8.33-8.33,8.34-21.83,0-30.17l-44.75-44.75c-8.33-8.33-21.84-8.33-30.17,0-8.33,8.33-8.33,21.84,0,30.17l44.75,44.75c8.34,8.34,21.84,8.33,30.17,0Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m338.03,318.43c8.33,8.33,21.83,8.34,30.17,0l126.27-116.27c8.33-8.33,8.33-21.84,0-30.17s-21.84-8.33-30.17,0l-126.27,116.27c-8.34,8.34-8.33,21.84,0,30.17Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m181.67,43c48.07,0,87.04,38.97,87.04,87.04s-38.97,87.04-87.04,87.04-87.04-38.97-87.04-87.04,38.97-87.04,87.04-87.04m0-43c-34.74,0-67.39,13.53-91.96,38.09-24.56,24.56-38.09,57.22-38.09,91.95s13.53,67.39,38.09,91.95c24.56,24.56,57.22,38.09,91.96,38.09s67.39-13.53,91.95-38.09c24.56-24.56,38.09-57.22,38.09-91.95s-13.53-67.39-38.09-91.95C249.06,13.53,216.41,0,181.67,0h0Z"
        fill={"#ffffff"}
      />
      <path
        className="cls-1"
        d="m21.5,460.91c10.38,0,19.2-7.43,21.15-17.62,12.51-65.38,69.98-114.8,139.01-114.8s126.51,49.41,139.01,114.8c1.95,10.19,10.77,17.62,21.15,17.62h0c13.55,0,23.65-12.36,21.11-25.67-2.42-12.67-6.17-25.05-11.25-37.04-9.3-21.98-22.6-41.71-39.53-58.65-16.93-16.93-36.67-30.24-58.65-39.53-22.78-9.64-46.95-14.52-71.85-14.52s-49.07,4.89-71.85,14.52c-21.98,9.3-41.71,22.6-58.65,39.53-16.93,16.93-30.24,36.67-39.53,58.65-5.07,11.99-8.83,24.38-11.25,37.04-2.54,13.31,7.56,25.67,21.11,25.67h0Z"
        fill={"#ffffff"}
      />
    </g>
  </svg>
);

export const StoresSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <path
        className="cls-1"
        d="m251.88,5.02c29.07,0,58.13-.05,87.2.02,24.4.05,48.8.06,73.2.42,32.88.49,57.79,20.17,65.91,52.13,6.71,26.39,13.96,52.7,19.2,79.39,5.07,25.82-2.27,49.32-18.48,70.09-1.69,2.17-2.89,5.39-2.89,8.12-.16,60.84-.05,121.69-.15,182.53-.07,41.09-27.18,75.21-67.23,84.36-7.26,1.66-14.93,2.1-22.41,2.12-64.05.16-128.11.09-192.16.09-26.37,0-52.74.16-79.1-.04-42.72-.33-76.82-28.07-85.29-69.39-1.25-6.1-1.65-12.46-1.66-18.71-.12-60.13-.02-120.25-.21-180.38,0-3.06-1.33-6.64-3.21-9.08C6.56,183.26.99,157.16,7.8,128.55c5.64-23.71,11.72-47.31,17.8-70.91C33.87,25.49,58.87,5.82,92.02,5.44c19.92-.22,39.84-.04,59.76-.04,33.37,0,66.73,0,100.1,0,0-.13,0-.25,0-.38Zm189.32,229.45c-41.38,12.37-75.69,2.14-102.87-31.18-.29.1-.51.11-.62.22-.96,1.06-1.92,2.12-2.84,3.21-14.1,16.6-31.73,27.88-53.22,31.02-14.62,2.13-29.68,1.9-44.53,1.68-27.54-.4-50.19-11.8-68.27-32.45-1.13-1.29-2.27-2.56-3.3-3.73-27.57,33.47-61.76,43.56-102.93,31.23-.08,1.3-.21,2.52-.21,3.73,0,53.12-.09,106.25.03,159.37.06,27.07,20.16,50.3,45.74,51.73,18.6,1.05,37.3.34,55.96.39.45,0,.91-.41,1.64-.76,0-1.93,0-3.89,0-5.84,0-26.2-.18-52.41.12-78.61.08-7.29.84-14.76,2.61-21.82,10.73-42.76,51.24-69.95,95.25-64.33,41.94,5.35,74.04,42.03,74.28,85.11.15,26.74.03,53.48.03,80.22,0,1.91,0,3.83,0,6.15,14.47,0,28.26.09,42.05-.04,6.44-.06,13.03.22,19.3-.97,24.98-4.76,41.93-25.55,41.98-51.3.12-52.94.04-105.89.03-158.83,0-1.39-.14-2.77-.22-4.22ZM181.88,40.15c0,2.03,0,3.77,0,5.52,0,34.25-.03,68.51.02,102.76.03,25.6,17.11,48.84,42.16,54.24,12.93,2.79,26.68,2.4,40.05,2.33,33.15-.15,57.75-25.38,57.79-58.63.05-33.54.02-67.07.02-100.61,0-1.88,0-3.75,0-5.61h-140.05Zm-34.94.24c-1.37-.25-2.06-.49-2.75-.49-18.12,0-36.25-.25-54.37.11-15.05.3-26.79,10.08-30.57,24.93-5.92,23.27-11.61,46.59-17.46,69.88-5.49,21.83-.9,40.63,15.87,56.32,14.74,13.8,37.79,17.99,57.14,9.71,19.2-8.22,32.33-27.55,32.3-47.56-.05-35.53-.11-71.07-.16-106.6,0-2.1,0-4.2,0-6.3Zm209.97-.53c-.13,1.81-.25,2.68-.26,3.56-.05,36.23-.21,72.46,0,108.68.03,5.46,1.08,11.12,2.77,16.32,8.88,27.38,37.63,42.54,65.21,34.7,28.68-8.15,45.19-36.59,38.04-66-5.84-24.01-11.92-47.96-18.02-71.91-3.96-15.55-15.89-24.97-31.94-25.32-8.42-.18-16.86-.04-25.28-.05-10.02,0-20.03,0-30.51,0Zm-53.45,409.72c0-30.43.36-60.19-.17-89.93-.22-12.38-5.79-23.18-14.53-32.1-14.59-14.89-36.54-19.44-56.06-11.71-19.11,7.57-32.19,26.02-32.38,46.67-.26,27.98-.09,55.96-.07,83.94,0,1.02.29,2.04.45,3.14h102.76Zm1.15-444.59c11.49,0,22.98,0,34.47.03,24.4.05,48.8.06,73.2.42,32.88.49,57.79,20.17,65.91,52.13,6.71,26.39,13.96,52.7,19.2,79.39,5.07,25.82-2.27,49.32-18.48,70.09-1.69,2.17-2.89,5.39-2.89,8.12-.16,60.84-.05,121.69-.15,182.53-.07,41.08-27.18,75.21-67.23,84.36-7.26,1.66-14.93,2.1-22.41,2.12-34.58.09-69.17.11-103.75.11-29.47,0-58.94-.01-88.41-.01-16.25,0-32.49.06-48.74.06-10.12,0-20.24-.02-30.36-.1-42.72-.33-76.82-28.07-85.29-69.39-1.25-6.1-1.65-12.46-1.66-18.71-.12-60.13-.02-120.25-.21-180.38,0-3.06-1.33-6.64-3.21-9.08C6.56,183.26.99,157.16,7.8,128.55c5.64-23.71,11.72-47.31,17.8-70.91C33.87,25.49,58.87,5.82,92.02,5.44c7.65-.09,15.31-.11,22.97-.11,12.24,0,24.49.07,36.73.07h.06c13.06,0,26.11,0,39.17,0,20.31,0,40.62,0,60.93,0,0-.13,0-.25,0-.38,17.58,0,35.15-.02,52.73-.02m83,34.86c-.06,0-.13,0-.19,0-3.93,0-7.86,0-11.82,0-6.13,0-12.33,0-18.69,0-.13,1.81-.25,2.68-.26,3.56-.05,36.23-.21,72.46,0,108.68.03,5.46,1.08,11.12,2.77,16.33,7.3,22.51,28.04,36.76,50.51,36.76,4.86,0,9.8-.67,14.7-2.06,28.68-8.15,45.19-36.59,38.04-66-5.84-24.01-11.92-47.96-18.02-71.91-3.96-15.55-15.89-24.97-31.94-25.32-3.34-.07-6.69-.09-10.03-.09-5.02,0-10.04.05-15.07.05M93.9,205.09c7.08,0,14.21-1.37,20.89-4.23,19.2-8.22,32.33-27.55,32.3-47.56-.05-35.53-.11-71.07-.16-106.6,0-2.1,0-4.2,0-6.3-1.37-.25-2.06-.49-2.75-.49-10.46,0-20.92-.09-31.38-.09-7.67,0-15.33.04-22.99.2-15.05.3-26.79,10.08-30.57,24.93-5.92,23.27-11.61,46.59-17.46,69.88-5.49,21.83-.9,40.63,15.87,56.32,9.65,9.03,22.85,13.94,36.25,13.94m159.86-.04c3.46,0,6.91-.04,10.35-.05,33.15-.15,57.75-25.38,57.79-58.63.05-33.54.02-67.07.02-100.61,0-1.88,0-3.75,0-5.61h-140.05c0,2.03,0,3.77,0,5.52,0,34.25-.03,68.51.02,102.76.03,25.6,17.11,48.84,42.16,54.24,9.61,2.07,19.68,2.39,29.71,2.39m-158.94,34.48c-10.22,0-20.95-1.69-32.21-5.06-.08,1.3-.21,2.52-.21,3.73,0,53.12-.09,106.25.03,159.37.06,27.07,20.16,50.3,45.74,51.73,8.06.45,16.13.58,24.21.58,10.01,0,20.03-.19,30.04-.19.57,0,1.14,0,1.71,0,0,0,0,0,0,0,.45,0,.91-.41,1.64-.76v-5.84c0-26.2-.18-52.41.12-78.61.08-7.29.84-14.76,2.61-21.82,9.79-39.01,44.36-65.06,83.77-65.06,3.79,0,7.62.24,11.48.73,41.94,5.35,74.04,42.03,74.28,85.11.15,26.74.03,53.48.03,80.22,0,1.91,0,3.83,0,6.15,8.41,0,16.59.03,24.67.03,5.83,0,11.61-.02,17.39-.07.88,0,1.77-.01,2.65-.01.68,0,1.35,0,2.03,0,4.92,0,9.86-.05,14.62-.96,24.98-4.76,41.93-25.55,41.98-51.3.12-52.94.04-105.89.03-158.83,0-1.39-.14-2.77-.22-4.22-11.29,3.37-22.06,5.07-32.3,5.07-27.28,0-50.81-12.02-70.58-36.25-.29.1-.51.11-.62.22-.96,1.06-1.92,2.12-2.84,3.21-14.1,16.6-31.73,27.88-53.22,31.02-10.09,1.47-20.4,1.82-30.69,1.82-4.62,0-9.24-.07-13.84-.14-27.54-.4-50.19-11.8-68.27-32.45-1.13-1.29-2.27-2.56-3.3-3.73-20.03,24.32-43.56,36.3-70.73,36.3m105.88,210.05h102.76c0-30.43.36-60.19-.17-89.93-.22-12.38-5.79-23.18-14.53-32.1-9.88-10.08-23.13-15.42-36.72-15.42-6.48,0-13.04,1.22-19.34,3.71-19.11,7.57-32.19,26.02-32.38,46.67-.26,27.98-.09,55.96-.07,83.94,0,1.02.29,2.04.45,3.14M304.61,0c-8.79,0-17.58,0-26.37,0-8.79,0-17.58,0-26.36,0h-4.99v.38s-25.47,0-25.47,0h-30.47s-39.17,0-39.17,0h-.06c-6.12,0-12.23-.02-18.35-.03-6.13-.02-12.25-.03-18.38-.03-8.86,0-16.18.04-23.02.11-17.37.2-33.13,5.47-45.58,15.25-12.43,9.77-21.3,23.85-25.64,40.7l-.25.98c-5.9,22.91-11.99,46.6-17.57,70.02-7.16,30.08-1.21,57.79,17.69,82.36,1.25,1.63,2.17,4.17,2.17,6.04.1,34.03.12,68.64.13,102.11.01,25.65.02,52.17.07,78.26.01,7.53.59,13.98,1.76,19.7,8.92,43.55,45.15,73.04,90.15,73.39,9.05.07,18.71.1,30.4.1,8.12,0,16.24-.02,24.36-.03,8.13-.02,16.25-.03,24.38-.03,14.66,0,29.31,0,43.96,0,14.81,0,29.63,0,44.44,0,28.49,0,66.03-.01,103.77-.11,9.43-.02,16.9-.74,23.51-2.25,20.76-4.74,38.53-15.8,51.41-31.97,12.86-16.15,19.68-35.95,19.71-57.26.05-27.13.05-54.71.05-81.39,0-33.15,0-67.43.1-101.14,0-1.55.79-3.72,1.83-5.06,18.03-23.09,24.57-48.03,19.45-74.13-4.16-21.19-9.65-42.42-14.96-62.95-1.42-5.48-2.88-11.15-4.3-16.72-4.26-16.75-13.05-30.78-25.42-40.56-12.37-9.78-28.02-15.09-45.27-15.34-21.37-.32-43.09-.36-64.09-.4l-9.18-.02c-10.22-.02-21.18-.03-34.48-.03h0Zm82.81,44.86h.19c2.52,0,5.04-.01,7.56-.02,2.5-.01,5.01-.02,7.51-.02,3.84,0,6.99.03,9.92.09,13.87.3,23.78,8.16,27.2,21.56,5.88,23.06,12.11,47.6,18.01,71.85,6.51,26.76-8.34,52.56-34.55,60.01-4.36,1.24-8.85,1.87-13.33,1.87-20.91,0-39.29-13.38-45.75-33.3-1.63-5.02-2.5-10.14-2.53-14.81-.15-27.93-.1-56.33-.04-83.8.02-7.81.03-15.61.04-23.42h4.78s9.17,0,9.17,0h11.82ZM93.9,200.09c-12.31,0-24.28-4.59-32.83-12.6-14.91-13.95-19.63-30.78-14.44-51.45,2.43-9.67,4.87-19.5,7.23-29.01,3.33-13.4,6.76-27.26,10.23-40.85,3.26-12.8,13.16-20.91,25.83-21.17,6.71-.14,13.99-.2,22.89-.2,5.31,0,10.63.02,15.94.04,4.4.02,8.79.04,13.19.04,0,.6,0,1.2,0,1.8l.16,106.6c.03,17.91-12.01,35.57-29.27,42.96-5.94,2.54-12.31,3.83-18.93,3.83h0ZM186.88,45.15h130.05v.61c0,10.2,0,20.39,0,30.59,0,22.95,0,46.68-.03,70.01-.04,30.44-22.75,53.5-52.82,53.63-1.26,0-2.52.01-3.78.02-2.18.01-4.36.03-6.54.03-9.4,0-19.38-.28-28.65-2.27-22.11-4.77-38.19-25.52-38.22-49.35-.03-23.97-.03-48.34-.02-71.91,0-10.28,0-20.56,0-30.84v-.52h0Zm64.08,199.41c8.67,0,20.07-.21,31.42-1.87,21.3-3.11,40.04-13.87,55.69-32,19.91,22.47,43.72,33.85,70.85,33.85,8.77,0,18-1.2,27.51-3.57,0,12.97,0,25.93.02,38.9.02,38.56.04,78.44-.05,117.65-.05,23.44-15.29,42.08-37.92,46.4-4.24.81-8.7.87-13.68.87h-1.01s-1.02,0-1.02,0c-.9,0-1.8,0-2.7.01-5.07.05-10.58.07-17.34.07-4,0-8.02,0-12.08-.01-2.51,0-5.04,0-7.59-.01v-1.15c0-8.28.01-16.55.02-24.83.02-18.16.05-36.95-.06-55.43-.13-22.02-8.2-43.32-22.74-59.96-14.54-16.65-34.4-27.33-55.91-30.08-4.02-.51-8.09-.77-12.11-.77-20.27,0-40.18,6.73-56.04,18.94-16.26,12.52-27.53,29.78-32.58,49.9-1.73,6.91-2.66,14.64-2.76,22.97-.22,19.05-.18,38.4-.15,57.11.01,7.18.03,14.37.03,21.55v1.59c-4.49,0-9.02.05-13.42.09-4.91.05-9.99.1-14.97.1-9.41,0-17.01-.18-23.93-.57-22.56-1.27-40.96-22.24-41.02-46.75-.09-39.1-.07-78.86-.05-117.31,0-13.1.01-26.19.02-39.29,9.49,2.37,18.68,3.57,27.42,3.57,26.93,0,50.72-11.33,70.78-33.69,19.39,21.87,43.43,33.17,71.45,33.58h.37c4.43.07,9.01.14,13.54.14h0Zm-45.71,200.03c0-6.89-.02-13.78-.03-20.66-.04-20.12-.08-40.92.11-61.37.17-18.3,11.91-35.21,29.22-42.06,5.63-2.23,11.52-3.36,17.5-3.36,12.58,0,24.35,4.94,33.15,13.92,8.5,8.68,12.91,18.33,13.1,28.7.38,21.1.31,41.75.23,63.61-.02,6.95-.05,14.09-.06,21.23h-93.22Z"
        fill={"#ffffff"}
      />
    </g>
  </svg>
);

export const WorkflowSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <path
          className="cls-1"
          d="m96.33,0h-11C38.21,0,0,38.21,0,85.33v14c0,47.13,38.21,85.33,85.33,85.33h11c47.13,0,85.33-38.21,85.33-85.33v-14C181.67,38.21,143.46,0,96.33,0Zm42.67,99.33c0,23.56-19.1,42.67-42.67,42.67h-11c-23.56,0-42.67-19.1-42.67-42.67v-14c0-23.56,19.1-42.67,42.67-42.67h11c23.56,0,42.67,19.1,42.67,42.67v14Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m422.24,323.21h-11c-47.13,0-85.33,38.21-85.33,85.33v14c0,47.13,38.21,85.33,85.33,85.33h11c47.13,0,85.33-38.21,85.33-85.33v-14c0-47.13-38.21-85.33-85.33-85.33Zm42.67,99.33c0,23.56-19.1,42.67-42.67,42.67h-11c-23.56,0-42.67-19.1-42.67-42.67v-14c0-23.56,19.1-42.67,42.67-42.67h11c23.56,0,42.67,19.1,42.67,42.67v14Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m247.33,172.77h-11c-47.13,0-85.33,38.21-85.33,85.33v14c0,47.13,38.21,85.33,85.33,85.33h11c47.13,0,85.33-38.21,85.33-85.33v-14c0-47.13-38.21-85.33-85.33-85.33Zm42.67,99.33c0,23.56-19.1,42.67-42.67,42.67h-11c-23.56,0-42.67-19.1-42.67-42.67v-14c0-23.56,19.1-42.67,42.67-42.67h11c23.56,0,42.67,19.1,42.67,42.67v14Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m494.65,85.74c0-11.78-9.54-21.33-21.33-21.33H180.31c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h293c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m191.89,254.94c0-11.78-9.54-21.33-21.33-21.33H31.55c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h139c11.8,0,21.33-9.56,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m473.31,276.43c11.78,0,21.33-9.54,21.33-21.33V86.1c0-11.78-9.56-21.33-21.33-21.33s-21.33,9.56-21.33,21.33v169c0,11.8,9.56,21.33,21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m360.13,255.28c0,11.78,9.54,21.33,21.33,21.33h92c11.78,0,21.33-9.56,21.33-21.33s-9.56-21.33-21.33-21.33h-92c-11.8,0-21.33,9.56-21.33,21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m364.42,242.59c-7.24,9.29-5.6,22.69,3.7,29.94l33.12,25.83c9.29,7.24,22.7,5.58,29.94-3.7,7.24-9.29,5.58-22.7-3.7-29.94l-33.12-25.83c-9.3-7.25-22.7-5.58-29.94,3.7Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m401.24,212.88l-33.12,25.83c-9.29,7.24-10.95,20.66-3.7,29.94s20.66,10.95,29.94,3.7l33.12-25.83c9.3-7.25,10.95-20.66,3.7-29.94s-20.64-10.96-29.94-3.7Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m53.04,433.73v-179c0-11.78-9.56-21.33-21.33-21.33-11.78,0-21.33,9.56-21.33,21.33v179c0,11.8,9.56,21.33,21.33,21.33,11.78,0,21.33-9.54,21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m276.55,412.57H31.55c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h245c11.8,0,21.33-9.56,21.33-21.33,0-11.78-9.54-21.33-21.33-21.33Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m263.66,417.51l-33.12,25.83c-9.29,7.24-10.95,20.66-3.7,29.94,7.24,9.29,20.66,10.95,29.94,3.7l33.12-25.83c9.3-7.25,10.95-20.66,3.7-29.94-7.24-9.29-20.64-10.96-29.94-3.7Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m226.84,395.21c-7.24,9.29-5.6,22.69,3.7,29.94l33.12,25.83c9.29,7.24,22.7,5.58,29.94-3.7,7.24-9.29,5.58-22.7-3.7-29.94l-33.12-25.83c-9.3-7.25-22.7-5.58-29.94,3.7Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const WorkflowStatesSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <g>
          <path
            className="cls-1"
            d="m96.33,0h-11C38.21,0,0,38.21,0,85.33v14c0,47.13,38.21,85.33,85.33,85.33h11c47.13,0,85.33-38.21,85.33-85.33v-14C181.67,38.21,143.46,0,96.33,0Zm42.67,99.33c0,23.56-19.1,42.67-42.67,42.67h-11c-23.56,0-42.67-19.1-42.67-42.67v-14c0-23.56,19.1-42.67,42.67-42.67h11c23.56,0,42.67,19.1,42.67,42.67v14Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m422.24,323.21h-11c-47.13,0-85.33,38.21-85.33,85.33v14c0,47.13,38.21,85.33,85.33,85.33h11c47.13,0,85.33-38.21,85.33-85.33v-14c0-47.13-38.21-85.33-85.33-85.33Zm42.67,99.33c0,23.56-19.1,42.67-42.67,42.67h-11c-23.56,0-42.67-19.1-42.67-42.67v-14c0-23.56,19.1-42.67,42.67-42.67h11c23.56,0,42.67,19.1,42.67,42.67v14Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m247.33,172.77h-11c-47.13,0-85.33,38.21-85.33,85.33v14c0,47.13,38.21,85.33,85.33,85.33h11c47.13,0,85.33-38.21,85.33-85.33v-14c0-47.13-38.21-85.33-85.33-85.33Zm42.67,99.33c0,23.56-19.1,42.67-42.67,42.67h-11c-23.56,0-42.67-19.1-42.67-42.67v-14c0-23.56,19.1-42.67,42.67-42.67h11c23.56,0,42.67,19.1,42.67,42.67v14Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m494.65,85.74c0-11.78-9.54-21.33-21.33-21.33H180.31c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h293c11.8,0,21.33-9.56,21.33-21.33Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m191.89,254.94c0-11.78-9.54-21.33-21.33-21.33H31.55c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h139c11.8,0,21.33-9.56,21.33-21.33Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m473.31,276.43c11.78,0,21.33-9.54,21.33-21.33V86.1c0-11.78-9.56-21.33-21.33-21.33s-21.33,9.56-21.33,21.33v169c0,11.8,9.56,21.33,21.33,21.33Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m360.13,255.28c0,11.78,9.54,21.33,21.33,21.33h92c11.78,0,21.33-9.56,21.33-21.33s-9.56-21.33-21.33-21.33h-92c-11.8,0-21.33,9.56-21.33,21.33Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m364.42,242.59c-7.24,9.29-5.6,22.69,3.7,29.94l33.12,25.83c9.29,7.24,22.7,5.58,29.94-3.7,7.24-9.29,5.58-22.7-3.7-29.94l-33.12-25.83c-9.3-7.25-22.7-5.58-29.94,3.7Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m401.24,212.88l-33.12,25.83c-9.29,7.24-10.95,20.66-3.7,29.94s20.66,10.95,29.94,3.7l33.12-25.83c9.3-7.25,10.95-20.66,3.7-29.94s-20.64-10.96-29.94-3.7Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m53.04,433.73v-179c0-11.78-9.56-21.33-21.33-21.33-11.78,0-21.33,9.56-21.33,21.33v179c0,11.8,9.56,21.33,21.33,21.33,11.78,0,21.33-9.54,21.33-21.33Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m276.55,412.57H31.55c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h245c11.8,0,21.33-9.56,21.33-21.33,0-11.78-9.54-21.33-21.33-21.33Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m263.66,417.51l-33.12,25.83c-9.29,7.24-10.95,20.66-3.7,29.94,7.24,9.29,20.66,10.95,29.94,3.7l33.12-25.83c9.3-7.25,10.95-20.66,3.7-29.94s-20.64-10.96-29.94-3.7Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m226.84,395.21c-7.24,9.29-5.6,22.69,3.7,29.94l33.12,25.83c9.29,7.24,22.7,5.58,29.94-3.7,7.24-9.29,5.58-22.7-3.7-29.94l-33.12-25.83c-9.3-7.25-22.7-5.58-29.94,3.7Z"
            fill={"#ffffff"}
          />
        </g>
        <path
          className="cls-1"
          d="m106.11,75.31l-18.97,18.97c-.66.67-1.74.69-2.44.05l-9.41-8.63c-3.47-3.18-8.86-2.94-12.04.53-3.18,3.47-2.95,8.86.53,12.04l9.41,8.63c3.61,3.31,8.16,4.96,12.7,4.96,4.81,0,9.62-1.86,13.29-5.52l18.97-18.97c3.33-3.33,3.33-8.71,0-12.05s-8.71-3.33-12.05,0h0Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m257.11,251.59l-18.97,18.97c-.66.67-1.74.69-2.44.05l-9.41-8.63c-3.47-3.18-8.86-2.94-12.04.53-3.18,3.47-2.95,8.86.53,12.04l9.41,8.63c3.61,3.31,8.16,4.96,12.7,4.96,4.81,0,9.62-1.86,13.29-5.52l18.97-18.97c3.33-3.33,3.33-8.71,0-12.05-3.33-3.33-8.71-3.33-12.05,0h0Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m432.02,404.21l-18.97,18.97c-.66.67-1.74.69-2.44.05l-9.41-8.63c-3.47-3.18-8.86-2.94-12.04.53-3.18,3.47-2.95,8.86.53,12.04l9.41,8.63c3.61,3.31,8.16,4.96,12.7,4.96,4.81,0,9.62-1.86,13.29-5.52l18.97-18.97c3.33-3.33,3.33-8.71,0-12.05s-8.71-3.33-12.05,0h0Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);

export const WorkflowActionsSVG = ({ width, height }: any) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
  >
    <g id="Outline">
      <g>
        <g>
          <g>
            <path
              className="cls-1"
              d="m96.33,0h-11C38.21,0,0,38.21,0,85.33v14c0,47.13,38.21,85.33,85.33,85.33h11c47.13,0,85.33-38.21,85.33-85.33v-14C181.67,38.21,143.46,0,96.33,0Zm42.67,99.33c0,23.56-19.1,42.67-42.67,42.67h-11c-23.56,0-42.67-19.1-42.67-42.67v-14c0-23.56,19.1-42.67,42.67-42.67h11c23.56,0,42.67,19.1,42.67,42.67v14Z"
              fill={"#ffffff"}
            />
            <path
              className="cls-1"
              d="m422.24,323.21h-11c-47.13,0-85.33,38.21-85.33,85.33v14c0,47.13,38.21,85.33,85.33,85.33h11c47.13,0,85.33-38.21,85.33-85.33v-14c0-47.13-38.21-85.33-85.33-85.33Zm42.67,99.33c0,23.56-19.1,42.67-42.67,42.67h-11c-23.56,0-42.67-19.1-42.67-42.67v-14c0-23.56,19.1-42.67,42.67-42.67h11c23.56,0,42.67,19.1,42.67,42.67v14Z"
              fill={"#ffffff"}
            />
            <path
              className="cls-1"
              d="m247.33,172.77h-11c-47.13,0-85.33,38.21-85.33,85.33v14c0,47.13,38.21,85.33,85.33,85.33h11c47.13,0,85.33-38.21,85.33-85.33v-14c0-47.13-38.21-85.33-85.33-85.33Zm42.67,99.33c0,23.56-19.1,42.67-42.67,42.67h-11c-23.56,0-42.67-19.1-42.67-42.67v-14c0-23.56,19.1-42.67,42.67-42.67h11c23.56,0,42.67,19.1,42.67,42.67v14Z"
              fill={"#ffffff"}
            />
            <path
              className="cls-1"
              d="m494.65,85.74c0-11.78-9.54-21.33-21.33-21.33H180.31c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h293c11.8,0,21.33-9.56,21.33-21.33Z"
              fill={"#ffffff"}
            />
            <path
              className="cls-1"
              d="m191.89,254.94c0-11.78-9.54-21.33-21.33-21.33H31.55c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h139c11.8,0,21.33-9.56,21.33-21.33Z"
              fill={"#ffffff"}
            />
            <path
              className="cls-1"
              d="m473.31,276.43c11.78,0,21.33-9.54,21.33-21.33V86.1c0-11.78-9.56-21.33-21.33-21.33s-21.33,9.56-21.33,21.33v169c0,11.8,9.56,21.33,21.33,21.33Z"
              fill={"#ffffff"}
            />
            <path
              className="cls-1"
              d="m360.13,255.28c0,11.78,9.54,21.33,21.33,21.33h92c11.78,0,21.33-9.56,21.33-21.33s-9.56-21.33-21.33-21.33h-92c-11.8,0-21.33,9.56-21.33,21.33Z"
              fill={"#ffffff"}
            />
            <path
              className="cls-1"
              d="m364.42,242.59c-7.24,9.29-5.6,22.69,3.7,29.94l33.12,25.83c9.29,7.24,22.7,5.58,29.94-3.7,7.24-9.29,5.58-22.7-3.7-29.94l-33.12-25.83c-9.3-7.25-22.7-5.58-29.94,3.7Z"
              fill={"#ffffff"}
            />
            <path
              className="cls-1"
              d="m401.24,212.88l-33.12,25.83c-9.29,7.24-10.95,20.66-3.7,29.94s20.66,10.95,29.94,3.7l33.12-25.83c9.3-7.25,10.95-20.66,3.7-29.94s-20.64-10.96-29.94-3.7Z"
              fill={"#ffffff"}
            />
            <path
              className="cls-1"
              d="m53.04,433.73v-179c0-11.78-9.56-21.33-21.33-21.33-11.78,0-21.33,9.56-21.33,21.33v179c0,11.8,9.56,21.33,21.33,21.33,11.78,0,21.33-9.54,21.33-21.33Z"
              fill={"#ffffff"}
            />
            <path
              className="cls-1"
              d="m276.55,412.57H31.55c-11.78,0-21.33,9.56-21.33,21.33s9.56,21.33,21.33,21.33h245c11.8,0,21.33-9.56,21.33-21.33,0-11.78-9.54-21.33-21.33-21.33Z"
              fill={"#ffffff"}
            />
            <path
              className="cls-1"
              d="m263.66,417.51l-33.12,25.83c-9.29,7.24-10.95,20.66-3.7,29.94,7.24,9.29,20.66,10.95,29.94,3.7l33.12-25.83c9.3-7.25,10.95-20.66,3.7-29.94s-20.64-10.96-29.94-3.7Z"
              fill={"#ffffff"}
            />
            <path
              className="cls-1"
              d="m226.84,395.21c-7.24,9.29-5.6,22.69,3.7,29.94l33.12,25.83c9.29,7.24,22.7,5.58,29.94-3.7,7.24-9.29,5.58-22.7-3.7-29.94l-33.12-25.83c-9.3-7.25-22.7-5.58-29.94,3.7Z"
              fill={"#ffffff"}
            />
          </g>
          <path
            className="cls-1"
            d="m106.11,75.31l-18.97,18.97c-.66.67-1.74.69-2.44.05l-9.41-8.63c-3.47-3.18-8.86-2.94-12.04.53-3.18,3.47-2.95,8.86.53,12.04l9.41,8.63c3.61,3.31,8.16,4.96,12.7,4.96,4.81,0,9.62-1.86,13.29-5.52l18.97-18.97c3.33-3.33,3.33-8.71,0-12.05s-8.71-3.33-12.05,0h0Z"
            fill={"#ffffff"}
          />
          <path
            className="cls-1"
            d="m257.11,251.59l-18.97,18.97c-.66.67-1.74.69-2.44.05l-9.41-8.63c-3.47-3.18-8.86-2.94-12.04.53-3.18,3.47-2.95,8.86.53,12.04l9.41,8.63c3.61,3.31,8.16,4.96,12.7,4.96,4.81,0,9.62-1.86,13.29-5.52l18.97-18.97c3.33-3.33,3.33-8.71,0-12.05-3.33-3.33-8.71-3.33-12.05,0h0Z"
            fill={"#ffffff"}
          />
        </g>
        <path
          className="cls-1"
          d="m435.47,398.05c-3.28-3.28-8.59-3.28-11.87,0l-25.59,25.59c-3.28,3.28-3.28,8.59,0,11.87,3.28,3.28,8.59,3.28,11.87,0l25.59-25.59c3.28-3.28,3.28-8.59,0-11.87Z"
          fill={"#ffffff"}
        />
        <path
          className="cls-1"
          d="m398.01,409.92l25.59,25.59c3.28,3.28,8.59,3.28,11.87,0,3.28-3.28,3.28-8.59,0-11.87l-25.59-25.59c-3.28-3.28-8.59-3.28-11.87,0s-3.28,8.59,0,11.87Z"
          fill={"#ffffff"}
        />
      </g>
    </g>
  </svg>
);
